import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ApiToken = {
  __typename?: 'APIToken';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  ttype: ApiTokenTtype;
};

/** Autogenerated return type of APITokenCreate. */
export type ApiTokenCreatePayload = {
  __typename?: 'APITokenCreatePayload';
  apiToken?: Maybe<ApiToken>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of APITokenDeactivate. */
export type ApiTokenDeactivatePayload = {
  __typename?: 'APITokenDeactivatePayload';
  ok: Scalars['Boolean']['output'];
};

export enum ApiTokenTtype {
  /** Commerce */
  Commerce = 'commerce',
  /** Salesforce */
  Salesforce = 'salesforce',
  /** User */
  User = 'user'
}

/** Autogenerated return type of AcceptInvite. */
export type AcceptInvitePayload = {
  __typename?: 'AcceptInvitePayload';
  error?: Maybe<Scalars['String']['output']>;
  joinedWorkspace?: Maybe<Workspace>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of AcceptanceRecentlyViewedProductsFetch. */
export type AcceptanceRecentlyViewedProductsFetchPayload = {
  __typename?: 'AcceptanceRecentlyViewedProductsFetchPayload';
  products?: Maybe<Array<Product>>;
};

export type AcceptanceRecommendation = {
  __typename?: 'AcceptanceRecommendation';
  id: Scalars['ID']['output'];
  product: Product;
};

/** Autogenerated return type of AcceptanceRecommendationsFetch. */
export type AcceptanceRecommendationsFetchPayload = {
  __typename?: 'AcceptanceRecommendationsFetchPayload';
  id?: Maybe<Scalars['ID']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  recommendationModel?: Maybe<Scalars['String']['output']>;
  recommendationModelToken?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Array<AcceptanceRecommendation>>;
  seenProductIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated return type of AcceptanceRecommendationsGenerateTopics. */
export type AcceptanceRecommendationsGenerateTopicsPayload = {
  __typename?: 'AcceptanceRecommendationsGenerateTopicsPayload';
  topics: Array<Scalars['String']['output']>;
};

export type AcceptanceStoreEventPayloadInput = {
  acceptanceRecommendationGroupId?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  eventValue?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  impressions?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  recommendationModelToken?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcceptanceStoreEventRecord. */
export type AcceptanceStoreEventRecordPayload = {
  __typename?: 'AcceptanceStoreEventRecordPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of AccessRequestCreate. */
export type AccessRequestCreatePayload = {
  __typename?: 'AccessRequestCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/** Information about AI Chat usage */
export type AiChatInfoInput = {
  generatedMessage: Scalars['String']['input'];
  initialPrompt?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
  userMessageCount?: InputMaybe<Scalars['Int']['input']>;
};

export type AiChatThread = {
  __typename?: 'AiChatThread';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Attribution = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  firstPartyCampaign?: InputMaybe<Scalars['String']['input']>;
  firstPartyInfo?: InputMaybe<Scalars['String']['input']>;
  firstPartySource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceGiftTrackId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AuthLogin. */
export type AuthLoginPayload = {
  __typename?: 'AuthLoginPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  requireSsoEmail?: Maybe<Scalars['String']['output']>;
  requireSsoError?: Maybe<Scalars['String']['output']>;
  requireSsoSetting?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of AuthLogout. */
export type AuthLogoutPayload = {
  __typename?: 'AuthLogoutPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of AuthSignUp. */
export type AuthSignUpPayload = {
  __typename?: 'AuthSignUpPayload';
  error?: Maybe<Scalars['String']['output']>;
  errorIsEmail?: Maybe<Scalars['Boolean']['output']>;
  errorIsFirstName?: Maybe<Scalars['Boolean']['output']>;
  errorIsLastName?: Maybe<Scalars['Boolean']['output']>;
  errorIsPassword?: Maybe<Scalars['Boolean']['output']>;
  errorIsPhone?: Maybe<Scalars['Boolean']['output']>;
  errorIsUsername?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of AuthUnlinkOpenid. */
export type AuthUnlinkOpenidPayload = {
  __typename?: 'AuthUnlinkOpenidPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of AuthVerify. */
export type AuthVerifyPayload = {
  __typename?: 'AuthVerifyPayload';
  error?: Maybe<Scalars['String']['output']>;
  errorIsAccount?: Maybe<Scalars['Boolean']['output']>;
  errorIsVerify?: Maybe<Scalars['Boolean']['output']>;
  newUser?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Author = {
  __typename?: 'Author';
  bio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<AuthorSocialLinks>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AuthorSocialLinks = {
  __typename?: 'AuthorSocialLinks';
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type AutogiftRule = {
  __typename?: 'AutogiftRule';
  anchorDateNumberOfDaysDelta?: Maybe<Scalars['Int']['output']>;
  anchorDateSendOption?: Maybe<AutogiftRuleAnchorDateSendOptionEnum>;
  anchorDateType?: Maybe<AutogiftRuleAnchorDateTypeEnum>;
  autopayPaymentMethodId?: Maybe<Scalars['String']['output']>;
  autopayPaymentMethodName?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Card>;
  cart?: Maybe<Array<CartProduct>>;
  contactList: ContactList;
  contactsWithEventToday: Array<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  expireAtOption?: Maybe<Scalars['String']['output']>;
  firstGiftSummary?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internationalShippingTier: InternationalShippingTierEnum;
  message?: Maybe<Scalars['String']['output']>;
  products: Array<ProductFragment>;
  settings: GiftsSettings;
  status: AutogiftRuleStatus;
  swapEnabled?: Maybe<Scalars['Boolean']['output']>;
  swapType?: Maybe<GiftSwapTypeEnum>;
  tenureMax?: Maybe<Scalars['Int']['output']>;
  tenureMin?: Maybe<Scalars['Int']['output']>;
  userPublicId: Scalars['ID']['output'];
};

export enum AutogiftRuleAnchorDateSendOptionEnum {
  SendAfterAnchorDate = 'send_after_anchor_date',
  SendBeforeAnchorDate = 'send_before_anchor_date',
  SendOnAnchorDate = 'send_on_anchor_date'
}

export enum AutogiftRuleAnchorDateTypeEnum {
  AddedToHrisDate = 'added_to_hris_date',
  StartDate = 'start_date'
}

/** Data needed to create an autogift_rule */
export type AutogiftRuleInput = {
  alcoholAgeVerificationAttested?: InputMaybe<Scalars['Boolean']['input']>;
  anchorDateNumberOfDaysDelta?: InputMaybe<Scalars['Int']['input']>;
  anchorDateSendOption?: InputMaybe<AutogiftRuleAnchorDateSendOptionEnum>;
  anchorDateType?: InputMaybe<AutogiftRuleAnchorDateTypeEnum>;
  autopayPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  autopayPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cart?: InputMaybe<Array<CartProductInput>>;
  contactListId?: InputMaybe<Scalars['ID']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  expireAtOption?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  maximumProductPrice?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<GiftsSettingsInput>;
  status: AutogiftRuleStatus;
  swapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  swapType?: InputMaybe<GiftSwapTypeEnum>;
  tenureMax?: InputMaybe<Scalars['Int']['input']>;
  tenureMin?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AutogiftRulePause. */
export type AutogiftRulePausePayload = {
  __typename?: 'AutogiftRulePausePayload';
  autogiftRule?: Maybe<AutogiftRule>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export enum AutogiftRuleStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Paused */
  Paused = 'PAUSED'
}

/** Autogenerated return type of AutogiftRuleUpdate. */
export type AutogiftRuleUpdatePayload = {
  __typename?: 'AutogiftRuleUpdatePayload';
  autogiftRule?: Maybe<AutogiftRule>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export type BalanceAccount = {
  __typename?: 'BalanceAccount';
  activity: BalanceActivity;
  balance: Scalars['Int']['output'];
  balanceExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  balanceTransactionReports?: Maybe<Array<BalanceTransactionReport>>;
  id: Scalars['ID']['output'];
  organizationBudgetRule?: Maybe<BudgetRule>;
  organizationMembership?: Maybe<OrganizationMembership>;
  ownerType: BalanceAccountOwner;
  transactions: BalanceTransactionSeries;
  workspace?: Maybe<Workspace>;
};


export type BalanceAccountActivityArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type BalanceAccountTransactionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BalanceAccountOwner {
  /** ORGANIZATION */
  Organization = 'organization',
  /** USER */
  User = 'user',
  /** WORKSPACE */
  Workspace = 'workspace'
}

export type BalanceActivity = {
  __typename?: 'BalanceActivity';
  balanceGiftBatches: Array<BalanceGiftBatch>;
};

export type BalanceDeposit = {
  __typename?: 'BalanceDeposit';
  amount: Scalars['Int']['output'];
  bundledReceiptItem?: Maybe<BundledReceiptItem>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export enum BalanceDepositAccount {
  Organization = 'organization',
  User = 'user',
  Workspace = 'workspace'
}

export enum BalanceDepositFundingMethod {
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** Invoice */
  Invoice = 'INVOICE'
}

/** Autogenerated return type of BalanceDeposit. */
export type BalanceDepositPayload = {
  __typename?: 'BalanceDepositPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BalanceGift = {
  __typename?: 'BalanceGift';
  giftPublicId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isRefunded: Scalars['Boolean']['output'];
  postAcceptAdjustedAmount?: Maybe<Scalars['Int']['output']>;
  recipientName: Scalars['String']['output'];
  status: BalanceGiftStatus;
  storedAmount?: Maybe<Scalars['Int']['output']>;
};

export type BalanceGiftBatch = {
  __typename?: 'BalanceGiftBatch';
  acceptedAmount: Scalars['Int']['output'];
  acceptedGiftsCount: Scalars['Int']['output'];
  amountReserved?: Maybe<Scalars['Int']['output']>;
  balanceGifts: Array<BalanceGift>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  giftBatchPublicId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pendingAmount: Scalars['Int']['output'];
  pendingGiftsCount: Scalars['Int']['output'];
  scheduledRecipients?: Maybe<Scalars['Int']['output']>;
  scheduledSendOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: BalanceGiftBatchStatus;
};

export enum BalanceGiftBatchStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Finalized */
  Finalized = 'FINALIZED',
  /** Scheduled Authorized */
  ScheduledAuthorized = 'SCHEDULED_AUTHORIZED',
  /** Scheduled Inactive */
  ScheduledInactive = 'SCHEDULED_INACTIVE',
  /** Scheduled Pending */
  ScheduledPending = 'SCHEDULED_PENDING',
  /** Scheduled Prepaid */
  ScheduledPrepaid = 'SCHEDULED_PREPAID'
}

export enum BalanceGiftStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Expired */
  Expired = 'EXPIRED',
  /** Finalized */
  Finalized = 'FINALIZED',
  /** Pending */
  Pending = 'PENDING'
}

export type BalanceTransaction = {
  __typename?: 'BalanceTransaction';
  action: Scalars['String']['output'];
  amountAfter: Scalars['Int']['output'];
  amountBefore: Scalars['Int']['output'];
  amountDiff: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdByUser?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<BalanceTransactionGift>;
  giftBatch?: Maybe<BalanceTransactionGiftBatch>;
  id: Scalars['ID']['output'];
  publicId: Scalars['String']['output'];
  ttype: Scalars['String']['output'];
};

export type BalanceTransactionGift = {
  __typename?: 'BalanceTransactionGift';
  id: Scalars['ID']['output'];
  productFragment: ProductFragment;
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  recipientLastName?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  status: GiftViewableStatus;
};

/** Limited gift batch object for balance transactions */
export type BalanceTransactionGiftBatch = {
  __typename?: 'BalanceTransactionGiftBatch';
  batchName?: Maybe<Scalars['String']['output']>;
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  productFragment: ProductFragment;
  sendStatus: GiftBatchSendStatus;
};

export type BalanceTransactionReport = {
  __typename?: 'BalanceTransactionReport';
  accessToken: Scalars['String']['output'];
  csvUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of BalanceTransactionReportCreate. */
export type BalanceTransactionReportCreatePayload = {
  __typename?: 'BalanceTransactionReportCreatePayload';
  balanceTransactionReport?: Maybe<BalanceTransactionReport>;
  ok: Scalars['Boolean']['output'];
};

/** This Series type contains the underlying object (BalanceTransaction) along with a total count for pagination. */
export type BalanceTransactionSeries = {
  __typename?: 'BalanceTransactionSeries';
  items: Array<BalanceTransaction>;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated return type of BalanceTransfer. */
export type BalanceTransferPayload = {
  __typename?: 'BalanceTransferPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BatchBillingGroup = {
  __typename?: 'BatchBillingGroup';
  amountNetCharges: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentMethodName?: Maybe<Scalars['String']['output']>;
  receiptId: Scalars['String']['output'];
};

export enum BatchSendMethod {
  DirectSend = 'direct_send',
  EmailAndLink = 'email_and_link',
  LinkMultipleAnyone = 'link_multiple_anyone',
  LinkMultipleCustomList = 'link_multiple_custom_list',
  LinkSingle = 'link_single',
  LinkUnspecified = 'link_unspecified'
}

/** Autogenerated return type of BirthdayRequest. */
export type BirthdayRequestPayload = {
  __typename?: 'BirthdayRequestPayload';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of BirthdaySet. */
export type BirthdaySetPayload = {
  __typename?: 'BirthdaySetPayload';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BookResult = {
  __typename?: 'BookResult';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  binding?: Maybe<Scalars['String']['output']>;
  contributors?: Maybe<Array<Scalars['String']['output']>>;
  ean: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageAvailable: Scalars['Boolean']['output'];
  imageLarge?: Maybe<Scalars['String']['output']>;
  imageMedium?: Maybe<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  isbn?: Maybe<Scalars['String']['output']>;
  notYetAvailable: Scalars['Boolean']['output'];
  onOrder: Scalars['Boolean']['output'];
  pages?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  productFormat?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Autogenerated return type of BookSearch. */
export type BookSearchPayload = {
  __typename?: 'BookSearchPayload';
  ok: Scalars['Boolean']['output'];
  productId: Scalars['ID']['output'];
  results?: Maybe<Array<BookResult>>;
};

export type Brand = {
  __typename?: 'Brand';
  brandValues: Array<Scalars['String']['output']>;
  brandValuesInfo: Array<BrandValuesInfo>;
  freeShippingMinimum?: Maybe<Scalars['Int']['output']>;
  hideMadeBySubtitle: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  logoImage?: Maybe<Image>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryGiftOption?: Maybe<GiftOption>;
  restrictedStates: Array<Scalars['String']['output']>;
  restrictedStatesByCountry?: Maybe<Scalars['JSON']['output']>;
  segments: Array<BusinessSegment>;
  shippingCountriesFinal: Array<Scalars['String']['output']>;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
};

export enum BrandValuesDisplay {
  Options = 'options',
  OptionsAndList = 'options_and_list'
}

export type BrandValuesInfo = {
  __typename?: 'BrandValuesInfo';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum BudgetRecurrence {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY'
}

export type BudgetRule = {
  __typename?: 'BudgetRule';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  recurrence: BudgetRecurrence;
};

/** Autogenerated return type of BudgetRuleUpdate. */
export type BudgetRuleUpdatePayload = {
  __typename?: 'BudgetRuleUpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type BudgetSummary = {
  __typename?: 'BudgetSummary';
  budgetTotalMonthly: Scalars['Int']['output'];
  budgetTotalQuarterly: Scalars['Int']['output'];
};

export type BundledReceipt = {
  __typename?: 'BundledReceipt';
  accessToken: Scalars['String']['output'];
  amountNetCharges: Scalars['Int']['output'];
  closeDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  isBalanceDeposit?: Maybe<Scalars['Boolean']['output']>;
  isBatchBillingGroupFailed: Scalars['Boolean']['output'];
  itemsCount: Scalars['Int']['output'];
  paymentMethodName: Scalars['String']['output'];
  status: BundledReceiptStatus;
  user?: Maybe<User>;
};

export type BundledReceiptItem = {
  __typename?: 'BundledReceiptItem';
  accessToken: Scalars['String']['output'];
  bundledReceipt: BundledReceipt;
  id: Scalars['ID']['output'];
};

export type BundledReceiptPaymentMethodOption = {
  __typename?: 'BundledReceiptPaymentMethodOption';
  cardBrand?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
};

export type BundledReceiptSeries = {
  __typename?: 'BundledReceiptSeries';
  items: Array<BundledReceipt>;
  totalCount: Scalars['Int']['output'];
};


export type BundledReceiptSeriesItemsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum BundledReceiptStatus {
  Finalized = 'FINALIZED',
  Pending = 'PENDING'
}

export type BusinessReferralInfo = {
  __typename?: 'BusinessReferralInfo';
  creditAwarded: Scalars['Int']['output'];
  referralUrl?: Maybe<Scalars['String']['output']>;
};

export enum BusinessSegment {
  Business = 'business',
  Consumer = 'consumer'
}

export type CalendarIntegration = {
  __typename?: 'CalendarIntegration';
  calendlyApiUrl?: Maybe<Scalars['String']['output']>;
  giftSetting?: Maybe<Gift_Meeting_Setting>;
};

/** Autogenerated return type of CalendarIntegrationUpdate. */
export type CalendarIntegrationUpdatePayload = {
  __typename?: 'CalendarIntegrationUpdatePayload';
  calendarIntegration?: Maybe<CalendarIntegration>;
  errors?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Capabilities for API calls */
export enum Capability {
  /** Client ability to handle a giveaway being out */
  GiveawayOut = 'GIVEAWAY_OUT'
}

export type Card = {
  __typename?: 'Card';
  id: Scalars['ID']['output'];
  image: Image;
  imageLarge: Image;
  imageThumb: Image;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  owner: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

/** Data needed to create a card */
export type CardCreateFieldsInput = {
  imageFile: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CardCreate. */
export type CardCreatePayload = {
  __typename?: 'CardCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Data needed to update a card */
export type CardUpdateFieldsInput = {
  id: Scalars['ID']['input'];
  imageFile?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CardUpdate. */
export type CardUpdatePayload = {
  __typename?: 'CardUpdatePayload';
  card?: Maybe<Card>;
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Price estimate for an aggregated cart */
export type CartPriceEstimate = {
  __typename?: 'CartPriceEstimate';
  priceEstTaxHigh: Scalars['Int']['output'];
  priceEstTaxLow: Scalars['Int']['output'];
  priceEstTotalHigh: Scalars['Int']['output'];
  priceEstTotalLow: Scalars['Int']['output'];
  pricePreTax: Scalars['Int']['output'];
  priceProcessingFee: Scalars['Int']['output'];
  priceProduct: Scalars['Int']['output'];
  priceShipping: Scalars['Int']['output'];
  specialDiscountApplied?: Maybe<Scalars['Int']['output']>;
};

/** Price estimate for an aggregated cart */
export type CartPriceEstimateInput = {
  priceEstTaxHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTaxLow?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalLow?: InputMaybe<Scalars['Int']['input']>;
  pricePreTax?: InputMaybe<Scalars['Int']['input']>;
  priceProcessingFee?: InputMaybe<Scalars['Int']['input']>;
  priceProduct?: InputMaybe<Scalars['Int']['input']>;
  priceShipping?: InputMaybe<Scalars['Int']['input']>;
  specialDiscountApplied?: InputMaybe<Scalars['Int']['input']>;
};

export type CartProduct = {
  __typename?: 'CartProduct';
  bookResult?: Maybe<BookResult>;
  id: Scalars['ID']['output'];
  lineUnitAmountCents?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  presetCustomResponses?: Maybe<Array<CustomResponse>>;
  presetVariants?: Maybe<Array<Scalars['String']['output']>>;
  product: Product;
  productDetails: CartProductProductDetails;
  productFragment: ProductFragment;
  productTitle: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/** Data for an item in a cart */
export type CartProductInput = {
  presetCustomResponses?: InputMaybe<Array<CustomResponseInput>>;
  presetVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  productDetails: CartProductProductDetailsInput;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartProductProductDetails = {
  __typename?: 'CartProductProductDetails';
  bookContributors?: Maybe<Scalars['String']['output']>;
  bookDescription?: Maybe<Scalars['String']['output']>;
  bookEan?: Maybe<Scalars['String']['output']>;
  bookImage?: Maybe<Scalars['String']['output']>;
  bookImageAvailable?: Maybe<Scalars['Boolean']['output']>;
  bookPrice?: Maybe<Scalars['Int']['output']>;
  bookTitle?: Maybe<Scalars['String']['output']>;
  flexGiftPrice?: Maybe<Scalars['Int']['output']>;
  giftCardAmount?: Maybe<Scalars['Int']['output']>;
  giftCardNativeAmount?: Maybe<Scalars['Int']['output']>;
  isBook?: Maybe<Scalars['Boolean']['output']>;
  referringCategoryId?: Maybe<Scalars['String']['output']>;
  referringOccasionvcId?: Maybe<Scalars['String']['output']>;
  referringSearchRecordId?: Maybe<Scalars['String']['output']>;
  referringSource?: Maybe<Scalars['String']['output']>;
  referringSourceId?: Maybe<Scalars['String']['output']>;
};

/** For any data specific to the gifted product of the gift */
export type CartProductProductDetailsInput = {
  bookContributors?: InputMaybe<Scalars['String']['input']>;
  bookDescription?: InputMaybe<Scalars['String']['input']>;
  bookEan?: InputMaybe<Scalars['String']['input']>;
  bookImage?: InputMaybe<Scalars['String']['input']>;
  bookImageAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  bookIsbn?: InputMaybe<Scalars['String']['input']>;
  bookPrice?: InputMaybe<Scalars['Int']['input']>;
  bookTitle?: InputMaybe<Scalars['String']['input']>;
  flexGiftPrice?: InputMaybe<Scalars['Int']['input']>;
  giftCardAmount?: InputMaybe<Scalars['Int']['input']>;
  giftCardNativeAmount?: InputMaybe<Scalars['Int']['input']>;
  isBook?: InputMaybe<Scalars['Boolean']['input']>;
  referringCategoryId?: InputMaybe<Scalars['String']['input']>;
  referringOccasionvcId?: InputMaybe<Scalars['String']['input']>;
  referringSearchRecordId?: InputMaybe<Scalars['String']['input']>;
  referringSource?: InputMaybe<Scalars['String']['input']>;
  referringSourceId?: InputMaybe<Scalars['String']['input']>;
};

export enum CartValidateDirectSendErrorType {
  /** Product Ineligible */
  ProductIneligible = 'product_ineligible',
  /** Variant Required */
  VariantRequired = 'variant_required'
}

/** Autogenerated return type of CartValidateDirectSend. */
export type CartValidateDirectSendPayload = {
  __typename?: 'CartValidateDirectSendPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorProductName?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<CartValidateDirectSendErrorType>;
  ok: Scalars['Boolean']['output'];
  variantRequiredProducts?: Maybe<Array<Product>>;
};

export type Category = {
  __typename?: 'Category';
  categoriesSet?: Maybe<Scalars['Boolean']['output']>;
  editorialItems: Array<EditorialItem>;
  icon?: Maybe<Scalars['String']['output']>;
  iconWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  occasionsSet?: Maybe<Scalars['Boolean']['output']>;
  pageDescription?: Maybe<Scalars['String']['output']>;
  pageHeading?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<CategorySegment>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subcategories: Array<Category>;
  supercategoryId?: Maybe<Scalars['ID']['output']>;
};


export type CategoryEditorialItemsArgs = {
  storePlatform?: InputMaybe<StorePlatformEnum>;
};

export type CategoryHomepageProductsPaginatedSeries = {
  __typename?: 'CategoryHomepageProductsPaginatedSeries';
  items: Array<Product>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CategoryProductsPaginatedSeries = {
  __typename?: 'CategoryProductsPaginatedSeries';
  items: Array<CollectionCategoryProduct>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum CategorySegment {
  /** plus */
  Plus = 'PLUS',
  /** standard */
  Standard = 'STANDARD',
  /** swag */
  Swag = 'SWAG'
}

export enum CategorySet {
  /** CATEGORIES */
  Categories = 'CATEGORIES',
  /** OCCASIONS */
  Occasions = 'OCCASIONS'
}

/** Autogenerated return type of CheckAbandonedCart. */
export type CheckAbandonedCartPayload = {
  __typename?: 'CheckAbandonedCartPayload';
  ok: Scalars['Boolean']['output'];
};

/** A single product + quantity line in any checkout flow (Company Store, gift top-off, etc.). */
export type CheckoutItemInput = {
  customResponses?: InputMaybe<Array<CustomResponseInput>>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Payment details for any checkout flow. The card is tokenized client-side via VGS. Provide `billingAddress` only when the buyer entered a billing address that differs from shipping; otherwise the shipping address is used. */
export type CheckoutPaymentInput = {
  billingAddress?: InputMaybe<AddressInput>;
  cardholderName: Scalars['String']['input'];
  interimCardToken: Scalars['String']['input'];
};

/** Autogenerated return type of CoinsRedeem. */
export type CoinsRedeemPayload = {
  __typename?: 'CoinsRedeemPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type Collection = {
  __typename?: 'Collection';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  companyStoreEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  latestDraftVersion?: Maybe<CollectionVersion>;
  orders: StoreOrderConnection;
  /** Order count + sales total for the last 30 days. */
  ordersSummary: StoreOrdersSummary;
  organizationImage?: Maybe<Image>;
  organizationName?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  publishedPrice?: Maybe<Scalars['Int']['output']>;
  publishedVersion?: Maybe<CollectionVersion>;
  publishedVersionId?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  swag?: Maybe<CollectionsSwagType>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CollectionOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StoreOrderDashboardStateEnum>;
};

/** Autogenerated return type of CollectionArchive. */
export type CollectionArchivePayload = {
  __typename?: 'CollectionArchivePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCategorizationApply. */
export type CollectionCategorizationApplyPayload = {
  __typename?: 'CollectionCategorizationApplyPayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Data needed to apply collection categorization */
export type CollectionCategorizationInput = {
  name: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CollectionCategorizationSuggest. */
export type CollectionCategorizationSuggestPayload = {
  __typename?: 'CollectionCategorizationSuggestPayload';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CollectionCategory = {
  __typename?: 'CollectionCategory';
  /** Products in this category with their positions */
  categoryProducts: CollectionCategoryProductConnection;
  /** Paginated products in this category */
  categoryProductsPaginated: CategoryProductsPaginatedSeries;
  collectionProducts: Array<CollectionProduct>;
  collectionVersion: CollectionVersion;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isFeatured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CollectionCategoryCategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionCategoryCategoryProductsPaginatedArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};

/** Autogenerated return type of CollectionCategoryCreate. */
export type CollectionCategoryCreatePayload = {
  __typename?: 'CollectionCategoryCreatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCategoryDelete. */
export type CollectionCategoryDeletePayload = {
  __typename?: 'CollectionCategoryDeletePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Data needed to update a collection category */
export type CollectionCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A product within a collection category with position information */
export type CollectionCategoryProduct = {
  __typename?: 'CollectionCategoryProduct';
  collectionCategory: CollectionCategory;
  collectionCategoryId: Scalars['ID']['output'];
  collectionProduct: CollectionProduct;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Position within the category (1-based) */
  position: Scalars['Int']['output'];
  product: Product;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CollectionCategoryProduct. */
export type CollectionCategoryProductConnection = {
  __typename?: 'CollectionCategoryProductConnection';
  /** A list of edges. */
  edges: Array<CollectionCategoryProductEdge>;
  /** A list of nodes. */
  nodes: Array<CollectionCategoryProduct>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of CollectionCategoryProductCopy. */
export type CollectionCategoryProductCopyPayload = {
  __typename?: 'CollectionCategoryProductCopyPayload';
  error?: Maybe<Scalars['String']['output']>;
  newCollectionCategoryProduct?: Maybe<CollectionCategoryProduct>;
  ok: Scalars['Boolean']['output'];
  sourceCategory?: Maybe<CollectionCategory>;
  targetCategory?: Maybe<CollectionCategory>;
};

/** Autogenerated return type of CollectionCategoryProductDelete. */
export type CollectionCategoryProductDeletePayload = {
  __typename?: 'CollectionCategoryProductDeletePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type CollectionCategoryProductEdge = {
  __typename?: 'CollectionCategoryProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CollectionCategoryProduct>;
};

/** Autogenerated return type of CollectionCategoryProductMove. */
export type CollectionCategoryProductMovePayload = {
  __typename?: 'CollectionCategoryProductMovePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  sourceCategory?: Maybe<CollectionCategory>;
  targetCategory?: Maybe<CollectionCategory>;
};

/** Autogenerated return type of CollectionCategoryProductReorder. */
export type CollectionCategoryProductReorderPayload = {
  __typename?: 'CollectionCategoryProductReorderPayload';
  collectionCategory?: Maybe<CollectionCategory>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCategoryReorder. */
export type CollectionCategoryReorderPayload = {
  __typename?: 'CollectionCategoryReorderPayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCategorySuggest. */
export type CollectionCategorySuggestPayload = {
  __typename?: 'CollectionCategorySuggestPayload';
  collectionCategory?: Maybe<CollectionCategory>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCategoryUpdate. */
export type CollectionCategoryUpdatePayload = {
  __typename?: 'CollectionCategoryUpdatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionClone. */
export type CollectionClonePayload = {
  __typename?: 'CollectionClonePayload';
  clonedCollection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionCreate. */
export type CollectionCreatePayload = {
  __typename?: 'CollectionCreatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionHeaderImageCreateFromUrl. */
export type CollectionHeaderImageCreateFromUrlPayload = {
  __typename?: 'CollectionHeaderImageCreateFromUrlPayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionHeaderImageUpload. */
export type CollectionHeaderImageUploadPayload = {
  __typename?: 'CollectionHeaderImageUploadPayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CollectionPriceEstimate = {
  __typename?: 'CollectionPriceEstimate';
  displayPrice: Scalars['Int']['output'];
  estimatedTaxHigh: Scalars['Int']['output'];
  estimatedTaxLow: Scalars['Int']['output'];
  estimatedTotalHigh: Scalars['Int']['output'];
  estimatedTotalLow: Scalars['Int']['output'];
  maximumSubtotalWithShipping: Scalars['Int']['output'];
  multipleSelectCount?: Maybe<Scalars['Int']['output']>;
  priceWithGiftCount?: Maybe<Scalars['Int']['output']>;
  priceWithLimitation?: Maybe<Scalars['Int']['output']>;
  processingFee: Scalars['Int']['output'];
};

export type CollectionProduct = {
  __typename?: 'CollectionProduct';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  productDetails?: Maybe<CollectionProductProductDetails>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of CollectionProductCreate. */
export type CollectionProductCreatePayload = {
  __typename?: 'CollectionProductCreatePayload';
  alreadyExisted: Scalars['Boolean']['output'];
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionProductDelete. */
export type CollectionProductDeletePayload = {
  __typename?: 'CollectionProductDeletePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CollectionProductProductDetails = {
  __typename?: 'CollectionProductProductDetails';
  giftCardNativeAmount?: Maybe<Scalars['Int']['output']>;
  giftCardUsdAmount?: Maybe<Scalars['Int']['output']>;
};

export type CollectionProductProductDetailsInput = {
  giftCardNativeAmount?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CollectionStoreUpdate. */
export type CollectionStoreUpdatePayload = {
  __typename?: 'CollectionStoreUpdatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionThemeUpdate. */
export type CollectionThemeUpdatePayload = {
  __typename?: 'CollectionThemeUpdatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionUnarchive. */
export type CollectionUnarchivePayload = {
  __typename?: 'CollectionUnarchivePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CollectionVersion = {
  __typename?: 'CollectionVersion';
  allowRecipientTopup: Scalars['Boolean']['output'];
  collection: Collection;
  collectionCategories: Array<CollectionCategory>;
  collectionCategory?: Maybe<CollectionCategory>;
  collectionProducts: Array<CollectionProduct>;
  companyStoreInternationalShippingTier: InternationalShippingTierEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayInterface: CollectionsDisplayInterfaceEnum;
  /** Returns the collection-version theme if set, otherwise falls back to the organization-level theme. Used by storefront / gift-acceptance surfaces that want a single resolved theme without plumbing the fallback chain client-side. */
  effectiveTheme?: Maybe<Theme>;
  gridColumns: CollectionsGridColumnsEnum;
  headerImage?: Maybe<CollectionsHeaderImageType>;
  id: Scalars['ID']['output'];
  internationalGiftCardsEnabled: Scalars['Boolean']['output'];
  internationalShippingTier: InternationalShippingTierEnum;
  isDraft: Scalars['Boolean']['output'];
  multipleSelectCount?: Maybe<Scalars['Int']['output']>;
  multipleSelectMode: CollectionsMultipleSelectModeEnum;
  multipleSelectPrice?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  priceEstimate?: Maybe<CollectionPriceEstimate>;
  productImageShape: CollectionsProductImageShapeEnum;
  subtitle?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Theme>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CollectionVersionCollectionCategoryArgs = {
  slug: Scalars['String']['input'];
};

/** Data needed to create a collection version */
export type CollectionVersionInput = {
  allowRecipientTopup?: InputMaybe<Scalars['Boolean']['input']>;
  collectionHeaderImageId?: InputMaybe<Scalars['ID']['input']>;
  companyStoreInternationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  displayInterface?: InputMaybe<CollectionsDisplayInterfaceEnum>;
  gridColumns?: InputMaybe<CollectionsGridColumnsEnum>;
  internationalGiftCardsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  internationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  multipleSelectCount?: InputMaybe<Scalars['Int']['input']>;
  multipleSelectMode?: InputMaybe<CollectionsMultipleSelectModeEnum>;
  multipleSelectPrice?: InputMaybe<Scalars['Int']['input']>;
  productImageShape?: InputMaybe<CollectionsProductImageShapeEnum>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CollectionVersionPublish. */
export type CollectionVersionPublishPayload = {
  __typename?: 'CollectionVersionPublishPayload';
  collection?: Maybe<Collection>;
  draftVersion?: Maybe<CollectionVersion>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  publishedVersion?: Maybe<CollectionVersion>;
};

/** Autogenerated return type of CollectionVersionRemoveHeaderImage. */
export type CollectionVersionRemoveHeaderImagePayload = {
  __typename?: 'CollectionVersionRemoveHeaderImagePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CollectionVersionUpdate. */
export type CollectionVersionUpdatePayload = {
  __typename?: 'CollectionVersionUpdatePayload';
  collection?: Maybe<Collection>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum CollectionsDisplayInterfaceEnum {
  CategoryPages = 'category_pages',
  SinglePage = 'single_page'
}

export enum CollectionsGridColumnsEnum {
  Four = 'four',
  Three = 'three'
}

export type CollectionsHeaderImageType = {
  __typename?: 'CollectionsHeaderImageType';
  altText: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageLarge: Image;
  position: Scalars['Int']['output'];
  public: Scalars['Boolean']['output'];
};

export enum CollectionsMultipleSelectModeEnum {
  Disabled = 'disabled',
  ItemCount = 'item_count',
  MaxPrice = 'max_price'
}

export enum CollectionsProductImageShapeEnum {
  Horizontal = 'horizontal',
  Square = 'square'
}

export enum CollectionsSwagStatusEnum {
  /** Workflow completed successfully */
  Completed = 'completed',
  /** Workflow failed or was cancelled */
  Failed = 'failed',
  /** Workflow is pending or running */
  Processing = 'processing'
}

export type CollectionsSwagType = {
  __typename?: 'CollectionsSwagType';
  failedMessage?: Maybe<Scalars['String']['output']>;
  /** Products hidden due to exceeding max price (without override) */
  hiddenProductsConnection: SwagIntegrationsCustomProductIntegrationConnection;
  id: Scalars['ID']['output'];
  /** Count of products above the max price that have manual overrides to remain visible */
  manuallyAddedAboveMaxCount: Scalars['Int']['output'];
  status: CollectionsSwagStatusEnum;
  storePreviewsConnection: SwagIntegrationsCustomProductIntegrationConnection;
  /** Maximum price swag products in the collection can have (e.g., 7500 for $75.00). Null means no limit. Swag products exceeding this price will be filtered from view */
  swagMaximumPrice?: Maybe<Scalars['Int']['output']>;
};


export type CollectionsSwagTypeHiddenProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectionsSwagTypeStorePreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ColorInputs = {
  __typename?: 'ColorInputs';
  accent?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  primary: Scalars['String']['output'];
  unwrapBackground?: Maybe<Scalars['String']['output']>;
  unwrapPrimary?: Maybe<Scalars['String']['output']>;
  unwrapRibbon?: Maybe<Scalars['String']['output']>;
};

export type ColorInputsInput = {
  accent?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  primary: Scalars['String']['input'];
  unwrapBackground?: InputMaybe<Scalars['String']['input']>;
  unwrapPrimary?: InputMaybe<Scalars['String']['input']>;
  unwrapRibbon?: InputMaybe<Scalars['String']['input']>;
};

export type CommerceApp = {
  __typename?: 'CommerceApp';
  apiTokens: Array<ApiToken>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publicAppId: Scalars['String']['output'];
  svixDashboardUrl: Scalars['String']['output'];
};

/** Autogenerated return type of CommerceAppCreate. */
export type CommerceAppCreatePayload = {
  __typename?: 'CommerceAppCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CommonSubscription = {
  /** @deprecated Seats fields have been deprecated */
  additionalSeatMonthlyCostCents?: Maybe<Scalars['Int']['output']>;
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  isCancelRegistered?: Maybe<Scalars['Boolean']['output']>;
  isEe: Scalars['Boolean']['output'];
  isTeamPlan: Scalars['Boolean']['output'];
  isTrialActive?: Maybe<Scalars['Boolean']['output']>;
  managementType?: Maybe<SubscriptionManagement>;
  planName: Scalars['String']['output'];
  planSku: SubscriptionPlanSku;
  trialCardStatus?: Maybe<SubscriptionTrialCardStatus>;
  trialEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of CompanyNameUpdate. */
export type CompanyNameUpdatePayload = {
  __typename?: 'CompanyNameUpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

/** Autogenerated return type of ConfirmIntegration. */
export type ConfirmIntegrationPayload = {
  __typename?: 'ConfirmIntegrationPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ConnectIntegration. */
export type ConnectIntegrationPayload = {
  __typename?: 'ConnectIntegrationPayload';
  data?: Maybe<HrisIntegrationConnectData>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  addedToHrisDate?: Maybe<ScheduledEvent>;
  birthday?: Maybe<ScheduledEvent>;
  birthdayRequest?: Maybe<EventRequest>;
  company?: Maybe<Scalars['String']['output']>;
  contactLists: Array<ContactList>;
  deviceContactIds: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventRequests: Array<EventRequest>;
  firstName: Scalars['String']['output'];
  hasPendingAutogifts?: Maybe<Scalars['Boolean']['output']>;
  hrisName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  scheduledEvents: Array<ScheduledEvent>;
  startDate?: Maybe<ScheduledEvent>;
  title?: Maybe<Scalars['String']['output']>;
  workAnniversary?: Maybe<ScheduledEvent>;
};

/** Autogenerated return type of ContactBatchRemove. */
export type ContactBatchRemovePayload = {
  __typename?: 'ContactBatchRemovePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
  removedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of ContactBatchUpdate. */
export type ContactBatchUpdatePayload = {
  __typename?: 'ContactBatchUpdatePayload';
  error?: Maybe<Array<Scalars['String']['output']>>;
  errorCode?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  results: Array<ContactUploadResult>;
};

export type ContactInput = {
  birthday?: InputMaybe<ScheduledEventInput>;
  birthdayString?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  deviceContactId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workAnniversary?: InputMaybe<ScheduledEventInput>;
  workAnniversaryString?: InputMaybe<Scalars['String']['input']>;
};

export type ContactList = {
  __typename?: 'ContactList';
  autogiftGiftBatches?: Maybe<Array<GiftBatch>>;
  autogiftRules?: Maybe<Array<AutogiftRule>>;
  contacts: Array<Contact>;
  contactsCount: Scalars['Int']['output'];
  contactsWithEventToday: Array<Scalars['String']['output']>;
  countByWorkTenure?: Maybe<Scalars['Int']['output']>;
  hasActiveAutogifts: Scalars['Boolean']['output'];
  hrisSynced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type ContactListAutogiftGiftBatchesArgs = {
  eventType: EventKind;
};


export type ContactListContactsWithEventTodayArgs = {
  eventType: EventKind;
  tenureMax?: InputMaybe<Scalars['Int']['input']>;
  tenureMin?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactListCountByWorkTenureArgs = {
  tenureMax?: InputMaybe<Scalars['Int']['input']>;
  tenureMin?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ContactListBatchAddContacts. */
export type ContactListBatchAddContactsPayload = {
  __typename?: 'ContactListBatchAddContactsPayload';
  addedCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ContactListCreate. */
export type ContactListCreatePayload = {
  __typename?: 'ContactListCreatePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ContactListDestroy. */
export type ContactListDestroyPayload = {
  __typename?: 'ContactListDestroyPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
  removedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of ContactListUpdate. */
export type ContactListUpdatePayload = {
  __typename?: 'ContactListUpdatePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ContactRemove. */
export type ContactRemovePayload = {
  __typename?: 'ContactRemovePayload';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum ContactSegment {
  /** plus */
  Plus = 'PLUS',
  /** standard */
  Standard = 'STANDARD'
}

/** Autogenerated return type of ContactUpdate. */
export type ContactUpdatePayload = {
  __typename?: 'ContactUpdatePayload';
  contact?: Maybe<Contact>;
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ContactUploadResult = {
  __typename?: 'ContactUploadResult';
  addListId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  new: Scalars['Boolean']['output'];
  newItems: Array<Scalars['String']['output']>;
  updateItems: Array<Scalars['String']['output']>;
};

export enum CountryCodeEnum {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** DR Congo */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Domestic */
  Domestic = 'DOMESTIC',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Gift Card */
  GiftCard = 'GIFT_CARD',
  /** Greenland */
  Gl = 'GL',
  /** Global */
  Global = 'GLOBAL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** Autogenerated return type of CreateIdentityProvider. */
export type CreateIdentityProviderPayload = {
  __typename?: 'CreateIdentityProviderPayload';
  ok: Scalars['Boolean']['output'];
  samlIdentityProvider: IdentityProvider;
};

/** Autogenerated return type of CreateInvite. */
export type CreateInvitePayload = {
  __typename?: 'CreateInvitePayload';
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<WorkspaceInviteError>>;
  invitedCount?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateWorkspace. */
export type CreateWorkspacePayload = {
  __typename?: 'CreateWorkspacePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CurrentWorkspace = {
  __typename?: 'CurrentWorkspace';
  autogiftGiftBatches?: Maybe<Array<GiftBatch>>;
  balance?: Maybe<Scalars['Int']['output']>;
  balanceAccess: WorkspaceBalanceAccess;
  balanceAccessAvailable: Scalars['Boolean']['output'];
  balanceAccount?: Maybe<BalanceAccount>;
  budgetRule?: Maybe<BudgetRule>;
  contactIds: Array<Scalars['ID']['output']>;
  contactIdsCapped: Scalars['Boolean']['output'];
  contactList: ContactList;
  contactLists: Array<ContactList>;
  contacts?: Maybe<Array<Contact>>;
  contactsByIds: Array<Contact>;
  contactsCount: Scalars['Int']['output'];
  giftBatch?: Maybe<GiftBatch>;
  giftBatches: Array<GiftBatch>;
  giftBatchesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoicingEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  recentlyAcceptedGifts: Array<Gift>;
};


export type CurrentWorkspaceAutogiftGiftBatchesArgs = {
  autogiftRuleId?: InputMaybe<Scalars['ID']['input']>;
};


export type CurrentWorkspaceContactIdsArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentWorkspaceContactIdsCappedArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentWorkspaceContactListArgs = {
  id: Scalars['ID']['input'];
};


export type CurrentWorkspaceContactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentWorkspaceContactsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type CurrentWorkspaceContactsCountArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type CurrentWorkspaceGiftBatchArgs = {
  id: Scalars['ID']['input'];
};


export type CurrentWorkspaceGiftBatchesArgs = {
  filters?: InputMaybe<GiftBatchFiltersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentWorkspaceGiftBatchesCountArgs = {
  filters?: InputMaybe<GiftBatchFiltersInput>;
};

export type CustomResponse = {
  __typename?: 'CustomResponse';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type CustomResponseInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type CustomStore = {
  __typename?: 'CustomStore';
  brandValuesDisplay: BrandValuesDisplay;
  desktopHeaderImage?: Maybe<Image>;
  desktopHeaderImageThumb?: Maybe<Image>;
  hasCreditExcludedItems: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internationalShippingTier: InternationalShippingTierEnum;
  maximumPrice?: Maybe<Scalars['Int']['output']>;
  minimumPrice?: Maybe<Scalars['Int']['output']>;
  mobileHeaderImage?: Maybe<Image>;
  mobileHeaderImageThumb?: Maybe<Image>;
  multipleSelectCount?: Maybe<Scalars['Int']['output']>;
  multipleSelectMode?: Maybe<MultipleSelectModeEnum>;
  multipleSelectPrice?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  numProductsHidden: Scalars['Int']['output'];
  optionList: Array<CustomStoreOption>;
  priceEstimate?: Maybe<CustomStorePriceEstimate>;
  product: Product;
  productPreviewList?: Maybe<Array<CustomStoreProductPreview>>;
  settings: GiftsSettings;
  status: CustomStoreStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CustomStoreAddOption. */
export type CustomStoreAddOptionPayload = {
  __typename?: 'CustomStoreAddOptionPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CustomStoreArchive. */
export type CustomStoreArchivePayload = {
  __typename?: 'CustomStoreArchivePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CustomStoreCreate. */
export type CustomStoreCreatePayload = {
  __typename?: 'CustomStoreCreatePayload';
  customStore?: Maybe<CustomStore>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export type CustomStoreGiftOption = GiftOptionInterface & {
  __typename?: 'CustomStoreGiftOption';
  brand: Brand;
  colors: GiftOptionColors;
  description?: Maybe<Scalars['String']['output']>;
  giftOptionImages: Array<GiftOptionImage>;
  id: Scalars['ID']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isSingleProduct?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Image>;
  name: Scalars['String']['output'];
  priceMax?: Maybe<Scalars['Int']['output']>;
  priceMaxWithShipping?: Maybe<Scalars['Int']['output']>;
  priceMin?: Maybe<Scalars['Int']['output']>;
  prices: Array<Scalars['Int']['output']>;
  primaryImage?: Maybe<GiftOptionImage>;
  products: Array<CustomStoreProduct>;
  recommendedOccasionIds?: Maybe<Array<Scalars['String']['output']>>;
  sections: Array<GiftOptionSection>;
  seo: GiftOptionSeo;
  shippingCountryGroup: ShippingCountryGroup;
  singleProductMode: Scalars['Boolean']['output'];
  singleProductSlug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: GiftOptionStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type CustomStoreGiftOptionPriceMaxWithShippingArgs = {
  customStoreId: Scalars['ID']['input'];
};


export type CustomStoreGiftOptionProductsArgs = {
  customStoreId: Scalars['ID']['input'];
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
};

export type CustomStoreImage = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomStoreMultipleSelectModeEnum {
  Disabled = 'disabled',
  ItemCount = 'item_count',
  MaxPrice = 'max_price'
}

export type CustomStoreOption = {
  __typename?: 'CustomStoreOption';
  giftCardAmount?: Maybe<Scalars['Int']['output']>;
  giftOption?: Maybe<CustomStoreGiftOption>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  priceMaxWithShipping: Scalars['Int']['output'];
  product: CustomStoreProduct;
};

/** The connection type for CustomStoreOption. */
export type CustomStoreOptionConnection = {
  __typename?: 'CustomStoreOptionConnection';
  /** A list of edges. */
  edges: Array<CustomStoreOptionEdge>;
  /** A list of nodes. */
  nodes: Array<CustomStoreOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomStoreOptionEdge = {
  __typename?: 'CustomStoreOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CustomStoreOption>;
};

export type CustomStorePriceEstimate = {
  __typename?: 'CustomStorePriceEstimate';
  estimatedTaxHigh: Scalars['Int']['output'];
  estimatedTaxLow: Scalars['Int']['output'];
  estimatedTotalHigh: Scalars['Int']['output'];
  estimatedTotalLow: Scalars['Int']['output'];
  maximumSubtotalWithShipping: Scalars['Int']['output'];
  processingFee: Scalars['Int']['output'];
};

export type CustomStoreProduct = ProductInterface & {
  __typename?: 'CustomStoreProduct';
  active: Scalars['Boolean']['output'];
  brand: Brand;
  cartEligible: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionInfo?: Maybe<ProductCollectionInfo>;
  companyStoreRestrictedReason?: Maybe<Scalars['String']['output']>;
  customResponseCharMax?: Maybe<Scalars['Int']['output']>;
  customResponseQuestion?: Maybe<Scalars['String']['output']>;
  customStore?: Maybe<CustomStore>;
  customStoreImageThumb?: Maybe<Image>;
  customSwapMinimumPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domesticShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  ecommerceIntegrationType?: Maybe<EcommerceIntegration>;
  forceSwapEnabled: Scalars['Boolean']['output'];
  giftCardCountries?: Maybe<Array<CountryCodeEnum>>;
  giftCardCurrency?: Maybe<Scalars['String']['output']>;
  giftCardCurrencyRate?: Maybe<Scalars['Float']['output']>;
  giftCardInfo?: Maybe<GiftCardInfo>;
  giftCardNativeAmount?: Maybe<Scalars['Int']['output']>;
  giftCardNativeAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  giftCardNativeCurrency?: Maybe<Scalars['String']['output']>;
  giftCollectionTiers: Array<GiftCollectionTier>;
  globalShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  hasVariablePricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagesScalable: Scalars['Boolean']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isBook: Scalars['Boolean']['output'];
  isCollection: Scalars['Boolean']['output'];
  isDuplicated: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  isGiftCollection: Scalars['Boolean']['output'];
  isOfflineProduct: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  isRestrictedInCompanyStores: Scalars['Boolean']['output'];
  isShippingTierDisabled: Scalars['Boolean']['output'];
  isSwapToEligible: Scalars['Boolean']['output'];
  itemType?: Maybe<ItemTypeEnum>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionsAvailable: Scalars['Boolean']['output'];
  preferredSwapImageLarge?: Maybe<Image>;
  preferredSwapImageXlarge?: Maybe<Image>;
  price: Scalars['Int']['output'];
  priceWithShipping: Scalars['Int']['output'];
  productAttributes?: Maybe<Array<ProductAttribute>>;
  productEditorialImages?: Maybe<Array<ProductEditorialImage>>;
  productImages: Array<ProductImage>;
  restrictedStates: Array<Scalars['String']['output']>;
  restrictedStatesByCountry?: Maybe<Scalars['JSON']['output']>;
  restrictedStatesOverrideEnabled: Scalars['Boolean']['output'];
  shippingCountriesFinal: Array<Scalars['String']['output']>;
  shippingCountryGroup: ShippingCountryGroup;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shippingStates?: Maybe<Array<Scalars['String']['output']>>;
  showCategories?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  status: ProductStatus;
  stockRemaining?: Maybe<Scalars['Int']['output']>;
  storeTags?: Maybe<Array<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleShort?: Maybe<Scalars['String']['output']>;
  swag: ProductsSwagType;
  swapStoreHeaderImage?: Maybe<Image>;
  swapStoreMobileHeaderImage?: Maybe<Image>;
  swapStoreSettings?: Maybe<SwapStoreSettings>;
  variantGroups?: Maybe<Array<VariantGroups>>;
  variants: Array<ProductVariant>;
  variantsLabel?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncase?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncasePlural?: Maybe<Scalars['String']['output']>;
  variantsNumSelectable?: Maybe<Scalars['Int']['output']>;
};


export type CustomStoreProductGiftCardNativeAmountArgs = {
  customStoreId: Scalars['ID']['input'];
};


export type CustomStoreProductIsAvailableArgs = {
  customStoreId: Scalars['ID']['input'];
};


export type CustomStoreProductIsDuplicatedArgs = {
  customStoreId: Scalars['ID']['input'];
};


export type CustomStoreProductPriceArgs = {
  customStoreId: Scalars['ID']['input'];
};

export type CustomStoreProductPreview = {
  __typename?: 'CustomStoreProductPreview';
  brandName: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
};

/** Autogenerated return type of CustomStoreRemoveOption. */
export type CustomStoreRemoveOptionPayload = {
  __typename?: 'CustomStoreRemoveOptionPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CustomStoreReorderOptions. */
export type CustomStoreReorderOptionsPayload = {
  __typename?: 'CustomStoreReorderOptionsPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export enum CustomStoreStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** DRAFT */
  Draft = 'DRAFT'
}

/** Autogenerated return type of CustomStoreUpdate. */
export type CustomStoreUpdatePayload = {
  __typename?: 'CustomStoreUpdatePayload';
  customStore?: Maybe<CustomStore>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeletionRequestCreate. */
export type DeletionRequestCreatePayload = {
  __typename?: 'DeletionRequestCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DestroyMembership. */
export type DestroyMembershipPayload = {
  __typename?: 'DestroyMembershipPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DeviceIdentifiers = {
  gaid?: InputMaybe<Scalars['String']['input']>;
  idfa?: InputMaybe<Scalars['String']['input']>;
  idfv?: InputMaybe<Scalars['String']['input']>;
};

/** Information about a user's installation */
export type DeviceInfoInput = {
  abTests?: InputMaybe<Array<Scalars['String']['input']>>;
  appsflyerId?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Attribution>;
  attributionCampaign?: InputMaybe<Scalars['String']['input']>;
  attributionSource?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  contactsPermissionsStatus?: InputMaybe<Scalars['String']['input']>;
  deviceIdentifiers?: InputMaybe<DeviceIdentifiers>;
  deviceModelName?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  devicePushTokenType?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceYearClass?: InputMaybe<Scalars['String']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  expoSdkVersion?: InputMaybe<Scalars['String']['input']>;
  expoVersion?: InputMaybe<Scalars['String']['input']>;
  installationId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  nativeAppVersion?: InputMaybe<Scalars['String']['input']>;
  nativeBuildVersion?: InputMaybe<Scalars['String']['input']>;
  notificationsPermissionsStatus?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  releaseChannel?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updateId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeviceUpdateLastSession. */
export type DeviceUpdateLastSessionPayload = {
  __typename?: 'DeviceUpdateLastSessionPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeviceUpdate. */
export type DeviceUpdatePayload = {
  __typename?: 'DeviceUpdatePayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DisableIdentityProvider. */
export type DisableIdentityProviderPayload = {
  __typename?: 'DisableIdentityProviderPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DisconnectIntegration. */
export type DisconnectIntegrationPayload = {
  __typename?: 'DisconnectIntegrationPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DraftAccept. */
export type DraftAcceptPayload = {
  __typename?: 'DraftAcceptPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DraftCreate. */
export type DraftCreatePayload = {
  __typename?: 'DraftCreatePayload';
  giftBatchesDraftId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DraftSwapBack. */
export type DraftSwapBackPayload = {
  __typename?: 'DraftSwapBackPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DraftSwap. */
export type DraftSwapPayload = {
  __typename?: 'DraftSwapPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DraftUpdateCurrentCountryOverride. */
export type DraftUpdateCurrentCountryOverridePayload = {
  __typename?: 'DraftUpdateCurrentCountryOverridePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum EcommerceIntegration {
  BestBuy = 'best_buy',
  BestBuyCanada = 'best_buy_canada',
  Carro = 'carro',
  CorporateMerch = 'corporate_merch',
  GourmetGiftBasket = 'gourmet_gift_basket',
  Harco = 'harco',
  ManualPrintProvider = 'manual_print_provider',
  PowerSale = 'power_sale',
  Premco = 'premco',
  Printify = 'printify',
  Shopify = 'shopify'
}

export type EditorialImage = {
  __typename?: 'EditorialImage';
  id: Scalars['ID']['output'];
  imageFileId: Scalars['String']['output'];
  imageLarge: Image;
};

export type EditorialItem = {
  __typename?: 'EditorialItem';
  author?: Maybe<Scalars['String']['output']>;
  authorDescription?: Maybe<Scalars['String']['output']>;
  authorImageSmall?: Maybe<Image>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  ctaImageDesktopLarge?: Maybe<Image>;
  ctaImageDesktopWideXlarge?: Maybe<Image>;
  ctaImageDesktopXlarge?: Maybe<Image>;
  ctaImageMobileLarge?: Maybe<Image>;
  ctaLabel: Scalars['String']['output'];
  ctaUrlOverride?: Maybe<Scalars['String']['output']>;
  displayType: EditorialItemDisplayType;
  editorialImages: Array<EditorialImage>;
  giftOptions: Array<GiftOption>;
  headerImageLarge?: Maybe<Image>;
  headerImageSmall?: Maybe<Image>;
  id: Scalars['ID']['output'];
  instagram1?: Maybe<Scalars['String']['output']>;
  instagram2?: Maybe<Scalars['String']['output']>;
  isPreview: Scalars['Boolean']['output'];
  isSubtitleHiddenOnPreview: Scalars['Boolean']['output'];
  products: Array<Product>;
  productsWithGiftOption: Array<Product>;
  relatedEditorialItems: Array<EditorialItem>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum EditorialItemDisplayType {
  /** Standard */
  Standard = 'STANDARD'
}

export enum EmailDeliveryMethods {
  /** Sent from sender's email (via Gmail API) */
  Gmail = 'gmail',
  /** Email sent by Goody */
  Goody = 'goody'
}

/** Autogenerated return type of EmailVerificationSend. */
export type EmailVerificationSendPayload = {
  __typename?: 'EmailVerificationSendPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of EmailVerificationVerify. */
export type EmailVerificationVerifyPayload = {
  __typename?: 'EmailVerificationVerifyPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Event = {
  __typename?: 'Event';
  autogiftRules: Array<AutogiftRule>;
  autogiftSettings: Array<EventAutogiftSettings>;
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  tenure?: Maybe<Scalars['Int']['output']>;
};

export type EventAutogiftSettings = {
  __typename?: 'EventAutogiftSettings';
  canceled: Scalars['Boolean']['output'];
  card?: Maybe<Card>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type EventAutogiftSettingsInput = {
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type EventInput = {
  autogiftSettings: Array<EventAutogiftSettingsInput>;
  id: Scalars['String']['input'];
};

export enum EventKind {
  /** added_to_hris_date */
  AddedToHrisDate = 'ADDED_TO_HRIS_DATE',
  /** anniversary */
  Anniversary = 'ANNIVERSARY',
  /** birthday */
  Birthday = 'BIRTHDAY',
  /** holiday */
  Holiday = 'HOLIDAY',
  /** onboarding */
  Onboarding = 'ONBOARDING',
  /** start_date */
  StartDate = 'START_DATE',
  /** work anniversary */
  WorkAnniversary = 'WORK_ANNIVERSARY'
}

export enum EventOwner {
  /** public */
  Public = 'PUBLIC',
  /** user */
  User = 'USER'
}

export type EventRequest = {
  __typename?: 'EventRequest';
  id: Scalars['ID']['output'];
  kind: EventKind;
};

/** Autogenerated return type of EventUpdate. */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ExperimentAssignmentRecordCreate. */
export type ExperimentAssignmentRecordCreatePayload = {
  __typename?: 'ExperimentAssignmentRecordCreatePayload';
  ok: Scalars['Boolean']['output'];
};

export type FailureMessages = {
  __typename?: 'FailureMessages';
  message: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqCollection = {
  __typename?: 'FaqCollection';
  faqItems: Array<FaqItem>;
  id: Scalars['ID']['output'];
};

export type FaqItem = {
  __typename?: 'FaqItem';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

/** Autogenerated return type of FavoritesOnboardingCheck. */
export type FavoritesOnboardingCheckPayload = {
  __typename?: 'FavoritesOnboardingCheckPayload';
  displayFavoritesOnboarding: Scalars['Boolean']['output'];
};

export enum FlexPreviewMode {
  Multiple = 'multiple',
  Single = 'single'
}

/** Autogenerated return type of ForgotPassword. */
export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GenerateAblyTokenRequest. */
export type GenerateAblyTokenRequestPayload = {
  __typename?: 'GenerateAblyTokenRequestPayload';
  tokenRequest?: Maybe<Scalars['String']['output']>;
};

export type Gift = {
  __typename?: 'Gift';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  amountCreditApplied: Scalars['Int']['output'];
  amountProcessingFee: Scalars['Int']['output'];
  amountProduct: Scalars['Int']['output'];
  amountShipping: Scalars['Int']['output'];
  amountTax?: Maybe<Scalars['Int']['output']>;
  amountTotal?: Maybe<Scalars['Int']['output']>;
  autopayEnabled?: Maybe<Scalars['Boolean']['output']>;
  autopayPaymentMethodName?: Maybe<Scalars['String']['output']>;
  autopayProcessed?: Maybe<Scalars['Boolean']['output']>;
  bookImage?: Maybe<Scalars['String']['output']>;
  bookTitle?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Card>;
  cartItemCount: Scalars['Int']['output'];
  cartProducts: Array<CartProduct>;
  cartQuantities: Array<Scalars['Int']['output']>;
  checkoutKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  giftActivities: Array<GiftActivity>;
  giftBatchId?: Maybe<Scalars['ID']['output']>;
  giftBatchName?: Maybe<Scalars['String']['output']>;
  giftBatchRecipientRequest?: Maybe<GiftBatchRecipientRequest>;
  giftNotificationDisabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isBook: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isEligibleForReminder?: Maybe<Scalars['Boolean']['output']>;
  isExpired: Scalars['Boolean']['output'];
  isSelfSend?: Maybe<Scalars['Boolean']['output']>;
  isSwapped: Scalars['Boolean']['output'];
  lastReminderNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  meetingInfo: GiftMeetingInfo;
  meetingStatus?: Maybe<MeetingStatus>;
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  originalAmountCreditApplied?: Maybe<Scalars['Int']['output']>;
  originalAmountProduct?: Maybe<Scalars['Int']['output']>;
  originalAmountShipping?: Maybe<Scalars['Int']['output']>;
  originalAmountTotal?: Maybe<Scalars['Int']['output']>;
  originalProductFragment?: Maybe<ProductFragment>;
  productFragment: ProductFragment;
  productTitle: Scalars['String']['output'];
  receiptId?: Maybe<Scalars['String']['output']>;
  recipientDeviceContactId?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  recipientHasBusinessEmail: Scalars['Boolean']['output'];
  recipientLastName?: Maybe<Scalars['String']['output']>;
  reminder1SentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sendMethod?: Maybe<BatchSendMethod>;
  senderFullName: Scalars['String']['output'];
  senderLink?: Maybe<Scalars['String']['output']>;
  senderPublicId: Scalars['String']['output'];
  senderSentReminderEligible?: Maybe<Scalars['Boolean']['output']>;
  senderSentReminderRecipientPhone?: Maybe<Scalars['String']['output']>;
  senderSentReminderSent?: Maybe<Scalars['Boolean']['output']>;
  senderViewAccessId?: Maybe<Scalars['String']['output']>;
  sharedAccessId?: Maybe<Scalars['String']['output']>;
  sharedLink?: Maybe<Scalars['String']['output']>;
  shipments: Array<Shipment>;
  shippedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: GiftViewableStatus;
  thankYouNote?: Maybe<Scalars['String']['output']>;
};

export type GiftAcceptInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  birthDay?: InputMaybe<Scalars['String']['input']>;
  birthMonth?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  twoFactorCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GiftAccept. */
export type GiftAcceptPayload = {
  __typename?: 'GiftAcceptPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GiftActivity = {
  __typename?: 'GiftActivity';
  createdAt: Scalars['ISO8601Date']['output'];
  giftStatus: GiftViewableStatus;
};

/** Autogenerated return type of GiftAddThankYouNote. */
export type GiftAddThankYouNotePayload = {
  __typename?: 'GiftAddThankYouNotePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GiftAttributionInput = {
  editorialItemId?: InputMaybe<Scalars['String']['input']>;
  editorialItemSourceType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GiftAutopayDisable. */
export type GiftAutopayDisablePayload = {
  __typename?: 'GiftAutopayDisablePayload';
  ok: Scalars['Boolean']['output'];
};

export type GiftBatch = {
  __typename?: 'GiftBatch';
  acceptedCount: Scalars['Int']['output'];
  autopayPaymentMethod?: Maybe<PaymentMethod>;
  autopayPaymentMethodId?: Maybe<Scalars['String']['output']>;
  autopayPaymentMethodName?: Maybe<Scalars['String']['output']>;
  batchName?: Maybe<Scalars['String']['output']>;
  batchNameFallback: Scalars['String']['output'];
  card?: Maybe<Card>;
  cardFragment?: Maybe<Card>;
  cartItemCount: Scalars['Int']['output'];
  cartProducts: Array<CartProduct>;
  cartQuantities: Array<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customEmailSubject?: Maybe<Scalars['String']['output']>;
  customStoreImageThumb?: Maybe<Image>;
  customStoreMultipleSelectMode?: Maybe<CustomStoreMultipleSelectModeEnum>;
  emailDeliveryMethod?: Maybe<EmailDeliveryMethods>;
  event?: Maybe<Event>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  failureMessages: Array<FailureMessages>;
  firstGiftDate?: Maybe<Scalars['ISO8601Date']['output']>;
  firstRecipientFullName?: Maybe<Scalars['String']['output']>;
  flexGiftPrice?: Maybe<Scalars['Int']['output']>;
  fromName: Scalars['String']['output'];
  giftCardAmount?: Maybe<Scalars['Int']['output']>;
  giftDispenser?: Maybe<GiftDispenser>;
  giftLink?: Maybe<Scalars['String']['output']>;
  giftSeries: GiftSeries;
  gifts: Array<Gift>;
  giftsEligibleForReminderCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  internationalShippingTier: InternationalShippingTierEnum;
  isAutogift: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isScheduledSend: Scalars['Boolean']['output'];
  isSmartLink?: Maybe<Scalars['Boolean']['output']>;
  landingPageEnabled?: Maybe<Scalars['Boolean']['output']>;
  landingPageSendNotifs?: Maybe<Scalars['Boolean']['output']>;
  landingPageSlug?: Maybe<Scalars['String']['output']>;
  meetingSettings?: Maybe<MeetingSettings>;
  message: Scalars['String']['output'];
  pendingSends: Scalars['Int']['output'];
  priceEstimate?: Maybe<GiftBatchPriceEstimate>;
  /** @deprecated Use product on cartProduct instead */
  product?: Maybe<Product>;
  /** @deprecated Use productDetails on cartProduct instead */
  productDetails?: Maybe<GiftBatchProductDetails>;
  /** @deprecated Use productFragment on cartProduct instead */
  productFragment: ProductFragment;
  /** @deprecated Use productTitle on cartProduct instead */
  productTitle?: Maybe<Scalars['String']['output']>;
  productUnavailable: Scalars['Boolean']['output'];
  recentAccepts: Array<Gift>;
  recipientContactInformationAvailable?: Maybe<Scalars['Boolean']['output']>;
  recipientCount: Scalars['Int']['output'];
  recipientEmails?: Maybe<Scalars['String']['output']>;
  recipientEmailsAvailable?: Maybe<Scalars['Boolean']['output']>;
  recipientSeries: GiftBatchRecipientRequestSeries;
  recipients: Array<GiftBatchRecipientRequest>;
  scheduledEvent?: Maybe<ScheduledEvent>;
  scheduledSendOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scheduledSendRecipientList?: Maybe<Array<GiftBatchPotentialRecipient>>;
  sendAudience?: Maybe<SendAudience>;
  sendMethod?: Maybe<BatchSendMethod>;
  sendStatus: GiftBatchSendStatus;
  senderPublicId: Scalars['String']['output'];
  settings: GiftsSettings;
  smartLinkActive?: Maybe<Scalars['Boolean']['output']>;
  smartLinkAwaitingApprovalCount?: Maybe<Scalars['Int']['output']>;
  smartLinkClaimedCount?: Maybe<Scalars['Int']['output']>;
  smartLinkQuantity?: Maybe<Scalars['Int']['output']>;
  statistics: GiftOptionStatistics;
  swapEnabled: Scalars['Boolean']['output'];
  swapType?: Maybe<GiftSwapTypeEnum>;
  tenure?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Theme>;
  userFullName: Scalars['String']['output'];
  userPublicId: Scalars['ID']['output'];
  weeklyRemindersEnabled: Scalars['Boolean']['output'];
};


export type GiftBatchGiftSeriesArgs = {
  filter: GiftSeriesFilter;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type GiftBatchRecipientSeriesArgs = {
  filter: GiftSeriesFilter;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GiftBatchCancel. */
export type GiftBatchCancelPayload = {
  __typename?: 'GiftBatchCancelPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftBatchCancelPendingGifts. */
export type GiftBatchCancelPendingGiftsPayload = {
  __typename?: 'GiftBatchCancelPendingGiftsPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftBatchCreate. */
export type GiftBatchCreatePayload = {
  __typename?: 'GiftBatchCreatePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  giftBatch?: Maybe<GiftBatch>;
  id?: Maybe<Scalars['ID']['output']>;
  isScheduledSend?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
  recipientErrors?: Maybe<Array<GiftBatchRecipientError>>;
  refreshPrice?: Maybe<Scalars['Boolean']['output']>;
  salesforceEventData?: Maybe<Array<SalesforceEventData>>;
};

export type GiftBatchFiltersInput = {
  giftStatus?: InputMaybe<GiftSeriesFilter>;
  onlyMyGifts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: Use recipient_search instead. Filter by recipient emails (substring match). */
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search terms to match against recipient name/email, batch name, batch message, and sender display name. Also searches pending recipient requests and scheduled send recipients. */
  recipientSearch?: InputMaybe<Array<Scalars['String']['input']>>;
  sendType?: InputMaybe<SendTypeEnum>;
  sentAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  sentBefore?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Data needed to create a gift batch */
export type GiftBatchInput = {
  aiChatInfo?: InputMaybe<AiChatInfoInput>;
  alcoholAgeVerificationAttested?: InputMaybe<Scalars['Boolean']['input']>;
  autopayPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  autopayPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  batchName?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardInput?: InputMaybe<PaymentMethodCreditCardInput>;
  cart?: InputMaybe<Array<CartProductInput>>;
  customEmailSubject?: InputMaybe<Scalars['String']['input']>;
  emailDeliveryMethod?: InputMaybe<EmailDeliveryMethods>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  flexGiftPrice?: InputMaybe<Scalars['Int']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  giftAttribution?: InputMaybe<GiftAttributionInput>;
  giftCalendarSetting?: InputMaybe<Gift_Meeting_Setting>;
  giftCardAmount?: InputMaybe<Scalars['Int']['input']>;
  giftDispenserQuantity?: InputMaybe<Scalars['Int']['input']>;
  giftTemplate?: InputMaybe<GiftTemplateInput>;
  giveawayId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  installationId?: InputMaybe<Scalars['String']['input']>;
  internationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  isGiftDispenser?: InputMaybe<Scalars['Boolean']['input']>;
  isSmartLink?: InputMaybe<Scalars['Boolean']['input']>;
  landingPageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  landingPageSendNotifs?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageAssistantInfo?: InputMaybe<MessageAssistantInfoInput>;
  occasionId?: InputMaybe<Scalars['ID']['input']>;
  omitCredit?: InputMaybe<Scalars['Boolean']['input']>;
  priceEstimate?: InputMaybe<GiftBatchPriceEstimateInput>;
  priceEstimates?: InputMaybe<PriceEstimatesInput>;
  productDetails?: InputMaybe<GiftBatchProductDetailsInput>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<GiftBatchRecipientInput>;
  referringCategoryId?: InputMaybe<Scalars['String']['input']>;
  referringOccasionvcId?: InputMaybe<Scalars['String']['input']>;
  salesforceGiftBatchData?: InputMaybe<SalesforceGiftBatchDataInput>;
  scheduledSendOn?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sendAudience?: InputMaybe<SendAudience>;
  sendMethod?: InputMaybe<BatchSendMethod>;
  sendType?: InputMaybe<SendTypeEnum>;
  settings?: InputMaybe<GiftsSettingsInput>;
  smartLinkApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  smartLinkQuantity?: InputMaybe<Scalars['Int']['input']>;
  statsigStableId?: InputMaybe<Scalars['String']['input']>;
  swapEnabled: Scalars['Boolean']['input'];
  swapType?: InputMaybe<GiftSwapTypeEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  theme?: InputMaybe<ThemeInput>;
  topUpAmount?: InputMaybe<Scalars['Int']['input']>;
  topUpPaymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};

export type GiftBatchPlusPriceEstimateInput = {
  balance?: InputMaybe<Scalars['Int']['input']>;
  creditApplied: Scalars['Int']['input'];
  creditAvailable: Scalars['Int']['input'];
  creditAvailableToApply?: InputMaybe<Scalars['Int']['input']>;
  estGroupTotalHigh: Scalars['Int']['input'];
  estGroupTotalLow: Scalars['Int']['input'];
  estPreCreditSubtotalHigh: Scalars['Int']['input'];
  estPreCreditSubtotalLow: Scalars['Int']['input'];
  recipients: Scalars['Int']['input'];
};

export type GiftBatchPotentialRecipient = {
  __typename?: 'GiftBatchPotentialRecipient';
  companyName?: Maybe<Scalars['String']['output']>;
  deviceContactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MailingAddress>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Price estimate for the given batch */
export type GiftBatchPriceEstimate = {
  __typename?: 'GiftBatchPriceEstimate';
  isFlexGift?: Maybe<Scalars['Boolean']['output']>;
  priceEstTaxHigh?: Maybe<Scalars['Int']['output']>;
  priceEstTaxLow?: Maybe<Scalars['Int']['output']>;
  priceEstTotalHigh?: Maybe<Scalars['Int']['output']>;
  priceEstTotalLow?: Maybe<Scalars['Int']['output']>;
  pricePreTax?: Maybe<Scalars['Int']['output']>;
  priceProcessingFee?: Maybe<Scalars['Int']['output']>;
  priceProduct?: Maybe<Scalars['Int']['output']>;
  priceShipping?: Maybe<Scalars['Int']['output']>;
};

/** Price estimate seen by the user for the given batch */
export type GiftBatchPriceEstimateInput = {
  creditApplied?: InputMaybe<Scalars['Int']['input']>;
  isFlexGift?: InputMaybe<Scalars['Boolean']['input']>;
  plusPriceEstimate: GiftBatchPlusPriceEstimateInput;
  priceEstTaxHigh: Scalars['Int']['input'];
  priceEstTaxLow: Scalars['Int']['input'];
  priceEstTotalHigh: Scalars['Int']['input'];
  priceEstTotalLow: Scalars['Int']['input'];
  pricePreTax: Scalars['Int']['input'];
  priceProcessingFee: Scalars['Int']['input'];
  priceProduct: Scalars['Int']['input'];
  priceShipping: Scalars['Int']['input'];
};

/** For any data specific to the gifted product of the gift batch */
export type GiftBatchProductDetails = {
  __typename?: 'GiftBatchProductDetails';
  bookContributors?: Maybe<Scalars['String']['output']>;
  bookEan?: Maybe<Scalars['String']['output']>;
  bookImage?: Maybe<Scalars['String']['output']>;
  bookImageAvailable?: Maybe<Scalars['Boolean']['output']>;
  bookIsbn?: Maybe<Scalars['String']['output']>;
  bookPrice?: Maybe<Scalars['Int']['output']>;
  bookTitle?: Maybe<Scalars['String']['output']>;
};

/** For any data specific to the gifted product of the gift batch */
export type GiftBatchProductDetailsInput = {
  bookContributors?: InputMaybe<Scalars['String']['input']>;
  bookEan?: InputMaybe<Scalars['String']['input']>;
  bookIsbn?: InputMaybe<Scalars['String']['input']>;
  bookTitle?: InputMaybe<Scalars['String']['input']>;
};

export type GiftBatchRecipientError = {
  __typename?: 'GiftBatchRecipientError';
  addressSuggestion?: Maybe<StructuredAddress>;
  error: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
};

export type GiftBatchRecipientInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  deviceContactId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<MailingAddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salesforceRecipientData?: InputMaybe<SalesforceRecipientDataInput>;
  scheduledEventId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GiftRecipientType>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type GiftBatchRecipientRequest = {
  __typename?: 'GiftBatchRecipientRequest';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gift?: Maybe<Gift>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MailingAddress>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type GiftBatchRecipientRequestSeries = {
  __typename?: 'GiftBatchRecipientRequestSeries';
  items: Array<GiftBatchRecipientRequest>;
  totalCount: Scalars['Int']['output'];
};

export enum GiftBatchSendStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Complete */
  Complete = 'COMPLETE',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING'
}

/** Autogenerated return type of GiftBatchSmartLinkDeactivate. */
export type GiftBatchSmartLinkDeactivatePayload = {
  __typename?: 'GiftBatchSmartLinkDeactivatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftBatchSmartLinkUpdateQuantity. */
export type GiftBatchSmartLinkUpdateQuantityPayload = {
  __typename?: 'GiftBatchSmartLinkUpdateQuantityPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftBatchUpdateMeetingSettings. */
export type GiftBatchUpdateMeetingSettingsPayload = {
  __typename?: 'GiftBatchUpdateMeetingSettingsPayload';
  errors?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftBatchUpdate. */
export type GiftBatchUpdatePayload = {
  __typename?: 'GiftBatchUpdatePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  giftBatch?: Maybe<GiftBatch>;
  id?: Maybe<Scalars['ID']['output']>;
  isScheduledSend?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
  recipientErrors?: Maybe<Array<GiftBatchRecipientError>>;
  refreshPrice?: Maybe<Scalars['Boolean']['output']>;
};

/** Data needed to update a sent gift batch */
export type GiftBatchUpdateSentBatchInput = {
  batchName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GiftBatchUpdateSentBatch. */
export type GiftBatchUpdateSentBatchPayload = {
  __typename?: 'GiftBatchUpdateSentBatchPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftCancel. */
export type GiftCancelPayload = {
  __typename?: 'GiftCancelPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  refundedCreditAmount?: Maybe<Scalars['Int']['output']>;
};

export type GiftCardInfo = {
  __typename?: 'GiftCardInfo';
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  /** Array of available denominations, as dollar integers. Empty if this gift card has a sliding scale of denominations, where the range is limited by value_restrictions. */
  denominations: Array<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiryAndValidity?: Maybe<Scalars['String']['output']>;
  howToUse?: Maybe<Scalars['String']['output']>;
  /** Whether this is a sliding-scale denomination gift card */
  isSlidingScale: Scalars['Boolean']['output'];
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  /** If this gift card is a sliding scale denominations card, this contains an object with the min and max denominations */
  valueRestrictions?: Maybe<GiftCardInfoValueRestrictions>;
};

export type GiftCardInfoValueRestrictions = {
  __typename?: 'GiftCardInfoValueRestrictions';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type GiftCardVoucher = {
  __typename?: 'GiftCardVoucher';
  code?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Scalars['JSON']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GiftCartProduct = {
  __typename?: 'GiftCartProduct';
  cartProduct: CartProduct;
  cartProductId: Scalars['ID']['output'];
  customResponses?: Maybe<Array<Scalars['JSON']['output']>>;
  giftCardVoucher?: Maybe<GiftCardVoucher>;
  id: Scalars['ID']['output'];
  isOrdered: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  quantityIndex: Scalars['Int']['output'];
  variants?: Maybe<Array<Scalars['String']['output']>>;
};

export type GiftCartProductInput = {
  customResponses?: InputMaybe<Array<Scalars['JSON']['input']>>;
  id: Scalars['ID']['input'];
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GiftCollectionTier = {
  __typename?: 'GiftCollectionTier';
  colorToken: GiftCollectionTierColorEnum;
  giftOptions: Array<GiftOption>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceMax: Scalars['Int']['output'];
  priceMin: Scalars['Int']['output'];
  products: Array<Product>;
};

export enum GiftCollectionTierColorEnum {
  /** gold */
  Gold = 'gold',
  /** grey */
  Grey = 'grey',
  /** purple */
  Purple = 'purple'
}

/** Autogenerated return type of GiftConfirmPostAcceptVariantSwap. */
export type GiftConfirmPostAcceptVariantSwapPayload = {
  __typename?: 'GiftConfirmPostAcceptVariantSwapPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftCreate. */
export type GiftCreatePayload = {
  __typename?: 'GiftCreatePayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
  senderViewAccessId?: Maybe<Scalars['String']['output']>;
  sharedLink?: Maybe<Scalars['String']['output']>;
};

export type GiftDispenser = {
  __typename?: 'GiftDispenser';
  id: Scalars['ID']['output'];
  productFragment: ProductFragment;
  quantityAccepted: Scalars['Int']['output'];
  quantityAvailable: Scalars['Int']['output'];
  quantityPendingNotExpired: Scalars['Int']['output'];
  quantityTotal: Scalars['Int']['output'];
  sharedLink: Scalars['String']['output'];
  status: GiftDispenserStatus;
};

/** Autogenerated return type of GiftDispenserClose. */
export type GiftDispenserClosePayload = {
  __typename?: 'GiftDispenserClosePayload';
  ok: Scalars['Boolean']['output'];
};

export enum GiftDispenserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Closed */
  Closed = 'CLOSED'
}

/** Data needed to create a gift */
export type GiftInput = {
  alcoholAgeVerificationAttested?: InputMaybe<Scalars['Boolean']['input']>;
  autopayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autopayPaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  autopayPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  bookContributors?: InputMaybe<Scalars['String']['input']>;
  bookEan?: InputMaybe<Scalars['String']['input']>;
  bookIsbn?: InputMaybe<Scalars['String']['input']>;
  bookTitle?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardInput?: InputMaybe<PaymentMethodCreditCardInput>;
  cart?: InputMaybe<Array<CartProductInput>>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  creditApplied?: InputMaybe<Scalars['Int']['input']>;
  displayedSharePhoneWithRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  flexGiftPrice?: InputMaybe<Scalars['Int']['input']>;
  giftAttribution?: InputMaybe<GiftAttributionInput>;
  giftCardAmount?: InputMaybe<Scalars['Int']['input']>;
  giftDispenserQuantity?: InputMaybe<Scalars['Int']['input']>;
  giveawayId?: InputMaybe<Scalars['ID']['input']>;
  installationId?: InputMaybe<Scalars['String']['input']>;
  isBook?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexGift?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  occasionId?: InputMaybe<Scalars['ID']['input']>;
  omitCredit?: InputMaybe<Scalars['Boolean']['input']>;
  priceCreditApplied?: InputMaybe<Scalars['Int']['input']>;
  priceEstTaxHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTaxLow?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalLow?: InputMaybe<Scalars['Int']['input']>;
  priceEstimates?: InputMaybe<PriceEstimatesInput>;
  pricePreTax?: InputMaybe<Scalars['Int']['input']>;
  priceProduct?: InputMaybe<Scalars['Int']['input']>;
  priceShipping?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recipientDeviceContactId?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientFirstName: Scalars['String']['input'];
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<GiftRecipientType>;
  recipientUsername?: InputMaybe<Scalars['String']['input']>;
  referringCategoryId?: InputMaybe<Scalars['String']['input']>;
  referringOccasionvcId?: InputMaybe<Scalars['String']['input']>;
  scheduledEventId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum GiftMeetingConfiguration {
  /** GIFT_FIRST */
  GiftFirst = 'GIFT_FIRST',
  /** MEETING_REQUIRED */
  MeetingRequired = 'MEETING_REQUIRED',
  /** NO_MEETING */
  NoMeeting = 'NO_MEETING'
}

export type GiftMeetingInfo = {
  __typename?: 'GiftMeetingInfo';
  calendarUrl?: Maybe<Scalars['String']['output']>;
  meetingConfiguration?: Maybe<GiftMeetingConfiguration>;
  meetingScheduled: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftMessageGeneratorRefine. */
export type GiftMessageGeneratorRefinePayload = {
  __typename?: 'GiftMessageGeneratorRefinePayload';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftMessageGeneratorSuggestCollaborative. */
export type GiftMessageGeneratorSuggestCollaborativePayload = {
  __typename?: 'GiftMessageGeneratorSuggestCollaborativePayload';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftMessageGeneratorSuggest. */
export type GiftMessageGeneratorSuggestPayload = {
  __typename?: 'GiftMessageGeneratorSuggestPayload';
  error?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GiftOption = GiftOptionInterface & {
  __typename?: 'GiftOption';
  brand: Brand;
  colors: GiftOptionColors;
  description?: Maybe<Scalars['String']['output']>;
  giftOptionImages: Array<GiftOptionImage>;
  id: Scalars['ID']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isSingleProduct?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Image>;
  name: Scalars['String']['output'];
  priceMax?: Maybe<Scalars['Int']['output']>;
  priceMaxWithShipping?: Maybe<Scalars['Int']['output']>;
  priceMin?: Maybe<Scalars['Int']['output']>;
  prices: Array<Scalars['Int']['output']>;
  primaryImage?: Maybe<GiftOptionImage>;
  products: Array<Product>;
  recommendedOccasionIds?: Maybe<Array<Scalars['String']['output']>>;
  sections: Array<GiftOptionSection>;
  seo: GiftOptionSeo;
  shippingCountryGroup: ShippingCountryGroup;
  singleProductMode: Scalars['Boolean']['output'];
  singleProductSlug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: GiftOptionStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type GiftOptionProductsArgs = {
  flexGiftMinimumPrice?: InputMaybe<Scalars['Int']['input']>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GiftOptionColors = {
  __typename?: 'GiftOptionColors';
  background?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
};

/** The connection type for GiftOption. */
export type GiftOptionConnection = {
  __typename?: 'GiftOptionConnection';
  /** A list of edges. */
  edges: Array<GiftOptionEdge>;
  /** A list of nodes. */
  nodes: Array<GiftOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GiftOptionEdge = {
  __typename?: 'GiftOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftOption>;
};

export type GiftOptionFiltersInput = {
  status?: InputMaybe<Array<StatusEnum>>;
};

export type GiftOptionImage = {
  __typename?: 'GiftOptionImage';
  id: Scalars['ID']['output'];
  image: Image;
  imageLarge: Image;
  imageXlarge: Image;
  imageXlarge2: Image;
};

export type GiftOptionInterface = {
  brand: Brand;
  colors: GiftOptionColors;
  description?: Maybe<Scalars['String']['output']>;
  giftOptionImages: Array<GiftOptionImage>;
  id: Scalars['ID']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isSingleProduct?: Maybe<Scalars['Boolean']['output']>;
  logoImage?: Maybe<Image>;
  name: Scalars['String']['output'];
  priceMax?: Maybe<Scalars['Int']['output']>;
  priceMin?: Maybe<Scalars['Int']['output']>;
  prices: Array<Scalars['Int']['output']>;
  primaryImage?: Maybe<GiftOptionImage>;
  recommendedOccasionIds?: Maybe<Array<Scalars['String']['output']>>;
  sections: Array<GiftOptionSection>;
  seo: GiftOptionSeo;
  shippingCountryGroup: ShippingCountryGroup;
  singleProductMode: Scalars['Boolean']['output'];
  singleProductSlug?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: GiftOptionStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type GiftOptionSection = {
  __typename?: 'GiftOptionSection';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productList: Array<Scalars['ID']['output']>;
};

export type GiftOptionSeo = {
  __typename?: 'GiftOptionSeo';
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
};

export type GiftOptionStatistics = {
  __typename?: 'GiftOptionStatistics';
  summaryAccepted: Scalars['Int']['output'];
  summaryWaiting: Scalars['Int']['output'];
};

export enum GiftOptionStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Inactive */
  Inactive = 'INACTIVE'
}

/** Autogenerated return type of GiftPay. */
export type GiftPayPayload = {
  __typename?: 'GiftPayPayload';
  complete: Scalars['Boolean']['output'];
  requiresAction?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of GiftPaymentCheck. */
export type GiftPaymentCheckPayload = {
  __typename?: 'GiftPaymentCheckPayload';
  complete: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftRecipientCheckoutCreate. */
export type GiftRecipientCheckoutCreatePayload = {
  __typename?: 'GiftRecipientCheckoutCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Recipient Top Up: overage breakdown for the recipient checkout */
export type GiftRecipientCheckoutEstimate = {
  __typename?: 'GiftRecipientCheckoutEstimate';
  amountProductCents: Scalars['Int']['output'];
  amountShippingCents: Scalars['Int']['output'];
  amountTaxCents: Scalars['Int']['output'];
  amountTotalCents: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export enum GiftRecipientType {
  /** Contact */
  Contact = 'CONTACT',
  /** Gift Dispenser */
  GiftDispenser = 'GIFT_DISPENSER',
  /** Manual Email */
  ManualEmail = 'MANUAL_EMAIL',
  /** Manual Phone */
  ManualPhone = 'MANUAL_PHONE',
  /** Self Send */
  SelfSend = 'SELF_SEND',
  /** Username */
  Username = 'USERNAME'
}

/** Autogenerated return type of GiftRecordMeetingScheduled. */
export type GiftRecordMeetingScheduledPayload = {
  __typename?: 'GiftRecordMeetingScheduledPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftSendTwoFactorCode. */
export type GiftSendTwoFactorCodePayload = {
  __typename?: 'GiftSendTwoFactorCodePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftSenderSentReminderRecordSend. */
export type GiftSenderSentReminderRecordSendPayload = {
  __typename?: 'GiftSenderSentReminderRecordSendPayload';
  ok: Scalars['Boolean']['output'];
};

export type GiftSeries = {
  __typename?: 'GiftSeries';
  items: Array<Gift>;
  totalCount: Scalars['Int']['output'];
};

export enum GiftSeriesFilter {
  All = 'all',
  Delivered = 'delivered',
  NotYetAccepted = 'not_yet_accepted',
  Notified = 'notified',
  Opened = 'opened',
  PendingSelfSend = 'pending_self_send',
  RecentlyAccepted = 'recently_accepted',
  Shipped = 'shipped'
}

/** Autogenerated return type of GiftSwapBack. */
export type GiftSwapBackPayload = {
  __typename?: 'GiftSwapBackPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftSwap. */
export type GiftSwapPayload = {
  __typename?: 'GiftSwapPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export enum GiftSwapTypeEnum {
  SwapDisabled = 'swap_disabled',
  SwapMultiple = 'swap_multiple',
  SwapSingle = 'swap_single'
}

export type GiftTemplate = {
  __typename?: 'GiftTemplate';
  card: Card;
  category: Scalars['String']['output'];
  flexGiftPrice?: Maybe<Scalars['Int']['output']>;
  giftCardAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  products: Array<Product>;
  subcategory: Scalars['String']['output'];
};

export type GiftTemplateInput = {
  cardId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of GiftUpdateCurrentCountryOverride. */
export type GiftUpdateCurrentCountryOverridePayload = {
  __typename?: 'GiftUpdateCurrentCountryOverridePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of GiftUserApproval. */
export type GiftUserApprovalPayload = {
  __typename?: 'GiftUserApprovalPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum GiftViewableStatus {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Created */
  Created = 'CREATED',
  /** Delivered */
  Delivered = 'DELIVERED',
  /** Failed */
  Failed = 'FAILED',
  /** Notified */
  Notified = 'NOTIFIED',
  /** Opened */
  Opened = 'OPENED',
  /** Ordered */
  Ordered = 'ORDERED',
  /** Paid */
  Paid = 'PAID',
  /** Pending Payment */
  PendingPayment = 'PENDING_PAYMENT',
  /** Pending User Approval */
  PendingUserApproval = 'PENDING_USER_APPROVAL',
  /** Shipped */
  Shipped = 'SHIPPED',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type GiftsPaginatedSeries = {
  __typename?: 'GiftsPaginatedSeries';
  items: Array<Gift>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GiftsSettings = {
  __typename?: 'GiftsSettings';
  allowRecipientTopup: Scalars['Boolean']['output'];
  giftCardsEnabled: Scalars['Boolean']['output'];
  smartLinkWorkEmailRequired: Scalars['Boolean']['output'];
};

/** Attributes for updating gift settings */
export type GiftsSettingsInput = {
  allowRecipientTopup?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smartLinkWorkEmailRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Giveaway = {
  __typename?: 'Giveaway';
  autoRefresh: Scalars['Boolean']['output'];
  brandGiftOption?: Maybe<GiftOption>;
  giftOption: GiftOption;
  hasUserGift: Scalars['Boolean']['output'];
  headerSubtitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageLarge?: Maybe<Image>;
  label: Scalars['String']['output'];
  outDescription?: Maybe<Scalars['String']['output']>;
  outTagline?: Maybe<Scalars['String']['output']>;
  outTitle?: Maybe<Scalars['String']['output']>;
  product: Product;
  quantityRemaining: Scalars['Int']['output'];
};

export type HrisConfiguration = {
  __typename?: 'HrisConfiguration';
  enabled: Scalars['Boolean']['output'];
  filters: Array<HrisConfigurationFilter>;
  groupingField?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HrisConfigurationFilter = {
  __typename?: 'HrisConfigurationFilter';
  attribute: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type HrisConfigurationFilterInput = {
  attribute: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type HrisConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<HrisConfigurationFilterInput>>;
  groupingField?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type HrisExclusion = {
  __typename?: 'HrisExclusion';
  attribute: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type HrisExclusionInput = {
  attribute: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HrisExclusions = {
  __typename?: 'HrisExclusions';
  employee: Array<HrisExclusion>;
};

export type HrisExclusionsInput = {
  employee: Array<HrisExclusionInput>;
};

export type HrisFilterOption = {
  __typename?: 'HrisFilterOption';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HrisFilterOptions = {
  __typename?: 'HrisFilterOptions';
  attribute: Scalars['String']['output'];
  filterOptions: Array<HrisFilterOption>;
};

export type HrisGroup = {
  __typename?: 'HrisGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  remoteId: Scalars['String']['output'];
};

export type HrisIntegration = {
  __typename?: 'HrisIntegration';
  adapter: HrisIntegrationAdapterEnum;
  configurations: Array<HrisConfiguration>;
  customMappings?: Maybe<HrisMappings>;
  exclusions: HrisExclusions;
  filterOptions: Array<HrisFilterOptions>;
  groups: Array<HrisGroup>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextSyncAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publicId: Scalars['String']['output'];
  state: HrisIntegrationStateEnum;
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum HrisIntegrationAdapterEnum {
  Merge = 'Merge',
  Rippling = 'Rippling'
}

export type HrisIntegrationConfirmInput = {
  merge?: InputMaybe<HrisIntegrationConfirmMergeInput>;
};

export type HrisIntegrationConfirmMergeInput = {
  publicToken: Scalars['String']['input'];
};

export type HrisIntegrationConnectData = HrisIntegrationConnectDataMerge;

export type HrisIntegrationConnectDataMerge = {
  __typename?: 'HrisIntegrationConnectDataMerge';
  linkToken: Scalars['String']['output'];
};

export enum HrisIntegrationStateEnum {
  Connected = 'connected',
  Connecting = 'connecting',
  Disconnected = 'disconnected',
  Enqueued = 'enqueued',
  Pending = 'pending',
  Reconnecting = 'reconnecting',
  Stuck = 'stuck',
  Syncing = 'syncing'
}

export type HrisMapping = {
  __typename?: 'HrisMapping';
  attribute: Scalars['String']['output'];
  rules: Array<HrisMappingRule>;
};

export type HrisMappingInput = {
  attribute: Scalars['String']['input'];
  rules?: InputMaybe<Array<HrisMappingRuleInput>>;
};

export type HrisMappingRule = {
  __typename?: 'HrisMappingRule';
  data?: Maybe<Array<Scalars['String']['output']>>;
  type: MappingRuleTypeEnum;
};

export type HrisMappingRuleInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  type: MappingRuleTypeEnum;
};

export type HrisMappings = {
  __typename?: 'HrisMappings';
  employee: Array<HrisMapping>;
};

export type HrisMappingsInput = {
  employee: Array<HrisMappingInput>;
};

export type Identity = {
  __typename?: 'Identity';
  canSendEmailOnBehalf: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  provider: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of IdentityCreate. */
export type IdentityCreatePayload = {
  __typename?: 'IdentityCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  errorIsEmail?: Maybe<Scalars['Boolean']['output']>;
  errorIsPassword?: Maybe<Scalars['Boolean']['output']>;
  identity?: Maybe<Identity>;
  ok: Scalars['Boolean']['output'];
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  acsUrl: Scalars['String']['output'];
  certificate?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  samlId: Scalars['String']['output'];
  spEntityId: Scalars['String']['output'];
  ssoUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of IdentityUpdate. */
export type IdentityUpdatePayload = {
  __typename?: 'IdentityUpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  errorIsNewPassword?: Maybe<Scalars['Boolean']['output']>;
  errorIsPassword?: Maybe<Scalars['Boolean']['output']>;
  identity?: Maybe<Identity>;
  ok: Scalars['Boolean']['output'];
};

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  monochrome?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageBanner = {
  __typename?: 'ImageBanner';
  image: Image;
};

export type InfoBanner = {
  __typename?: 'InfoBanner';
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
  showOtaUpdate?: Maybe<Scalars['Boolean']['output']>;
};

export type InfoBannerDeviceInfoInput = {
  installationId?: InputMaybe<Scalars['String']['input']>;
  nativeAppVersion?: InputMaybe<Scalars['String']['input']>;
  nativeBuildVersion?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  releaseChannel?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['String']['input']>;
  updateId?: InputMaybe<Scalars['String']['input']>;
};

export enum InternationalShippingTierEnum {
  /** Disabled */
  Disabled = 'disabled',
  /** Full */
  Full = 'full',
  /** Standard */
  Standard = 'standard'
}

export enum InviteMembersPermission {
  Managers = 'MANAGERS',
  MembersAndManagers = 'MEMBERS_AND_MANAGERS'
}

export type InvoiceRequestInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  addressCity: Scalars['String']['input'];
  addressPostalCode: Scalars['String']['input'];
  addressState: Scalars['String']['input'];
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum ItemTypeEnum {
  Digital = 'digital',
  GiftCard = 'gift_card',
  Physical = 'physical'
}

/** Autogenerated return type of LeaveWorkspace. */
export type LeaveWorkspacePayload = {
  __typename?: 'LeaveWorkspacePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum LinkType {
  /** Draft */
  Draft = 'draft',
  /** Recipient */
  Recipient = 'recipient',
  /** Sender */
  Sender = 'sender',
  /** Shared */
  Shared = 'shared'
}

export type List = {
  __typename?: 'List';
  id: Scalars['ID']['output'];
  items: Array<ListItem>;
  ttype: ListTtype;
};

export type ListItem = {
  __typename?: 'ListItem';
  giftOption?: Maybe<GiftOption>;
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
  ttype: ListItemTtype;
};

/** Autogenerated return type of ListItemCreate. */
export type ListItemCreatePayload = {
  __typename?: 'ListItemCreatePayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ListItemDestroy. */
export type ListItemDestroyPayload = {
  __typename?: 'ListItemDestroyPayload';
  ok: Scalars['Boolean']['output'];
};

export enum ListItemTtype {
  /** Gift Option */
  GiftOption = 'GIFT_OPTION',
  /** Product */
  Product = 'PRODUCT'
}

export enum ListTtype {
  /** Wishlist */
  Wishlist = 'WISHLIST'
}

export type MailingAddress = {
  __typename?: 'MailingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MailingAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export enum MappingRuleTypeEnum {
  FieldMapping = 'field_mapping',
  Value = 'value'
}

export type Me = {
  __typename?: 'Me';
  allowGiftsViaUsername: Scalars['Boolean']['output'];
  apiTokens: Array<ApiToken>;
  balance?: Maybe<Scalars['Int']['output']>;
  balanceAccount?: Maybe<BalanceAccount>;
  balanceDeposits: Array<BalanceDeposit>;
  batchBillingGroups: Array<BatchBillingGroup>;
  budgetRule?: Maybe<BudgetRule>;
  bundledReceipts: Array<BundledReceipt>;
  businessBillingAddress?: Maybe<MailingAddress>;
  businessReferralInfo?: Maybe<BusinessReferralInfo>;
  calendarIntegration?: Maybe<CalendarIntegration>;
  canStoreReview?: Maybe<Scalars['Boolean']['output']>;
  coins: Scalars['Int']['output'];
  coinsBirthdayRemainingUnredeemed: Scalars['Int']['output'];
  coinsCreditRedemptionOffer: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  companyTitle?: Maybe<Scalars['String']['output']>;
  contactLists: Array<ContactList>;
  contacts?: Maybe<Array<Contact>>;
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtUnix: Scalars['String']['output'];
  credit: Scalars['Int']['output'];
  crmId: Scalars['ID']['output'];
  customCards: Array<Card>;
  customStore?: Maybe<CustomStore>;
  customStores: Array<CustomStore>;
  dismissedScreens: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  eventRequestsPending: Scalars['Int']['output'];
  featureAccess: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<Gift>;
  giftBatch?: Maybe<GiftBatch>;
  giftBatchTypeCount: Scalars['Int']['output'];
  giftBatches: Array<GiftBatch>;
  giftBatchesCount: Scalars['Int']['output'];
  giftCount: Scalars['Int']['output'];
  giftDispensers: Array<GiftDispenser>;
  giftTemplates: Array<GiftTemplate>;
  gifts: Array<Gift>;
  giftsPaginated: GiftsPaginatedSeries;
  hasBalanceTransaction: Scalars['Boolean']['output'];
  hasCreatedAGiftBatch: Scalars['Boolean']['output'];
  hasPaidPlan: Scalars['Boolean']['output'];
  hasPendingGiftBatch: Scalars['Boolean']['output'];
  hasSendingInProgressGiftBatch: Scalars['Boolean']['output'];
  hrisIntegration?: Maybe<HrisIntegration>;
  id: Scalars['ID']['output'];
  identities: Array<Identity>;
  identity?: Maybe<Identity>;
  isDelinquent: Scalars['Boolean']['output'];
  /** @deprecated Seats fields have been deprecated */
  isFullOrganizationMember: Scalars['Boolean']['output'];
  isOrganizationAdmin: Scalars['Boolean']['output'];
  kustomerJwt: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastRealm?: Maybe<RealmTtype>;
  lastSendAudience?: Maybe<SendAudience>;
  lastUsedWorkspace?: Maybe<Workspace>;
  lists: Array<List>;
  locationText?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  paymentManagerKey: Scalars['String']['output'];
  paymentMethods: Array<PaymentMethod>;
  pendingSmartLinkApprovalCount: Scalars['Int']['output'];
  pendingSmartLinkApprovals: Array<Gift>;
  phone?: Maybe<Scalars['String']['output']>;
  plusEnrolled: Scalars['Boolean']['output'];
  plusEnrolledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  plusEnrollmentStatus: PlusEnrollmentStatus;
  plusEnrollmentUpgradeRequested: Scalars['Boolean']['output'];
  plusLimitedGiftCount?: Maybe<Scalars['Int']['output']>;
  publicId: Scalars['ID']['output'];
  recentBudgetSettings: Array<RecentBudgetSetting>;
  recentlyAcceptedGifts: Array<Gift>;
  referralBanner?: Maybe<ReferralBanner>;
  samlBlocked: Scalars['Boolean']['output'];
  scheduledGiftBatches: Array<GiftBatch>;
  showZeroBalance: Scalars['Boolean']['output'];
  staffAccessActive: Scalars['Boolean']['output'];
  subscription?: Maybe<UserSubscription>;
  subscriptionsAll: Array<UserSubscription>;
  suggestedUsername?: Maybe<Scalars['String']['output']>;
  upcomingEvents?: Maybe<Array<ScheduledEvent>>;
  userHash: Scalars['String']['output'];
  userHashAndroid: Scalars['String']['output'];
  userHashIos: Scalars['String']['output'];
  userSignalsChannel: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
  workspaces: Array<Workspace>;
};


export type MeCanStoreReviewArgs = {
  source: StoreReviewSource;
};


export type MeContactsArgs = {
  listId?: InputMaybe<Scalars['ID']['input']>;
  segment?: InputMaybe<CategorySegment>;
};


export type MeContactsCountArgs = {
  segment?: InputMaybe<CategorySegment>;
};


export type MeCustomStoreArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MeGiftArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  senderViewAccessId?: InputMaybe<Scalars['String']['input']>;
};


export type MeGiftBatchArgs = {
  id: Scalars['ID']['input'];
};


export type MeGiftBatchesArgs = {
  onlyMyGifts?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type MeGiftBatchesCountArgs = {
  onlyMyGifts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeGiftDispensersArgs = {
  onlyRecent?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<BusinessSegment>;
};


export type MeGiftsArgs = {
  readyForCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeGiftsPaginatedArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  readyForCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeIdentityArgs = {
  provider: Scalars['String']['input'];
};


export type MePaymentMethodsArgs = {
  onlyPersisted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeScheduledGiftBatchesArgs = {
  sendType?: InputMaybe<Scalars['String']['input']>;
};


export type MeUpcomingEventsArgs = {
  anchorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  segment: CategorySegment;
};


export type MeWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type MeetingSettings = {
  __typename?: 'MeetingSettings';
  giftSetting: Gift_Meeting_Setting;
};

export type MeetingStatus = {
  __typename?: 'MeetingStatus';
  meetingScheduled?: Maybe<Scalars['Boolean']['output']>;
};

export type Member = {
  __typename?: 'Member';
  companyTitle?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
};

/** Information about the AI Message Assistant usage */
export type MessageAssistantInfoInput = {
  assistantVersion: Scalars['Int']['input'];
  autopilotCategory?: InputMaybe<Scalars['String']['input']>;
  autopilotSubcategory?: InputMaybe<Scalars['String']['input']>;
  generatedMessage: Scalars['String']['input'];
  generationId?: InputMaybe<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
};

export enum MultipleSelectModeEnum {
  Disabled = 'disabled',
  ItemCount = 'item_count',
  MaxPrice = 'max_price'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptanceRecentlyViewedProductsFetch: AcceptanceRecentlyViewedProductsFetchPayload;
  acceptanceRecommendationsFetch?: Maybe<AcceptanceRecommendationsFetchPayload>;
  acceptanceRecommendationsGenerateTopics?: Maybe<AcceptanceRecommendationsGenerateTopicsPayload>;
  acceptanceStoreEventRecord: AcceptanceStoreEventRecordPayload;
  accessRequestCreate: AccessRequestCreatePayload;
  aiChatRecipientThreadCreate: RecipientThreadCreatePayload;
  aiChatRecipientThreadUpdate: RecipientThreadUpdatePayload;
  aiChatThreadCreate: ThreadCreatePayload;
  aiChatThreadDelete: ThreadDeletePayload;
  aiChatThreadUpdate: ThreadUpdatePayload;
  apiTokenCreate: ApiTokenCreatePayload;
  apiTokenDeactivate: ApiTokenDeactivatePayload;
  archiveOrganizationImage: OrganizationImagesArchivePayload;
  authLogin: AuthLoginPayload;
  authLogout: AuthLogoutPayload;
  authSignUp: AuthSignUpPayload;
  authUnlinkOpenid: AuthUnlinkOpenidPayload;
  authVerify: AuthVerifyPayload;
  autogiftRulePause: AutogiftRulePausePayload;
  autogiftRuleUpdate: AutogiftRuleUpdatePayload;
  balanceDeposit: BalanceDepositPayload;
  balanceTransactionReportCreate: BalanceTransactionReportCreatePayload;
  balanceTransfer: BalanceTransferPayload;
  birthdayRequest: BirthdayRequestPayload;
  birthdaySet: BirthdaySetPayload;
  bookSearch: BookSearchPayload;
  budgetRuleUpdate: BudgetRuleUpdatePayload;
  calendarIntegrationUpdate: CalendarIntegrationUpdatePayload;
  cardCreate: CardCreatePayload;
  cardUpdate: CardUpdatePayload;
  cartValidateDirectSend: CartValidateDirectSendPayload;
  coinsRedeem: CoinsRedeemPayload;
  /** Archive a collection */
  collectionArchive: CollectionArchivePayload;
  /** Apply a categorization to a collection version */
  collectionCategorizationApply: CollectionCategorizationApplyPayload;
  /** Suggest categorization for a collection version */
  collectionCategorizationSuggest: CollectionCategorizationSuggestPayload;
  /** Create a collection category */
  collectionCategoryCreate: CollectionCategoryCreatePayload;
  /** Delete a collection category */
  collectionCategoryDelete: CollectionCategoryDeletePayload;
  /** Copy a product to another collection category */
  collectionCategoryProductCopy: CollectionCategoryProductCopyPayload;
  /** Remove a product from a collection category */
  collectionCategoryProductDelete: CollectionCategoryProductDeletePayload;
  /** Move a product between collection categories */
  collectionCategoryProductMove: CollectionCategoryProductMovePayload;
  /** Reorder products within a collection category */
  collectionCategoryProductReorder: CollectionCategoryProductReorderPayload;
  /** Reorder a collection category */
  collectionCategoryReorder: CollectionCategoryReorderPayload;
  /** Suggest a collection category for a given product */
  collectionCategorySuggest: CollectionCategorySuggestPayload;
  /** Update a collection category */
  collectionCategoryUpdate: CollectionCategoryUpdatePayload;
  /** Clone an existing collection */
  collectionClone: CollectionClonePayload;
  /** Create a new collection */
  collectionCreate: CollectionCreatePayload;
  /** Create a header image for a collection from a URL */
  collectionHeaderImageCreateFromUrl: CollectionHeaderImageCreateFromUrlPayload;
  /** Upload a header image for a collection */
  collectionHeaderImageUpload: CollectionHeaderImageUploadPayload;
  /** Add a product to a collection */
  collectionProductCreate: CollectionProductCreatePayload;
  /** Remove a product from a collection entirely */
  collectionProductDelete: CollectionProductDeletePayload;
  /** Enable or disable the store on a collection */
  collectionStoreUpdate: CollectionStoreUpdatePayload;
  /** Update the theme of a collection version */
  collectionThemeUpdate: CollectionThemeUpdatePayload;
  /** Unarchive a collection */
  collectionUnarchive: CollectionUnarchivePayload;
  /** Publish a collection version */
  collectionVersionPublish: CollectionVersionPublishPayload;
  /** Remove the header image from a collection version */
  collectionVersionRemoveHeaderImage: CollectionVersionRemoveHeaderImagePayload;
  /** Update a collection version */
  collectionVersionUpdate: CollectionVersionUpdatePayload;
  commerceAppCreate: CommerceAppCreatePayload;
  companyNameUpdate: CompanyNameUpdatePayload;
  contactBatchRemove: ContactBatchRemovePayload;
  contactBatchUpdate: ContactBatchUpdatePayload;
  contactListBatchAddContacts: ContactListBatchAddContactsPayload;
  contactListCreate: ContactListCreatePayload;
  contactListDestroy: ContactListDestroyPayload;
  contactListUpdate: ContactListUpdatePayload;
  contactRemove: ContactRemovePayload;
  contactUpdate: ContactUpdatePayload;
  createSwagQuoteRequest: SwagIntegrationsCreateQuoteRequestPayload;
  customStoreAddOption: CustomStoreAddOptionPayload;
  customStoreArchive: CustomStoreArchivePayload;
  customStoreCreate: CustomStoreCreatePayload;
  customStoreRemoveOption: CustomStoreRemoveOptionPayload;
  customStoreReorderOptions: CustomStoreReorderOptionsPayload;
  customStoreUpdate: CustomStoreUpdatePayload;
  deletionRequestCreate: DeletionRequestCreatePayload;
  deviceUpdate: DeviceUpdatePayload;
  deviceUpdateLastSession: DeviceUpdateLastSessionPayload;
  emailVerificationSend: EmailVerificationSendPayload;
  emailVerificationVerify: EmailVerificationVerifyPayload;
  eventUpdate: EventUpdatePayload;
  /** Record an experiment assignment for a user. */
  experimentAssignmentRecordCreate: ExperimentAssignmentRecordCreatePayload;
  favoritesOnboardingCheck: FavoritesOnboardingCheckPayload;
  findOrCreateOrganizationImagesWithBrandFetch: OrganizationImagesFindOrCreateWithBrandFetchPayload;
  forgotPassword: ForgotPasswordPayload;
  generateAblyTokenRequest: GenerateAblyTokenRequestPayload;
  giftAccept: GiftAcceptPayload;
  giftAddThankYouNote: GiftAddThankYouNotePayload;
  /** @deprecated No longer used by any client. */
  giftAutopayDisable: GiftAutopayDisablePayload;
  giftBatchCancel: GiftBatchCancelPayload;
  giftBatchCancelPendingGifts: GiftBatchCancelPendingGiftsPayload;
  giftBatchCheckAbandonedCart: CheckAbandonedCartPayload;
  giftBatchCreate: GiftBatchCreatePayload;
  giftBatchRetryFailedEmailDelivery: RetryFailedEmailDeliveryPayload;
  giftBatchSmartLinkDeactivate: GiftBatchSmartLinkDeactivatePayload;
  giftBatchSmartLinkUpdateQuantity: GiftBatchSmartLinkUpdateQuantityPayload;
  giftBatchUpdate: GiftBatchUpdatePayload;
  giftBatchUpdateMeetingSettings: GiftBatchUpdateMeetingSettingsPayload;
  giftBatchUpdateSentBatch: GiftBatchUpdateSentBatchPayload;
  giftBatchUpdateSettings: UpdateSettingsPayload;
  giftBatchesDraftAccept: DraftAcceptPayload;
  giftBatchesDraftCreate: DraftCreatePayload;
  giftBatchesDraftSwap: DraftSwapPayload;
  giftBatchesDraftSwapBack: DraftSwapBackPayload;
  giftBatchesDraftUpdateCurrentCountryOverride: DraftUpdateCurrentCountryOverridePayload;
  giftBatchesSendRemindersForGifts: SendRemindersForGiftsPayload;
  giftCancel: GiftCancelPayload;
  giftCartProductUpdate: UpdatePayload;
  giftConfirmPostAcceptVariantSwap: GiftConfirmPostAcceptVariantSwapPayload;
  giftCreate: GiftCreatePayload;
  giftDispenserClose: GiftDispenserClosePayload;
  /** Refine an existing gift message */
  giftMessageGeneratorRefine: GiftMessageGeneratorRefinePayload;
  /** Generate gift message suggestions */
  giftMessageGeneratorSuggest: GiftMessageGeneratorSuggestPayload;
  /** Generate gift message suggestions in collaborative mode */
  giftMessageGeneratorSuggestCollaborative: GiftMessageGeneratorSuggestCollaborativePayload;
  giftPay: GiftPayPayload;
  giftPaymentCheck: GiftPaymentCheckPayload;
  /** Capture recipient top-up payment and accept the gift */
  giftRecipientCheckoutCreate: GiftRecipientCheckoutCreatePayload;
  giftRecordMeetingScheduled: GiftRecordMeetingScheduledPayload;
  giftSendReminder: SendReminderPayload;
  giftSendTwoFactorCode: GiftSendTwoFactorCodePayload;
  giftSenderSentReminderRecordSend: GiftSenderSentReminderRecordSendPayload;
  giftSwap: GiftSwapPayload;
  giftSwapBack: GiftSwapBackPayload;
  giftSwapCartUpdate: SwapCartUpdatePayload;
  giftTrackProductView: TrackProductViewPayload;
  giftUpdateCurrentCountryOverride: GiftUpdateCurrentCountryOverridePayload;
  giftUserApproval: GiftUserApprovalPayload;
  hrisConfirmIntegration: ConfirmIntegrationPayload;
  hrisConnectIntegration: ConnectIntegrationPayload;
  hrisDisconnectIntegration: DisconnectIntegrationPayload;
  hrisResyncIntegration: ResyncIntegrationPayload;
  hrisUpdateIntegration: UpdateIntegrationPayload;
  identityCreate: IdentityCreatePayload;
  identityUpdate: IdentityUpdatePayload;
  listItemCreate: ListItemCreatePayload;
  listItemDestroy: ListItemDestroyPayload;
  /** @deprecated Use balance_deposit instead */
  organizationBalanceDeposit: BalanceDepositPayload;
  /** @deprecated Seats mutations have been deprecated */
  organizationMembershipChangeAccess: OrganizationMembershipChangeAccessPayload;
  organizationMembershipChangeRole: OrganizationMembershipChangeRolePayload;
  organizationMembershipDeactivate: OrganizationMembershipDeactivatePayload;
  organizationUpdateBillingEmails: OrganizationUpdateBillingEmailsPayload;
  organizationUpdateQuarterStartMonth: OrganizationUpdateQuarterStartMonthPayload;
  organizationUpdateRequireSsoSetting: OrganizationUpdateRequireSsoSettingPayload;
  organizationUpdateTheme: OrganizationUpdateThemePayload;
  /** @deprecated No longer used by any client. Setup intents are now created via PaymentMethodCreate. */
  paymentGetSetupIntent: PaymentGetSetupIntentPayload;
  paymentMethodCreate: PaymentMethodCreatePayload;
  paymentMethodDeactivate: PaymentMethodDeactivatePayload;
  paymentMethodDelete: PaymentMethodDeletePayload;
  /** @deprecated No longer used by any client. Use PaymentMethodUpdate instead. */
  paymentMethodSetDefault: PaymentMethodSetDefaultPayload;
  paymentMethodUpdate: PaymentMethodUpdatePayload;
  plusEnroll: PlusEnrollPayload;
  plusEnrollmentUpgradeRequest: PlusEnrollmentUpgradeRequestPayload;
  priceEstimate: PriceEstimatePayload;
  promoCodeValidate: PromoCodeValidatePayload;
  referralInviteSend: ReferralInviteSendPayload;
  reportsValidateGiftBatchPublicId: ReportsValidateGiftBatchPublicIdPayload;
  resetPassword: ResetPasswordPayload;
  salesforceValidateSendPayload: SalesforceValidateSendPayloadPayload;
  samlCreateIdentityProvider: CreateIdentityProviderPayload;
  samlDisableIdentityProvider: DisableIdentityProviderPayload;
  samlUpdateIdentityProvider: UpdateIdentityProviderPayload;
  sampleGiftCreate: SampleGiftCreatePayload;
  setLastRealm: SetLastRealmPayload;
  setStoreReview: SetStoreReviewPayload;
  /** Create a storefront ("company store") gift purchase (unauthenticated). */
  storeCheckoutCreate: StoreCheckoutCreatePayload;
  subscriptionCreate: SubscriptionCreatePayload;
  subscriptionPriceEstimate: SubscriptionPriceEstimatePayload;
  subscriptionRegisterCancellation: SubscriptionRegisterCancellationPayload;
  swag: SwagIntegrations_MutationType;
  themeLogoUpload: ThemeLogoUploadPayload;
  uploadOrganizationImage: OrganizationImagesUploadPayload;
  userDismissedScreenCreate: UserDismissedScreenCreatePayload;
  userEdit: UserEditPayload;
  /** Update the last send audience a user selected. */
  userLastSendAudienceUpdate: UserLastSendAudienceUpdatePayload;
  userLastUsedWorkspaceUpdate: UserLastUsedWorkspaceUpdatePayload;
  /** Save post-signup v3 survey selections. */
  userUpdatePostSignupData: UserUpdatePostSignupDataPayload;
  userUsernameUpgrade: UserUsernameUpgradePayload;
  usernameSearch: UsernameSearchPayload;
  usernameValidate: UsernameValidatePayload;
  versionCheck: VersionCheckPayload;
  webhookApplicationCreate: WebhookApplicationCreatePayload;
  webhookApplicationFetchDashboardUrl: WebhookApplicationFetchDashboardUrlPayload;
  workspaceCreate: CreateWorkspacePayload;
  workspaceInviteAccept: AcceptInvitePayload;
  workspaceInviteCreate: CreateInvitePayload;
  workspaceInviteResend: ResendInvitePayload;
  workspaceInviteRevoke: RevokeInvitePayload;
  workspaceLeave: LeaveWorkspacePayload;
  workspaceMembershipDestroy: DestroyMembershipPayload;
  workspaceMembershipUpdate: UpdateMembershipPayload;
  workspaceUpdate: UpdateWorkspacePayload;
  workspaceUpdateBalanceAccess: UpdateBalanceAccessPayload;
};


export type MutationAcceptanceRecentlyViewedProductsFetchArgs = {
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAcceptanceRecommendationsFetchArgs = {
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAcceptanceStoreEventRecordArgs = {
  payload: AcceptanceStoreEventPayloadInput;
};


export type MutationAiChatRecipientThreadCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['JSON']['input']>;
  threadData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationAiChatRecipientThreadUpdateArgs = {
  id: Scalars['ID']['input'];
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['JSON']['input']>;
  threadData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationAiChatThreadCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAiChatThreadDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAiChatThreadUpdateArgs = {
  id: Scalars['ID']['input'];
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['JSON']['input']>;
  threadData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationApiTokenCreateArgs = {
  commerceAppId?: InputMaybe<Scalars['ID']['input']>;
  ttype: ApiTokenTtype;
};


export type MutationApiTokenDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOrganizationImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAuthLoginArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthSignUpArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkspaceInvite?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referringCode?: InputMaybe<Scalars['String']['input']>;
  referringGiftId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthUnlinkOpenidArgs = {
  provider: Scalars['String']['input'];
};


export type MutationAuthVerifyArgs = {
  code: Scalars['String']['input'];
  deviceInfo?: InputMaybe<DeviceInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmParams>;
};


export type MutationAutogiftRulePauseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAutogiftRuleUpdateArgs = {
  autogiftRuleInput: AutogiftRuleInput;
};


export type MutationBalanceDepositArgs = {
  accountType?: InputMaybe<BalanceDepositAccount>;
  amount: Scalars['Int']['input'];
  balanceAccountId?: InputMaybe<Scalars['ID']['input']>;
  cardInput?: InputMaybe<PaymentMethodCreditCardInput>;
  fundingMethod: BalanceDepositFundingMethod;
  invoiceRequestInput?: InputMaybe<InvoiceRequestInput>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBalanceTransactionReportCreateArgs = {
  balanceAccountId: Scalars['ID']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBalanceTransferArgs = {
  amount: Scalars['Int']['input'];
  fromBalanceAccountId: Scalars['ID']['input'];
  toBalanceAccountId: Scalars['ID']['input'];
};


export type MutationBirthdayRequestArgs = {
  contact: ContactInput;
};


export type MutationBirthdaySetArgs = {
  contact: ContactInput;
};


export type MutationBookSearchArgs = {
  query: Scalars['String']['input'];
};


export type MutationBudgetRuleUpdateArgs = {
  amount: Scalars['Int']['input'];
  balanceAccountId: Scalars['ID']['input'];
  recurrence: BudgetRecurrence;
};


export type MutationCalendarIntegrationUpdateArgs = {
  calendlyApiUrl: Scalars['String']['input'];
  giftSetting: Gift_Meeting_Setting;
};


export type MutationCardCreateArgs = {
  cardFields: CardCreateFieldsInput;
};


export type MutationCardUpdateArgs = {
  cardFields: CardUpdateFieldsInput;
};


export type MutationCartValidateDirectSendArgs = {
  cart: Array<CartProductInput>;
};


export type MutationCoinsRedeemArgs = {
  redemptionType: Scalars['String']['input'];
};


export type MutationCollectionArchiveArgs = {
  collectionId: Scalars['ID']['input'];
};


export type MutationCollectionCategorizationApplyArgs = {
  categorization: Array<CollectionCategorizationInput>;
  collectionVersionId: Scalars['ID']['input'];
};


export type MutationCollectionCategorizationSuggestArgs = {
  collectionVersionId: Scalars['ID']['input'];
};


export type MutationCollectionCategoryCreateArgs = {
  collectionVersionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCollectionCategoryDeleteArgs = {
  collectionCategoryId: Scalars['ID']['input'];
};


export type MutationCollectionCategoryProductCopyArgs = {
  collectionCategoryProductId: Scalars['ID']['input'];
  sourceCategoryId: Scalars['ID']['input'];
  targetCategoryId: Scalars['ID']['input'];
};


export type MutationCollectionCategoryProductDeleteArgs = {
  collectionCategoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionCategoryProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCollectionCategoryProductMoveArgs = {
  collectionCategoryProductId: Scalars['ID']['input'];
  sourceCategoryId: Scalars['ID']['input'];
  targetCategoryId: Scalars['ID']['input'];
  targetIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCollectionCategoryProductReorderArgs = {
  collectionCategoryId: Scalars['ID']['input'];
  collectionCategoryProductId: Scalars['ID']['input'];
  newIndex: Scalars['Int']['input'];
};


export type MutationCollectionCategoryReorderArgs = {
  collectionCategoryId: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
};


export type MutationCollectionCategorySuggestArgs = {
  collectionVersionId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationCollectionCategoryUpdateArgs = {
  collectionCategoryId: Scalars['ID']['input'];
  collectionCategoryInput: CollectionCategoryInput;
};


export type MutationCollectionCloneArgs = {
  sourceCollectionId: Scalars['ID']['input'];
};


export type MutationCollectionCreateArgs = {
  collectionVersion: CollectionVersionInput;
};


export type MutationCollectionHeaderImageCreateFromUrlArgs = {
  collectionVersionId: Scalars['ID']['input'];
  imageUrl: Scalars['String']['input'];
};


export type MutationCollectionHeaderImageUploadArgs = {
  collectionVersionId: Scalars['ID']['input'];
  imageFile: Scalars['Upload']['input'];
};


export type MutationCollectionProductCreateArgs = {
  collectionCategoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId: Scalars['ID']['input'];
  productDetails?: InputMaybe<CollectionProductProductDetailsInput>;
  productId: Scalars['ID']['input'];
};


export type MutationCollectionProductDeleteArgs = {
  collectionVersionId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationCollectionStoreUpdateArgs = {
  collectionId: Scalars['ID']['input'];
  companyStoreEnabled: Scalars['Boolean']['input'];
};


export type MutationCollectionThemeUpdateArgs = {
  collectionId: Scalars['ID']['input'];
  themeInput: ThemeInput;
};


export type MutationCollectionUnarchiveArgs = {
  collectionId: Scalars['ID']['input'];
};


export type MutationCollectionVersionPublishArgs = {
  collectionVersionId: Scalars['ID']['input'];
};


export type MutationCollectionVersionRemoveHeaderImageArgs = {
  collectionVersionId: Scalars['ID']['input'];
};


export type MutationCollectionVersionUpdateArgs = {
  collectionVersion: CollectionVersionInput;
  id: Scalars['ID']['input'];
};


export type MutationCommerceAppCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationCompanyNameUpdateArgs = {
  name: Scalars['String']['input'];
};


export type MutationContactBatchRemoveArgs = {
  contactIds: Array<Scalars['ID']['input']>;
};


export type MutationContactBatchUpdateArgs = {
  contacts: Array<ContactInput>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  newListName?: InputMaybe<Scalars['String']['input']>;
  save: Scalars['Boolean']['input'];
};


export type MutationContactListBatchAddContactsArgs = {
  contactIds: Array<Scalars['ID']['input']>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  newListName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationContactListCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationContactListDestroyArgs = {
  deleteContacts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationContactListUpdateArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationContactRemoveArgs = {
  contact: ContactInput;
};


export type MutationContactUpdateArgs = {
  contact: ContactInput;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segment?: InputMaybe<ContactSegment>;
};


export type MutationCreateSwagQuoteRequestArgs = {
  desiredQuantity: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  unsignedUserCompanyName?: InputMaybe<Scalars['String']['input']>;
  unsignedUserFirstName?: InputMaybe<Scalars['String']['input']>;
  unsignedUserLastName?: InputMaybe<Scalars['String']['input']>;
  unsignedUserWorkEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCustomStoreAddOptionArgs = {
  customStoreId: Scalars['ID']['input'];
  giftCardAmount?: InputMaybe<Scalars['Int']['input']>;
  giftOptionId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCustomStoreArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCustomStoreCreateArgs = {
  brandValuesDisplay?: InputMaybe<BrandValuesDisplay>;
  desktopImage: CustomStoreImage;
  internationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  mobileImage: CustomStoreImage;
  multipleSelectCount?: InputMaybe<Scalars['Int']['input']>;
  multipleSelectMode?: InputMaybe<MultipleSelectModeEnum>;
  multipleSelectPrice?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<GiftsSettingsInput>;
  subtitle: Scalars['String']['input'];
};


export type MutationCustomStoreRemoveOptionArgs = {
  customStoreId: Scalars['ID']['input'];
  customStoreOptionId?: InputMaybe<Scalars['ID']['input']>;
  giftOptionId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCustomStoreReorderOptionsArgs = {
  customStoreId: Scalars['ID']['input'];
  customStoreOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCustomStoreUpdateArgs = {
  activateStore: Scalars['Boolean']['input'];
  brandValuesDisplay?: InputMaybe<BrandValuesDisplay>;
  customStoreId: Scalars['ID']['input'];
  desktopImage: CustomStoreImage;
  internationalShippingTier?: InputMaybe<InternationalShippingTierEnum>;
  mobileImage: CustomStoreImage;
  multipleSelectCount?: InputMaybe<Scalars['Int']['input']>;
  multipleSelectMode?: InputMaybe<MultipleSelectModeEnum>;
  multipleSelectPrice?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<GiftsSettingsInput>;
  subtitle: Scalars['String']['input'];
};


export type MutationDeviceUpdateArgs = {
  deviceInfo: DeviceInfoInput;
};


export type MutationDeviceUpdateLastSessionArgs = {
  installationId?: InputMaybe<Scalars['String']['input']>;
  lastSessionAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type MutationEmailVerificationVerifyArgs = {
  token: Scalars['String']['input'];
};


export type MutationEventUpdateArgs = {
  event: EventInput;
};


export type MutationExperimentAssignmentRecordCreateArgs = {
  experiment: Scalars['String']['input'];
  group: Scalars['String']['input'];
  stableId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFindOrCreateOrganizationImagesWithBrandFetchArgs = {
  brandfetchIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGiftAcceptArgs = {
  params: GiftAcceptInput;
};


export type MutationGiftAddThankYouNoteArgs = {
  note: Scalars['String']['input'];
};


export type MutationGiftAutopayDisableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftBatchCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftBatchCancelPendingGiftsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftBatchCreateArgs = {
  giftBatch: GiftBatchInput;
  isSalesforceSend?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGiftBatchRetryFailedEmailDeliveryArgs = {
  giftBatchId: Scalars['ID']['input'];
};


export type MutationGiftBatchSmartLinkDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftBatchSmartLinkUpdateQuantityArgs = {
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationGiftBatchUpdateArgs = {
  giftBatch: GiftBatchInput;
};


export type MutationGiftBatchUpdateMeetingSettingsArgs = {
  giftBatchId: Scalars['ID']['input'];
  giftSetting: Gift_Meeting_Setting;
};


export type MutationGiftBatchUpdateSentBatchArgs = {
  giftBatchInfo: GiftBatchUpdateSentBatchInput;
};


export type MutationGiftBatchUpdateSettingsArgs = {
  batchName?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  giftBatchId: Scalars['ID']['input'];
  giftMeetingSetting?: InputMaybe<Scalars['String']['input']>;
  internationalShippingTier?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<GiftsSettingsInput>;
  swapType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGiftBatchesDraftAcceptArgs = {
  params: GiftAcceptInput;
};


export type MutationGiftBatchesDraftCreateArgs = {
  giftAttributesOverride?: InputMaybe<Scalars['JSON']['input']>;
  giftBatch: GiftBatchInput;
};


export type MutationGiftBatchesDraftSwapArgs = {
  cart: Array<CartProductInput>;
};


export type MutationGiftBatchesDraftUpdateCurrentCountryOverrideArgs = {
  countryCode: CountryCodeEnum;
};


export type MutationGiftBatchesSendRemindersForGiftsArgs = {
  giftBatchId: Scalars['ID']['input'];
};


export type MutationGiftCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftCartProductUpdateArgs = {
  giftCartProduct: GiftCartProductInput;
};


export type MutationGiftCreateArgs = {
  gift: GiftInput;
};


export type MutationGiftDispenserCloseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftMessageGeneratorRefineArgs = {
  formalityLevel?: InputMaybe<Scalars['Int']['input']>;
  originalMessage: Scalars['String']['input'];
  refinementPrompt: Scalars['String']['input'];
  tones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGiftMessageGeneratorSuggestArgs = {
  additionalPrompt?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  formalityLevel?: InputMaybe<Scalars['Int']['input']>;
  subCategory: Scalars['String']['input'];
  tones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGiftMessageGeneratorSuggestCollaborativeArgs = {
  formalityLevel?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  tones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGiftPayArgs = {
  checkoutKey: Scalars['String']['input'];
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationGiftPaymentCheckArgs = {
  checkoutKey: Scalars['String']['input'];
};


export type MutationGiftRecipientCheckoutCreateArgs = {
  acceptParams: GiftAcceptInput;
  payment: PaymentMethodCreditCardInput;
};


export type MutationGiftRecordMeetingScheduledArgs = {
  invitee: Scalars['JSON']['input'];
};


export type MutationGiftSendReminderArgs = {
  giftId: Scalars['ID']['input'];
};


export type MutationGiftSenderSentReminderRecordSendArgs = {
  confirmed: Scalars['Boolean']['input'];
  giftId: Scalars['String']['input'];
};


export type MutationGiftSwapArgs = {
  cart: Array<CartProductInput>;
};


export type MutationGiftSwapCartUpdateArgs = {
  cart: Array<CartProductInput>;
};


export type MutationGiftTrackProductViewArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationGiftUpdateCurrentCountryOverrideArgs = {
  countryCode: CountryCodeEnum;
};


export type MutationGiftUserApprovalArgs = {
  approved: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationHrisConfirmIntegrationArgs = {
  data?: InputMaybe<HrisIntegrationConfirmInput>;
  id: Scalars['ID']['input'];
};


export type MutationHrisConnectIntegrationArgs = {
  adapter: HrisIntegrationAdapterEnum;
};


export type MutationHrisDisconnectIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationHrisResyncIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationHrisUpdateIntegrationArgs = {
  configurations?: InputMaybe<Array<HrisConfigurationInput>>;
  customMappings?: InputMaybe<HrisMappingsInput>;
  exclusions?: InputMaybe<HrisExclusionsInput>;
  id: Scalars['ID']['input'];
};


export type MutationIdentityCreateArgs = {
  password: Scalars['String']['input'];
};


export type MutationIdentityUpdateArgs = {
  id: Scalars['ID']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationListItemCreateArgs = {
  associatedGiftOptionId?: InputMaybe<Scalars['ID']['input']>;
  listItemTtype: ListItemTtype;
  listTtype: ListTtype;
  resourceId: Scalars['ID']['input'];
};


export type MutationListItemDestroyArgs = {
  listItemTtype: ListItemTtype;
  listTtype: ListTtype;
  resourceId: Scalars['ID']['input'];
};


export type MutationOrganizationBalanceDepositArgs = {
  accountType?: InputMaybe<BalanceDepositAccount>;
  amount: Scalars['Int']['input'];
  balanceAccountId?: InputMaybe<Scalars['ID']['input']>;
  cardInput?: InputMaybe<PaymentMethodCreditCardInput>;
  fundingMethod: BalanceDepositFundingMethod;
  invoiceRequestInput?: InputMaybe<InvoiceRequestInput>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOrganizationMembershipChangeAccessArgs = {
  id: Scalars['ID']['input'];
  newAccess: OrganizationMembershipAccess;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOrganizationMembershipChangeRoleArgs = {
  id: Scalars['ID']['input'];
  role: OrganizationMembershipRole;
};


export type MutationOrganizationMembershipDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateBillingEmailsArgs = {
  billingEmails?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateQuarterStartMonthArgs = {
  startMonth: Scalars['Int']['input'];
};


export type MutationOrganizationUpdateRequireSsoSettingArgs = {
  organizationId: Scalars['ID']['input'];
  requireSsoSetting: OrganizationRequireSsoSetting;
};


export type MutationOrganizationUpdateThemeArgs = {
  themeInput: ThemeInput;
};


export type MutationPaymentMethodCreateArgs = {
  cardInput: PaymentMethodCreditCardInput;
};


export type MutationPaymentMethodDeactivateArgs = {
  paymentMethodId: Scalars['ID']['input'];
  replacementPaymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationPaymentMethodDeleteArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationPaymentMethodSetDefaultArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationPaymentMethodUpdateArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationPlusEnrollArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreementChecked?: InputMaybe<Scalars['Boolean']['input']>;
  agreementCheckedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyTitle?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  employeeEngagementTrialAutoEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  employeeEngagementTrialDirectEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  employeeEngagementTrialEnroll?: InputMaybe<Scalars['Boolean']['input']>;
  giftingTo?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  statsigStableId?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmParams>;
  workspaceInviteToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPriceEstimateArgs = {
  bookEan?: InputMaybe<Scalars['String']['input']>;
  cart?: InputMaybe<Array<CartProductInput>>;
  flexGiftPrice?: InputMaybe<Scalars['Int']['input']>;
  giftCardAmount?: InputMaybe<Scalars['Int']['input']>;
  giftDispenserQuantity?: InputMaybe<Scalars['Int']['input']>;
  giveawayId?: InputMaybe<Scalars['String']['input']>;
  installationId?: InputMaybe<Scalars['String']['input']>;
  isPlus?: InputMaybe<Scalars['Boolean']['input']>;
  isSmartLink?: InputMaybe<Scalars['Boolean']['input']>;
  omitCredit?: InputMaybe<Scalars['Boolean']['input']>;
  plusRecipients?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<GiftRecipientType>;
  recipients?: InputMaybe<Array<GiftBatchRecipientInput>>;
  scheduledGiftBatchId?: InputMaybe<Scalars['ID']['input']>;
  smartLinkQuantity?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPromoCodeValidateArgs = {
  code: Scalars['String']['input'];
  installationId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationReferralInviteSendArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type MutationReportsValidateGiftBatchPublicIdArgs = {
  giftBatchPublicId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSalesforceValidateSendPayloadArgs = {
  authorization: Scalars['String']['input'];
  salesforceOrgId: Scalars['String']['input'];
};


export type MutationSamlCreateIdentityProviderArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSamlDisableIdentityProviderArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSamlUpdateIdentityProviderArgs = {
  certificate: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ssoUrl: Scalars['String']['input'];
};


export type MutationSetLastRealmArgs = {
  lastRealm: RealmTtype;
};


export type MutationStoreCheckoutCreateArgs = {
  input: StoreCheckoutInput;
};


export type MutationSubscriptionCreateArgs = {
  cardInput?: InputMaybe<PaymentMethodCreditCardInput>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type MutationSubscriptionPriceEstimateArgs = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['Int']['input'];
};


export type MutationSubscriptionRegisterCancellationArgs = {
  ownerType: SubscriptionOwnerType;
};


export type MutationThemeLogoUploadArgs = {
  logoFile?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUploadOrganizationImageArgs = {
  imageFile: Scalars['Upload']['input'];
};


export type MutationUserDismissedScreenCreateArgs = {
  screenId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserEditArgs = {
  userFields: UserFieldsInput;
};


export type MutationUserLastSendAudienceUpdateArgs = {
  sendAudience?: InputMaybe<SendAudience>;
};


export type MutationUserLastUsedWorkspaceUpdateArgs = {
  lastUsedWorkspaceId: Scalars['ID']['input'];
};


export type MutationUserUpdatePostSignupDataArgs = {
  audience?: InputMaybe<Array<Scalars['String']['input']>>;
  giftTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUserUsernameUpgradeArgs = {
  username: Scalars['String']['input'];
};


export type MutationUsernameSearchArgs = {
  username: Scalars['String']['input'];
};


export type MutationUsernameValidateArgs = {
  username: Scalars['String']['input'];
};


export type MutationVersionCheckArgs = {
  versionInfo: VersionInfoInput;
};


export type MutationWorkspaceCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationWorkspaceInviteAcceptArgs = {
  workspaceInviteToken: Scalars['String']['input'];
};


export type MutationWorkspaceInviteCreateArgs = {
  workspaceId: Scalars['ID']['input'];
  workspaceInvites: Array<WorkspaceInviteCreateInput>;
};


export type MutationWorkspaceInviteResendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceInviteRevokeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceMembershipDestroyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceMembershipUpdateArgs = {
  fields?: InputMaybe<WorkspaceMembershipUpdateInput>;
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceUpdateArgs = {
  fields: WorkspaceUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationWorkspaceUpdateBalanceAccessArgs = {
  balanceAccess: WorkspaceBalanceAccess;
  workspaceId: Scalars['ID']['input'];
};

export type Occasion = {
  __typename?: 'Occasion';
  cards?: Maybe<Array<Card>>;
  color: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  segment?: Maybe<OccasionSegment>;
};

export enum OccasionSegment {
  Plus = 'PLUS',
  Standard = 'STANDARD'
}

/** specific type of visual display of an offer, which might include copy and visuals */
export enum OfferDisplay {
  /** Client ability to handle a giveaway being out */
  GiveXGetX = 'GIVE_X_GET_X'
}

export type OnboardingGift = {
  __typename?: 'OnboardingGift';
  card: Card;
  giftOption?: Maybe<GiftOption>;
  hasSent: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  product: Product;
  productBrandName: Scalars['String']['output'];
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  productCents: Scalars['Int']['output'];
  shippingCents: Scalars['Int']['output'];
  taxCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  adminCount: Scalars['Int']['output'];
  adminNames: Array<Scalars['String']['output']>;
  apiTokens: Array<ApiToken>;
  balanceAccount?: Maybe<BalanceAccount>;
  balanceAccounts: Array<BalanceAccount>;
  billingEmails?: Maybe<Array<Scalars['String']['output']>>;
  budgetRule?: Maybe<BudgetRule>;
  budgetSummary: BudgetSummary;
  bundledReceiptMembers?: Maybe<Array<OrganizationMembership>>;
  bundledReceiptPaymentMethodLast4s?: Maybe<Array<Scalars['String']['output']>>;
  bundledReceiptPaymentMethodOptions?: Maybe<Array<BundledReceiptPaymentMethodOption>>;
  bundledReceipts: BundledReceiptSeries;
  commerceApp?: Maybe<CommerceApp>;
  commerceApps: Array<CommerceApp>;
  currentMembership?: Maybe<OrganizationMembership>;
  fullMemberCount: Scalars['Int']['output'];
  hasWebhookApplication: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  membership?: Maybe<OrganizationMembership>;
  memberships?: Maybe<Array<OrganizationMembership>>;
  name: Scalars['String']['output'];
  organizationBalanceAccount?: Maybe<BalanceAccount>;
  paymentMethods: Array<PaymentMethod>;
  quarterStartMonth: Scalars['Int']['output'];
  requireSsoSetting: OrganizationRequireSsoSetting;
  samlEnabled: Scalars['Boolean']['output'];
  storedValue: Scalars['Int']['output'];
  storedValueTransactions: StoredValueTransactionSeries;
  storedValueTransactionsMonths: Array<Scalars['ISO8601Date']['output']>;
  subscription?: Maybe<OrganizationSubscription>;
  subscriptionSizeSegment?: Maybe<OrganizationSubscriptionSizeSegment>;
  subscriptionsAll: Array<OrganizationSubscription>;
  theme?: Maybe<Theme>;
  workspace?: Maybe<Workspace>;
  workspaces: Array<Workspace>;
};


export type OrganizationBalanceAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationBudgetRuleArgs = {
  balanceAccountId: Scalars['ID']['input'];
};


export type OrganizationBundledReceiptsArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodLast4?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type OrganizationCommerceAppArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationPaymentMethodsArgs = {
  onlyPersisted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationStoredValueTransactionsArgs = {
  dateEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type OrganizationImage = {
  __typename?: 'OrganizationImage';
  actions: Array<SwagIntegrationsActions>;
  classificationTags: Array<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  originalFilename: Scalars['String']['output'];
  theme: OrganizationImagesTheme;
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** Autogenerated return type of OrganizationImagesArchive. */
export type OrganizationImagesArchivePayload = {
  __typename?: 'OrganizationImagesArchivePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OrganizationImagesFindOrCreateWithBrandFetch. */
export type OrganizationImagesFindOrCreateWithBrandFetchPayload = {
  __typename?: 'OrganizationImagesFindOrCreateWithBrandFetchPayload';
  error?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<OrganizationImage>>;
  ok: Scalars['Boolean']['output'];
};

export type OrganizationImagesPaginatedSeries = {
  __typename?: 'OrganizationImagesPaginatedSeries';
  items: Array<OrganizationImage>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum OrganizationImagesTheme {
  Dark = 'dark',
  Light = 'light'
}

/** Autogenerated return type of OrganizationImagesUpload. */
export type OrganizationImagesUploadPayload = {
  __typename?: 'OrganizationImagesUploadPayload';
  error?: Maybe<Scalars['String']['output']>;
  image?: Maybe<OrganizationImage>;
  ok: Scalars['Boolean']['output'];
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  /** @deprecated Seats fields have been deprecated */
  access: OrganizationMembershipAccess;
  balanceAccount?: Maybe<BalanceAccount>;
  budgetRule?: Maybe<BudgetRule>;
  id: Scalars['ID']['output'];
  member: Member;
  memberGiftCount: Scalars['Int']['output'];
  memberWorkspaceNames: Array<Scalars['String']['output']>;
  pendingGiftCount: Scalars['Int']['output'];
  role: OrganizationMembershipRole;
  scheduledGiftBatchCount: Scalars['Int']['output'];
  status: OrganizationMembershipStatus;
};

export enum OrganizationMembershipAccess {
  /** FULL */
  Full = 'full',
  /** LIMITED */
  Limited = 'limited'
}

/** Autogenerated return type of OrganizationMembershipChangeAccess. */
export type OrganizationMembershipChangeAccessPayload = {
  __typename?: 'OrganizationMembershipChangeAccessPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated return type of OrganizationMembershipChangeRole. */
export type OrganizationMembershipChangeRolePayload = {
  __typename?: 'OrganizationMembershipChangeRolePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated return type of OrganizationMembershipDeactivate. */
export type OrganizationMembershipDeactivatePayload = {
  __typename?: 'OrganizationMembershipDeactivatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum OrganizationMembershipRole {
  /** ADMIN */
  Admin = 'admin',
  /** MEMBER */
  Member = 'member'
}

export enum OrganizationMembershipStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Inactive */
  Inactive = 'INACTIVE'
}

export enum OrganizationRequireSsoSetting {
  /** disabled */
  Disabled = 'disabled',
  /** google */
  Google = 'google',
  /** microsoft */
  Microsoft = 'microsoft',
  /** saml */
  Saml = 'saml'
}

export type OrganizationSubscription = CommonSubscription & {
  __typename?: 'OrganizationSubscription';
  /** @deprecated Seats fields have been deprecated */
  additionalSeatMonthlyCostCents?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Seats fields have been deprecated */
  billedSeatCount: Scalars['Int']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Seats fields have been deprecated */
  includedSeatCount?: Maybe<Scalars['Int']['output']>;
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  isCancelRegistered?: Maybe<Scalars['Boolean']['output']>;
  isEe: Scalars['Boolean']['output'];
  isTeamPlan: Scalars['Boolean']['output'];
  isTrialActive?: Maybe<Scalars['Boolean']['output']>;
  managementType?: Maybe<SubscriptionManagement>;
  planName: Scalars['String']['output'];
  planSku: SubscriptionPlanSku;
  trialCardStatus?: Maybe<SubscriptionTrialCardStatus>;
  trialEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum OrganizationSubscriptionSizeSegment {
  /** ENTERPRISE */
  Enterprise = 'enterprise',
  /** GROWTH */
  Growth = 'growth',
  /** SMALL_BUSINESS */
  SmallBusiness = 'small_business'
}

/** Autogenerated return type of OrganizationUpdateBillingEmails. */
export type OrganizationUpdateBillingEmailsPayload = {
  __typename?: 'OrganizationUpdateBillingEmailsPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OrganizationUpdateQuarterStartMonth. */
export type OrganizationUpdateQuarterStartMonthPayload = {
  __typename?: 'OrganizationUpdateQuarterStartMonthPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OrganizationUpdateRequireSsoSetting. */
export type OrganizationUpdateRequireSsoSettingPayload = {
  __typename?: 'OrganizationUpdateRequireSsoSettingPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of OrganizationUpdateTheme. */
export type OrganizationUpdateThemePayload = {
  __typename?: 'OrganizationUpdateThemePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PaymentGetSetupIntent. */
export type PaymentGetSetupIntentPayload = {
  __typename?: 'PaymentGetSetupIntentPayload';
  setupIntentClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  externalLocationsAlcohol: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PaymentMethodCreate. */
export type PaymentMethodCreatePayload = {
  __typename?: 'PaymentMethodCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Credit card payment method */
export type PaymentMethodCreditCardInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  addressCity: Scalars['String']['input'];
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode: Scalars['String']['input'];
  addressState: Scalars['String']['input'];
  cardholderName: Scalars['String']['input'];
  interimCardToken: Scalars['String']['input'];
};

/** Autogenerated return type of PaymentMethodDeactivate. */
export type PaymentMethodDeactivatePayload = {
  __typename?: 'PaymentMethodDeactivatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  organizationSubscriptionMatchingCardNumber?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of PaymentMethodDelete. */
export type PaymentMethodDeletePayload = {
  __typename?: 'PaymentMethodDeletePayload';
  ok: Scalars['Boolean']['output'];
};

export type PaymentMethodDependencies = {
  __typename?: 'PaymentMethodDependencies';
  activeOrPausedAutogiftRules?: Maybe<Array<Scalars['ID']['output']>>;
  activeSubscriptions?: Maybe<Array<Scalars['ID']['output']>>;
  canDeactivate: Scalars['Boolean']['output'];
  failedBatchBillingGroups?: Maybe<Array<Scalars['ID']['output']>>;
  pendingBatchBillingItems?: Maybe<Array<Scalars['ID']['output']>>;
  pendingScheduledGiftBatches?: Maybe<Array<Scalars['ID']['output']>>;
  unexpiredNotYetAcceptedGifts?: Maybe<Array<Scalars['ID']['output']>>;
  unexpiredSmartLinkGiftBatches?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated return type of PaymentMethodSetDefault. */
export type PaymentMethodSetDefaultPayload = {
  __typename?: 'PaymentMethodSetDefaultPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of PaymentMethodUpdate. */
export type PaymentMethodUpdatePayload = {
  __typename?: 'PaymentMethodUpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of PlusEnroll. */
export type PlusEnrollPayload = {
  __typename?: 'PlusEnrollPayload';
  error?: Maybe<Scalars['String']['output']>;
  joinedWorkspace?: Maybe<Workspace>;
  ok: Scalars['Boolean']['output'];
};

export enum PlusEnrollmentStatus {
  /** full */
  Full = 'FULL',
  /** limited */
  Limited = 'LIMITED',
  /** none */
  None = 'NONE'
}

/** Autogenerated return type of PlusEnrollmentUpgradeRequest. */
export type PlusEnrollmentUpgradeRequestPayload = {
  __typename?: 'PlusEnrollmentUpgradeRequestPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type PlusPriceEstimate = {
  __typename?: 'PlusPriceEstimate';
  balance?: Maybe<Scalars['Int']['output']>;
  creditApplied: Scalars['Int']['output'];
  creditAvailable: Scalars['Int']['output'];
  creditAvailableToApply?: Maybe<Scalars['Int']['output']>;
  estGroupTotalHigh: Scalars['Int']['output'];
  estGroupTotalLow: Scalars['Int']['output'];
  estPreCreditSubtotalHigh: Scalars['Int']['output'];
  estPreCreditSubtotalLow: Scalars['Int']['output'];
  recipients: Scalars['Int']['output'];
};

export type Post = {
  __typename?: 'Post';
  author?: Maybe<Author>;
  category?: Maybe<PostCategory>;
  excerpt?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isRecentHit: Scalars['Boolean']['output'];
  overview?: Maybe<Scalars['String']['output']>;
  readLabel: Scalars['String']['output'];
  relatedPosts?: Maybe<Array<Post>>;
  slug: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PostCategory = {
  __typename?: 'PostCategory';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PriceEstimateEffectiveBalanceData = {
  __typename?: 'PriceEstimateEffectiveBalanceData';
  effectiveBalance?: Maybe<Scalars['Int']['output']>;
  scheduledGiftBatchReservedBalance?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated return type of PriceEstimate. */
export type PriceEstimatePayload = {
  __typename?: 'PriceEstimatePayload';
  cartPriceEstimate: CartPriceEstimate;
  effectiveBalanceData?: Maybe<PriceEstimateEffectiveBalanceData>;
  effectiveBalanceDataWorkspace?: Maybe<PriceEstimateEffectiveBalanceData>;
  error?: Maybe<Scalars['String']['output']>;
  flexGiftPrice?: Maybe<Scalars['Int']['output']>;
  isFlexGift?: Maybe<Scalars['Boolean']['output']>;
  ok: Scalars['Boolean']['output'];
  plusPriceEstimate?: Maybe<PlusPriceEstimate>;
  priceCreditApplied?: Maybe<Scalars['Int']['output']>;
  priceEstTaxHigh?: Maybe<Scalars['Int']['output']>;
  priceEstTaxLow?: Maybe<Scalars['Int']['output']>;
  priceEstTaxText?: Maybe<Scalars['String']['output']>;
  priceEstTotalHigh?: Maybe<Scalars['Int']['output']>;
  priceEstTotalLow?: Maybe<Scalars['Int']['output']>;
  pricePreTax?: Maybe<Scalars['Int']['output']>;
  priceProcessingFee?: Maybe<Scalars['Int']['output']>;
  priceProduct?: Maybe<Scalars['Int']['output']>;
  priceShipping?: Maybe<Scalars['Int']['output']>;
  productPriceEstimates: Array<ProductPriceEstimate>;
  promoCodeError?: Maybe<Scalars['String']['output']>;
  recipientErrors?: Maybe<Array<GiftBatchRecipientError>>;
  totalPriceEstimate: TotalPriceEstimate;
};

/** Set of price estimates for a gift or gift batch send */
export type PriceEstimatesInput = {
  cartPriceEstimate: CartPriceEstimateInput;
  productPriceEstimates: Array<ProductPriceEstimateInput>;
  totalPriceEstimate: TotalPriceEstimateInput;
};

export type PriceRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = ProductInterface & {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  brand: Brand;
  cartEligible: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionInfo?: Maybe<ProductCollectionInfo>;
  companyStoreRestrictedReason?: Maybe<Scalars['String']['output']>;
  customResponseCharMax?: Maybe<Scalars['Int']['output']>;
  customResponseQuestion?: Maybe<Scalars['String']['output']>;
  customStore?: Maybe<CustomStore>;
  customStoreImageThumb?: Maybe<Image>;
  customSwapMinimumPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domesticShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  ecommerceIntegrationType?: Maybe<EcommerceIntegration>;
  forceSwapEnabled: Scalars['Boolean']['output'];
  giftCardCountries?: Maybe<Array<CountryCodeEnum>>;
  giftCardCurrency?: Maybe<Scalars['String']['output']>;
  giftCardCurrencyRate?: Maybe<Scalars['Float']['output']>;
  giftCardInfo?: Maybe<GiftCardInfo>;
  giftCardNativeAmount?: Maybe<Scalars['Int']['output']>;
  giftCardNativeAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  giftCardNativeCurrency?: Maybe<Scalars['String']['output']>;
  giftCollectionTiers: Array<GiftCollectionTier>;
  globalShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  hasVariablePricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagesScalable: Scalars['Boolean']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isBook: Scalars['Boolean']['output'];
  isCollection: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  isGiftCollection: Scalars['Boolean']['output'];
  isOfflineProduct: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  isRestrictedInCompanyStores: Scalars['Boolean']['output'];
  isShippingTierDisabled: Scalars['Boolean']['output'];
  isSwapToEligible: Scalars['Boolean']['output'];
  itemType?: Maybe<ItemTypeEnum>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionsAvailable: Scalars['Boolean']['output'];
  preferredSwapImageLarge?: Maybe<Image>;
  preferredSwapImageXlarge?: Maybe<Image>;
  price: Scalars['Int']['output'];
  priceWithShipping: Scalars['Int']['output'];
  productAttributes?: Maybe<Array<ProductAttribute>>;
  productEditorialImages?: Maybe<Array<ProductEditorialImage>>;
  productImages: Array<ProductImage>;
  relatedProducts?: Maybe<Array<Product>>;
  restrictedStates: Array<Scalars['String']['output']>;
  restrictedStatesByCountry?: Maybe<Scalars['JSON']['output']>;
  restrictedStatesOverrideEnabled: Scalars['Boolean']['output'];
  shippingCountriesFinal: Array<Scalars['String']['output']>;
  shippingCountryGroup: ShippingCountryGroup;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shippingStates?: Maybe<Array<Scalars['String']['output']>>;
  showCategories?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  specialDiscountAmount?: Maybe<Scalars['Int']['output']>;
  status: ProductStatus;
  stockRemaining?: Maybe<Scalars['Int']['output']>;
  storeTags?: Maybe<Array<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleShort?: Maybe<Scalars['String']['output']>;
  swag: ProductsSwagType;
  swapStoreHeaderImage?: Maybe<Image>;
  swapStoreMobileHeaderImage?: Maybe<Image>;
  swapStoreSettings?: Maybe<SwapStoreSettings>;
  variantGroups?: Maybe<Array<VariantGroups>>;
  variants: Array<ProductVariant>;
  variantsLabel?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncase?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncasePlural?: Maybe<Scalars['String']['output']>;
  variantsNumSelectable?: Maybe<Scalars['Int']['output']>;
};


export type ProductRelatedProductsArgs = {
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  content: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ProductCollectionInfo = {
  __typename?: 'ProductCollectionInfo';
  containsAlcohol: Scalars['Boolean']['output'];
  containsCreditExcludedItems: Scalars['Boolean']['output'];
  containsGiftCards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** The connection type for Product. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of edges. */
  edges: Array<ProductEdge>;
  /** A list of nodes. */
  nodes: Array<Product>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  searchRecordId?: Maybe<Scalars['String']['output']>;
  searchSessionId?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

export type ProductEditorialImage = {
  __typename?: 'ProductEditorialImage';
  editorialItemId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageLarge: Image;
  imageThumb: Image;
};

export type ProductFiltersInput = {
  status?: InputMaybe<Array<StatusEnum>>;
};

export type ProductFragment = ProductInterface & {
  __typename?: 'ProductFragment';
  active: Scalars['Boolean']['output'];
  associatedGiftOptionId?: Maybe<Scalars['ID']['output']>;
  autogiftTotalPrice?: Maybe<Scalars['Int']['output']>;
  brand: Brand;
  brandHideMadeBySubtitle: Scalars['Boolean']['output'];
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  brandSlug: Scalars['String']['output'];
  cartEligible: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionInfo?: Maybe<ProductCollectionInfo>;
  companyStoreRestrictedReason?: Maybe<Scalars['String']['output']>;
  customResponseCharMax?: Maybe<Scalars['Int']['output']>;
  customResponseQuestion?: Maybe<Scalars['String']['output']>;
  customStore?: Maybe<CustomStore>;
  customStoreImageThumb?: Maybe<Image>;
  customSwapMinimumPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domesticShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  ecommerceIntegrationType?: Maybe<EcommerceIntegration>;
  forceSwapEnabled: Scalars['Boolean']['output'];
  giftCardCountries?: Maybe<Array<CountryCodeEnum>>;
  giftCardCurrency?: Maybe<Scalars['String']['output']>;
  giftCardCurrencyRate?: Maybe<Scalars['Float']['output']>;
  giftCardInfo?: Maybe<GiftCardInfo>;
  giftCardNativeAmount?: Maybe<Scalars['Int']['output']>;
  giftCardNativeAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  giftCardNativeCurrency?: Maybe<Scalars['String']['output']>;
  giftCollectionTiers: Array<GiftCollectionTier>;
  globalShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  hasVariablePricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagesScalable: Scalars['Boolean']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isBook: Scalars['Boolean']['output'];
  isCollection: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  isGiftCollection: Scalars['Boolean']['output'];
  isOfflineProduct: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  isRestrictedInCompanyStores: Scalars['Boolean']['output'];
  isShippingTierDisabled: Scalars['Boolean']['output'];
  isSwapToEligible: Scalars['Boolean']['output'];
  itemType?: Maybe<ItemTypeEnum>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionsAvailable: Scalars['Boolean']['output'];
  preferredSwapImageLarge?: Maybe<Image>;
  preferredSwapImageXlarge?: Maybe<Image>;
  price?: Maybe<Scalars['Int']['output']>;
  priceWithShipping: Scalars['Int']['output'];
  primaryImage?: Maybe<ProductImage>;
  productAttributes?: Maybe<Array<ProductAttribute>>;
  productEditorialImages?: Maybe<Array<ProductEditorialImage>>;
  productImages: Array<ProductImage>;
  relatedProducts?: Maybe<Array<Product>>;
  restrictedStates: Array<Scalars['String']['output']>;
  restrictedStatesByCountry?: Maybe<Scalars['JSON']['output']>;
  restrictedStatesOverrideEnabled: Scalars['Boolean']['output'];
  shippingCountriesFinal: Array<Scalars['String']['output']>;
  shippingCountryGroup: ShippingCountryGroup;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shippingStates?: Maybe<Array<Scalars['String']['output']>>;
  showCategories?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  specialDiscountAmount?: Maybe<Scalars['Int']['output']>;
  status: ProductStatus;
  stockRemaining?: Maybe<Scalars['Int']['output']>;
  storeTags?: Maybe<Array<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleShort?: Maybe<Scalars['String']['output']>;
  swag: ProductsSwagType;
  swapStoreHeaderImage?: Maybe<Image>;
  swapStoreMobileHeaderImage?: Maybe<Image>;
  swapStoreSettings?: Maybe<SwapStoreSettings>;
  variantGroups?: Maybe<Array<VariantGroups>>;
  variants: Array<ProductVariant>;
  variantsLabel?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncase?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncasePlural?: Maybe<Scalars['String']['output']>;
  variantsNumSelectable?: Maybe<Scalars['Int']['output']>;
};


export type ProductFragmentRelatedProductsArgs = {
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  id: Scalars['ID']['output'];
  imageLarge: Image;
  imageThumb: Image;
  imageXlarge: Image;
  imageXmedium: Image;
};

export type ProductInterface = {
  active: Scalars['Boolean']['output'];
  brand: Brand;
  cartEligible: Scalars['Boolean']['output'];
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionInfo?: Maybe<ProductCollectionInfo>;
  companyStoreRestrictedReason?: Maybe<Scalars['String']['output']>;
  customResponseCharMax?: Maybe<Scalars['Int']['output']>;
  customResponseQuestion?: Maybe<Scalars['String']['output']>;
  customStore?: Maybe<CustomStore>;
  customStoreImageThumb?: Maybe<Image>;
  customSwapMinimumPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domesticShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  ecommerceIntegrationType?: Maybe<EcommerceIntegration>;
  forceSwapEnabled: Scalars['Boolean']['output'];
  giftCardCountries?: Maybe<Array<CountryCodeEnum>>;
  giftCardCurrency?: Maybe<Scalars['String']['output']>;
  giftCardCurrencyRate?: Maybe<Scalars['Float']['output']>;
  giftCardInfo?: Maybe<GiftCardInfo>;
  giftCardNativeAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  giftCardNativeCurrency?: Maybe<Scalars['String']['output']>;
  giftCollectionTiers: Array<GiftCollectionTier>;
  globalShippingCountries?: Maybe<Array<CountryCodeEnum>>;
  hasVariablePricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagesScalable: Scalars['Boolean']['output'];
  isAlcohol: Scalars['Boolean']['output'];
  isBook: Scalars['Boolean']['output'];
  isCollection: Scalars['Boolean']['output'];
  isFlexGift: Scalars['Boolean']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  isGiftCollection: Scalars['Boolean']['output'];
  isOfflineProduct: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  isRestrictedInCompanyStores: Scalars['Boolean']['output'];
  isShippingTierDisabled: Scalars['Boolean']['output'];
  isSwapToEligible: Scalars['Boolean']['output'];
  itemType?: Maybe<ItemTypeEnum>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  optionsAvailable: Scalars['Boolean']['output'];
  preferredSwapImageLarge?: Maybe<Image>;
  preferredSwapImageXlarge?: Maybe<Image>;
  priceWithShipping: Scalars['Int']['output'];
  productAttributes?: Maybe<Array<ProductAttribute>>;
  productEditorialImages?: Maybe<Array<ProductEditorialImage>>;
  productImages: Array<ProductImage>;
  restrictedStates: Array<Scalars['String']['output']>;
  restrictedStatesByCountry?: Maybe<Scalars['JSON']['output']>;
  restrictedStatesOverrideEnabled: Scalars['Boolean']['output'];
  shippingCountriesFinal: Array<Scalars['String']['output']>;
  shippingCountryGroup: ShippingCountryGroup;
  shippingPrice?: Maybe<Scalars['Int']['output']>;
  shippingStates?: Maybe<Array<Scalars['String']['output']>>;
  showCategories?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  status: ProductStatus;
  stockRemaining?: Maybe<Scalars['Int']['output']>;
  storeTags?: Maybe<Array<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleShort?: Maybe<Scalars['String']['output']>;
  swag: ProductsSwagType;
  swapStoreHeaderImage?: Maybe<Image>;
  swapStoreMobileHeaderImage?: Maybe<Image>;
  swapStoreSettings?: Maybe<SwapStoreSettings>;
  variantGroups?: Maybe<Array<VariantGroups>>;
  variants: Array<ProductVariant>;
  variantsLabel?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncase?: Maybe<Scalars['String']['output']>;
  variantsLabelDowncasePlural?: Maybe<Scalars['String']['output']>;
  variantsNumSelectable?: Maybe<Scalars['Int']['output']>;
};

/** Price estimate for a product */
export type ProductPriceEstimate = {
  __typename?: 'ProductPriceEstimate';
  isFlexGift?: Maybe<Scalars['Boolean']['output']>;
  priceEstTaxHigh: Scalars['Int']['output'];
  priceEstTaxLow: Scalars['Int']['output'];
  priceEstTotalHigh: Scalars['Int']['output'];
  priceEstTotalLow: Scalars['Int']['output'];
  pricePreTax: Scalars['Int']['output'];
  priceProcessingFee: Scalars['Int']['output'];
  priceProduct: Scalars['Int']['output'];
  priceShipping: Scalars['Int']['output'];
  specialDiscountApplied?: Maybe<Scalars['Int']['output']>;
};

/** Price estimate for a product */
export type ProductPriceEstimateInput = {
  isFlexGift?: InputMaybe<Scalars['Boolean']['input']>;
  priceEstTaxHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTaxLow?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalHigh?: InputMaybe<Scalars['Int']['input']>;
  priceEstTotalLow?: InputMaybe<Scalars['Int']['input']>;
  pricePreTax?: InputMaybe<Scalars['Int']['input']>;
  priceProcessingFee?: InputMaybe<Scalars['Int']['input']>;
  priceProduct?: InputMaybe<Scalars['Int']['input']>;
  priceShipping?: InputMaybe<Scalars['Int']['input']>;
  specialDiscountApplied?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductRecommendations = {
  __typename?: 'ProductRecommendations';
  recommendations: Array<Product>;
};

export enum ProductStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Inactive */
  Inactive = 'INACTIVE'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  imageLarge?: Maybe<Image>;
  imageMedium?: Maybe<Image>;
  imageThumb?: Maybe<Image>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageXlarge?: Maybe<Image>;
  name: Scalars['String']['output'];
  stockRemaining?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type ProductsPaginatedSeries = {
  __typename?: 'ProductsPaginatedSeries';
  items: Array<Product>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ProductsSwagType = {
  __typename?: 'ProductsSwagType';
  actions: Array<SwagIntegrationsActions>;
  currentCustomProductIntegration?: Maybe<SwagIntegrationsCustomProductIntegration>;
  draftCustomProductIntegration?: Maybe<SwagIntegrationsCustomProductIntegration>;
  id: Scalars['ID']['output'];
  storePreview?: Maybe<SwagIntegrationsCustomProductIntegration>;
  storePreviewEnabled: Scalars['Boolean']['output'];
  type?: Maybe<SwagIntegrationsType>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amountRecipient: Scalars['Int']['output'];
  codeType: Scalars['String']['output'];
  referrerName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of PromoCodeValidate. */
export type PromoCodeValidatePayload = {
  __typename?: 'PromoCodeValidatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type PromotionCode = {
  __typename?: 'PromotionCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get the active gift batches for the current user in their current workspace */
  activeGiftBatches: Array<GiftBatch>;
  aiChatThread?: Maybe<AiChatThread>;
  aiChatThreadData?: Maybe<Scalars['JSON']['output']>;
  aiChatThreads: Array<AiChatThread>;
  autogiftRules?: Maybe<Array<AutogiftRule>>;
  balanceTransactionReport?: Maybe<BalanceTransactionReport>;
  cardsForOccasion: Array<Card>;
  categories?: Maybe<Array<Category>>;
  category?: Maybe<Category>;
  categoryHomepageProducts: Array<Product>;
  categoryHomepageProductsPaginated: CategoryHomepageProductsPaginatedSeries;
  collection?: Maybe<Collection>;
  collectionHeaderImages: Array<CollectionsHeaderImageType>;
  collectionVersion?: Maybe<CollectionVersion>;
  collections: Array<Collection>;
  customStoreGiftOption?: Maybe<CustomStoreGiftOption>;
  customStoreOption: CustomStoreOption;
  customStoreOptionsConnection?: Maybe<CustomStoreOptionConnection>;
  customStoreProduct?: Maybe<CustomStoreProduct>;
  editorialItem?: Maybe<EditorialItem>;
  editorialItems: Array<EditorialItem>;
  emailDefaultSubjectTemplatePreview: Scalars['String']['output'];
  emailTemplatePreview: Scalars['String']['output'];
  faqCollection?: Maybe<FaqCollection>;
  featureFlags: Array<Scalars['String']['output']>;
  fullProduct?: Maybe<Product>;
  gift?: Maybe<RecipientGift>;
  giftByGiftBatchesDraftId?: Maybe<RecipientGift>;
  giftBySenderId?: Maybe<Gift>;
  giftFavorites?: Maybe<List>;
  giftOption?: Maybe<GiftOption>;
  giftOptions?: Maybe<Array<GiftOption>>;
  giftOptionsConnection?: Maybe<GiftOptionConnection>;
  giftRecipientCheckoutEstimate: GiftRecipientCheckoutEstimate;
  giveaway?: Maybe<Giveaway>;
  imageBanner?: Maybe<ImageBanner>;
  infoBanner?: Maybe<InfoBanner>;
  me?: Maybe<Me>;
  occasions?: Maybe<Array<Occasion>>;
  onboardingGifts?: Maybe<Array<OnboardingGift>>;
  organization?: Maybe<Organization>;
  organizationImagesPaginated: OrganizationImagesPaginatedSeries;
  paymentMethodDependencies: PaymentMethodDependencies;
  product?: Maybe<ProductFragment>;
  productDetails?: Maybe<Product>;
  productRecommendations?: Maybe<ProductRecommendations>;
  products?: Maybe<Array<ProductFragment>>;
  productsConnection?: Maybe<ProductConnection>;
  productsPaginated?: Maybe<ProductsPaginatedSeries>;
  promoCode?: Maybe<PromoCode>;
  /** Fetch a promotion code information by the code label */
  promotionCode?: Maybe<PromotionCode>;
  /** Returns featured events and upcoming public events */
  publicEvents: Array<ScheduledEvent>;
  recentlyAcceptedGifts: RecentlyAcceptedGiftsSeries;
  referralHistory?: Maybe<ReferralHistory>;
  referralOffer?: Maybe<ReferralOffer>;
  reportChart: ReportChart;
  reportFilterClasses?: Maybe<Array<ReportFilterClass>>;
  restrictedProductsConnection: ProductConnection;
  restrictedSwagCollectionProductCount: Scalars['Int']['output'];
  restrictedSwagCollectionProductsConnection: ProductConnection;
  shippingCountries: Array<ShippingCountry>;
  storeCheckoutEstimate: StoreCheckoutEstimate;
  storeOrder?: Maybe<StoreOrder>;
  storeSearch: StoreSearchResponse;
  /** Main entrypoint for the SwagIntegrationsEngine graphql types */
  swagIntegrations: SwagIntegrations_Query;
  /** Find or create swag maker based on the current user or anonymous user ID */
  swagMaker: SwagIntegrationsSwagMaker;
  /** Search for swag products */
  swagSearch: StoreSearchResponse;
  swagTemplateBrands: Array<Brand>;
  swagTemplatesPaginated?: Maybe<SwagTemplatesPaginatedSeries>;
  swappableProductsSearchConnection?: Maybe<ProductConnection>;
  variantGroups?: Maybe<Array<VariantGroups>>;
  webImageBanner?: Maybe<ImageBanner>;
  webflowAuthor?: Maybe<Author>;
  webflowAuthors: Array<Author>;
  webflowPost?: Maybe<Post>;
  webflowPosts: Array<Post>;
  workspace?: Maybe<CurrentWorkspace>;
  workspaceInvite?: Maybe<WorkspaceInviteLimited>;
};


export type QueryAiChatThreadArgs = {
  id: Scalars['ID']['input'];
  includeData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAiChatThreadDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiChatThreadsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAutogiftRulesArgs = {
  contactListId: Scalars['ID']['input'];
};


export type QueryBalanceTransactionReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCardsForOccasionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  occasionId: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubcategories?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  segment?: InputMaybe<CategorySegment>;
  set?: InputMaybe<CategorySet>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  storePlatform?: InputMaybe<StorePlatformEnum>;
};


export type QueryCategoryArgs = {
  defaultCategorySegment?: InputMaybe<CategorySegment>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoryHomepageProductsArgs = {
  categorySlug: Scalars['String']['input'];
};


export type QueryCategoryHomepageProductsPaginatedArgs = {
  categorySlug: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryCollectionArgs = {
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionVersionArgs = {
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomStoreGiftOptionArgs = {
  customStoreId: Scalars['ID']['input'];
  giftOptionId?: InputMaybe<Scalars['ID']['input']>;
  giftOptionSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomStoreOptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomStoreOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customStoreId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftCardsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomStoreProductArgs = {
  brandSlug?: InputMaybe<Scalars['String']['input']>;
  customStoreId: Scalars['ID']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  productSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEditorialItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEditorialItemsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  storePlatform?: InputMaybe<StorePlatformEnum>;
};


export type QueryEmailTemplatePreviewArgs = {
  directSend?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFaqCollectionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFullProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGiftBySenderIdArgs = {
  senderViewAccessId: Scalars['String']['input'];
};


export type QueryGiftOptionArgs = {
  filters?: InputMaybe<GiftOptionFiltersInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGiftOptionsArgs = {
  brandValues?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  defaultCategorySegment?: InputMaybe<CategorySegment>;
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  occasionId?: InputMaybe<Scalars['ID']['input']>;
  onlyShowOccasion?: InputMaybe<Scalars['Boolean']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requirePlusEligible?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<BusinessSegment>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGiftOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandValues?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  defaultCategorySegment?: InputMaybe<CategorySegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  occasionId?: InputMaybe<Scalars['ID']['input']>;
  onlyShowOccasion?: InputMaybe<Scalars['Boolean']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requirePlusEligible?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<BusinessSegment>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGiftRecipientCheckoutEstimateArgs = {
  address?: InputMaybe<AddressInput>;
};


export type QueryGiveawayArgs = {
  capabilities?: InputMaybe<Array<Capability>>;
};


export type QueryInfoBannerArgs = {
  deviceInfo?: InputMaybe<InfoBannerDeviceInfoInput>;
  isPlus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOccasionsArgs = {
  excludeCards?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<OccasionSegment>;
};


export type QueryOnboardingGiftsArgs = {
  installationId: Scalars['String']['input'];
};


export type QueryOrganizationImagesPaginatedArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryPaymentMethodDependenciesArgs = {
  paymentMethodId: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  allowAllVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductDetailsArgs = {
  brandSlug?: InputMaybe<Scalars['String']['input']>;
  companyStoreSlug?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFiltersInput>;
  productSlug?: InputMaybe<Scalars['String']['input']>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
};


export type QueryProductRecommendationsArgs = {
  query: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  productIdList: Array<Scalars['ID']['input']>;
};


export type QueryProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandValues?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requirePlusEligible?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<BusinessSegment>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductsPaginatedArgs = {
  brandValues?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  requirePlusEligible?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<BusinessSegment>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPromoCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryRecentlyAcceptedGiftsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryReferralOfferArgs = {
  supportedOfferDisplayTypes: Array<OfferDisplay>;
};


export type QueryReportChartArgs = {
  params: ReportParamsInput;
};


export type QueryRestrictedProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeSwagCollectionProducts?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRestrictedSwagCollectionProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStoreCheckoutEstimateArgs = {
  input: StoreCheckoutEstimateInput;
};


export type QueryStoreOrderArgs = {
  collectionId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryStoreSearchArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  isSwag?: InputMaybe<Scalars['Boolean']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  searchSessionId?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<BusinessSegment>;
};


export type QuerySwagSearchArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  filters: StoreFiltersInput;
  query: Scalars['String']['input'];
  searchSessionId?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<BusinessSegment>;
};


export type QuerySwagTemplateBrandsArgs = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  filters: StoreFiltersInput;
};


export type QuerySwagTemplatesPaginatedArgs = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  filters: StoreFiltersInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QuerySwappableProductsSearchConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flexPreviewMode?: InputMaybe<FlexPreviewMode>;
  flexPrice?: InputMaybe<Scalars['Int']['input']>;
  ignoreCustomSwap?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  searchSessionId?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<BusinessSegment>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  showOnlyDomesticShipping?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVariantGroupsArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryWebflowAuthorArgs = {
  slug: Scalars['String']['input'];
};


export type QueryWebflowPostArgs = {
  slug: Scalars['String']['input'];
};


export type QueryWebflowPostsArgs = {
  authorSlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkspaceInviteArgs = {
  token: Scalars['String']['input'];
};

export enum RealmTtype {
  /** consumer */
  Consumer = 'CONSUMER',
  /** plus */
  Plus = 'PLUS'
}

export type RecentBudgetSetting = {
  __typename?: 'RecentBudgetSetting';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  recurrence: BudgetRecurrence;
};

export type RecentlyAcceptedGiftsSeries = {
  __typename?: 'RecentlyAcceptedGiftsSeries';
  items: Array<Gift>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RecipientGift = {
  __typename?: 'RecipientGift';
  acceptWithEmailOnly: Scalars['Boolean']['output'];
  acceptanceFixedAddress?: Maybe<MailingAddress>;
  canAccept?: Maybe<Scalars['Boolean']['output']>;
  canCompleteSwap?: Maybe<Scalars['Boolean']['output']>;
  canSwapBack: Scalars['Boolean']['output'];
  canUndoSwap: Scalars['Boolean']['output'];
  cardImage?: Maybe<Image>;
  cartHasInactiveItems: Scalars['Boolean']['output'];
  cartItemCount: Scalars['Int']['output'];
  cartProducts?: Maybe<Array<CartProduct>>;
  cartQuantities: Array<Scalars['Int']['output']>;
  collection?: Maybe<Collection>;
  collectionMultipleSelectCount?: Maybe<Scalars['Int']['output']>;
  collectionMultipleSelectMode?: Maybe<CollectionsMultipleSelectModeEnum>;
  collectionMultipleSelectPrice?: Maybe<Scalars['Int']['output']>;
  commerceAppTag?: Maybe<Scalars['String']['output']>;
  currentCountry: CountryCodeEnum;
  customStore?: Maybe<CustomStore>;
  customStoreMultipleSelectCount?: Maybe<Scalars['Int']['output']>;
  customStoreMultipleSelectMode?: Maybe<Scalars['String']['output']>;
  customStoreMultipleSelectPrice?: Maybe<Scalars['Int']['output']>;
  customUnwrapVideoUrlPrefix?: Maybe<Scalars['String']['output']>;
  detectedCountry: Scalars['String']['output'];
  giftBatchesDraftId?: Maybe<Scalars['ID']['output']>;
  giftCardVoucher?: Maybe<GiftCardVoucher>;
  giftCartProducts?: Maybe<Array<GiftCartProduct>>;
  hasThankYouNote: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internationalShippingTier?: Maybe<InternationalShippingTierEnum>;
  isAccepted: Scalars['Boolean']['output'];
  isCurrentCountryEligibleForShipping: Scalars['Boolean']['output'];
  isDirectSend: Scalars['Boolean']['output'];
  isEmailSet: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isGiftCollection: Scalars['Boolean']['output'];
  isPhoneSet: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  isPostAcceptVariantSwapEnabled: Scalars['Boolean']['output'];
  isPreview: Scalars['Boolean']['output'];
  isSample: Scalars['Boolean']['output'];
  isSmartLink: Scalars['Boolean']['output'];
  isSwappable: Scalars['Boolean']['output'];
  isSwappableForDigital: Scalars['Boolean']['output'];
  linkType: LinkType;
  logo?: Maybe<Image>;
  meetingInfo?: Maybe<GiftMeetingInfo>;
  meetingNeedsScheduling: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  orderTotals?: Maybe<OrderTotals>;
  originalCartProducts?: Maybe<Array<CartProduct>>;
  productSendType: Scalars['String']['output'];
  recipientEmailForAccept?: Maybe<Scalars['String']['output']>;
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  recipientHasBusinessEmail: Scalars['Boolean']['output'];
  recipientLastName?: Maybe<Scalars['String']['output']>;
  recipientShippingAddress?: Maybe<MailingAddress>;
  recipientTopupEnabled: Scalars['Boolean']['output'];
  requiresTwoFactorOnAccept: Scalars['Boolean']['output'];
  restrictedStatesForCurrentCountry: Array<Scalars['String']['output']>;
  senderFullName: Scalars['String']['output'];
  shipments?: Maybe<Array<Shipment>>;
  smartLinkApprovalRequired: Scalars['Boolean']['output'];
  smartLinkWorkEmailRequired: Scalars['Boolean']['output'];
  statsigKey: Scalars['String']['output'];
  status: Status;
  supportedCountries: Array<CountryCodeEnum>;
  swapCartProducts?: Maybe<Array<CartProduct>>;
  swapReferenceAmount: Scalars['Int']['output'];
  swapSubtotal: Scalars['Int']['output'];
  swapType?: Maybe<GiftSwapTypeEnum>;
  theme?: Maybe<Theme>;
  trackId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of RecipientThreadCreate. */
export type RecipientThreadCreatePayload = {
  __typename?: 'RecipientThreadCreatePayload';
  aiChatThreadId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of RecipientThreadUpdate. */
export type RecipientThreadUpdatePayload = {
  __typename?: 'RecipientThreadUpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Type of event recurrence */
export enum Recurrence {
  /** An event that repeats */
  Recurring = 'RECURRING',
  /** A one-time event */
  Single = 'SINGLE'
}

export type ReferralBanner = {
  __typename?: 'ReferralBanner';
  amount?: Maybe<Scalars['Int']['output']>;
  referrerName?: Maybe<Scalars['String']['output']>;
  showBanner: Scalars['Boolean']['output'];
};

export type ReferralError = {
  __typename?: 'ReferralError';
  email?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
};

export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  referrals: Array<ReferralInfo>;
  totalAmountCredited: Scalars['Int']['output'];
};

export type ReferralInfo = {
  __typename?: 'ReferralInfo';
  amountCredited: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

/** Autogenerated return type of ReferralInviteSend. */
export type ReferralInviteSendPayload = {
  __typename?: 'ReferralInviteSendPayload';
  error?: Maybe<Scalars['String']['output']>;
  invalidEmails?: Maybe<Array<ReferralError>>;
  ok: Scalars['Boolean']['output'];
  processedCount?: Maybe<Scalars['Int']['output']>;
};

export type ReferralOffer = {
  __typename?: 'ReferralOffer';
  ctaText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  messageText?: Maybe<Scalars['String']['output']>;
  offerDisplayType: OfferDisplay;
  referralCode?: Maybe<Scalars['String']['output']>;
};

export type ReportChart = {
  __typename?: 'ReportChart';
  acceptanceRate?: Maybe<ReportChartsAcceptanceRate>;
  acceptedGiftsCost?: Maybe<ReportChartsAcceptedGiftsCost>;
  cards?: Maybe<ReportChartsCards>;
  giftData?: Maybe<ReportChartsGiftData>;
  giftsAccepted?: Maybe<ReportChartsGiftsAccepted>;
  giftsSent?: Maybe<ReportChartsGiftsSent>;
  meetingsScheduled?: Maybe<ReportChartsMeetingScheduled>;
  pendingAndAcceptedSpend?: Maybe<ReportChartsPendingAndAcceptedSpend>;
  senders?: Maybe<ReportChartsSenders>;
  swapRate?: Maybe<ReportChartsSwapRate>;
  thankYouNotes?: Maybe<ReportChartsThankYouNotes>;
  timeToAccept?: Maybe<ReportChartsTimeToAccept>;
  timeToOpen?: Maybe<ReportChartsTimeToOpen>;
  topBrands?: Maybe<ReportChartsTopBrands>;
  topProducts?: Maybe<ReportChartsTopProducts>;
  totalViews?: Maybe<ReportChartsTotalViews>;
  viewCountPerGift?: Maybe<ReportChartsViewCountPerGift>;
};


export type ReportChartAcceptedGiftsCostArgs = {
  cohorted?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportChartGiftDataArgs = {
  segment?: InputMaybe<ReportChartsGiftDataSegment>;
};


export type ReportChartGiftsAcceptedArgs = {
  cohorted?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportChartGiftsSentArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type ReportChartSendersArgs = {
  cohorted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ReportChartTimeToAcceptArgs = {
  granularity: ReportChartsTimeToActionGranularity;
};


export type ReportChartTimeToOpenArgs = {
  granularity: ReportChartsTimeToActionGranularity;
};


export type ReportChartTopBrandsArgs = {
  segment: ReportChartsProductOrBrandSegment;
};


export type ReportChartTopProductsArgs = {
  segment: ReportChartsProductOrBrandSegment;
};

export type ReportChartsAcceptanceRate = {
  __typename?: 'ReportChartsAcceptanceRate';
  percentAccepted: Scalars['Int']['output'];
  percentNotOpened: Scalars['Int']['output'];
  percentOpened: Scalars['Int']['output'];
};

export type ReportChartsAcceptedGiftsCost = {
  __typename?: 'ReportChartsAcceptedGiftsCost';
  data: Array<ReportChartsAcceptedGiftsCostData>;
  totalCost: Scalars['Int']['output'];
  totalGifts: Scalars['Int']['output'];
};

export type ReportChartsAcceptedGiftsCostData = {
  __typename?: 'ReportChartsAcceptedGiftsCostData';
  cost: Scalars['Int']['output'];
  date: Scalars['ISO8601Date']['output'];
  gifts: Scalars['Int']['output'];
};

export type ReportChartsCards = {
  __typename?: 'ReportChartsCards';
  data: Array<ReportChartsCardsData>;
};

export type ReportChartsCardsData = {
  __typename?: 'ReportChartsCardsData';
  giftCount: Scalars['Int']['output'];
  giftPercent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageLargeUrl: Scalars['String']['output'];
  senders: Array<ReportChartsCardsDataSenders>;
};

export type ReportChartsCardsDataSenders = {
  __typename?: 'ReportChartsCardsDataSenders';
  name: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type ReportChartsGiftData = {
  __typename?: 'ReportChartsGiftData';
  csvData: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum ReportChartsGiftDataSegment {
  /** accepted_in_range */
  AcceptedInRange = 'accepted_in_range',
  /** sent_in_range */
  SentInRange = 'sent_in_range'
}

export type ReportChartsGiftsAccepted = {
  __typename?: 'ReportChartsGiftsAccepted';
  data: Array<ReportChartsGiftsWithDateData>;
  totalCount: Scalars['Int']['output'];
};

export type ReportChartsGiftsSent = {
  __typename?: 'ReportChartsGiftsSent';
  data: Array<ReportChartsGiftsWithDateData>;
  totalCount: Scalars['Int']['output'];
};

export type ReportChartsGiftsWithDateData = {
  __typename?: 'ReportChartsGiftsWithDateData';
  date: Scalars['ISO8601Date']['output'];
  gifts: Scalars['Int']['output'];
};

export type ReportChartsMeetingScheduled = {
  __typename?: 'ReportChartsMeetingScheduled';
  data: Array<ReportChartsMeetingsScheduledData>;
  totalCount: Scalars['Int']['output'];
};

export type ReportChartsMeetingsScheduledData = {
  __typename?: 'ReportChartsMeetingsScheduledData';
  date: Scalars['ISO8601Date']['output'];
  meetingsScheduled: Scalars['Int']['output'];
};

export type ReportChartsPendingAndAcceptedSpend = {
  __typename?: 'ReportChartsPendingAndAcceptedSpend';
  acceptedAmount: Scalars['Int']['output'];
  acceptedGifts: Scalars['Int']['output'];
  acceptedPercent: Scalars['Int']['output'];
  pendingAmount: Scalars['Int']['output'];
  pendingGifts: Scalars['Int']['output'];
  pendingPercent: Scalars['Int']['output'];
};

export enum ReportChartsProductOrBrandSegment {
  /** accepted */
  Accepted = 'accepted',
  /** sent */
  Sent = 'sent',
  /** swapped */
  Swapped = 'swapped'
}

export type ReportChartsSenders = {
  __typename?: 'ReportChartsSenders';
  data: Array<ReportChartsSendersData>;
  totalCount: Scalars['Int']['output'];
};

export type ReportChartsSendersData = {
  __typename?: 'ReportChartsSendersData';
  giftsAccepted: Scalars['Int']['output'];
  giftsSent: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalSpent: Scalars['Int']['output'];
};

export type ReportChartsSwapRate = {
  __typename?: 'ReportChartsSwapRate';
  percentageSwapped: Scalars['Float']['output'];
};

export type ReportChartsThankYouNotes = {
  __typename?: 'ReportChartsThankYouNotes';
  data: Array<ReportChartsThankYouNotesData>;
  totalCount: Scalars['Int']['output'];
};


export type ReportChartsThankYouNotesDataArgs = {
  offset: Scalars['Int']['input'];
};

export type ReportChartsThankYouNotesData = {
  __typename?: 'ReportChartsThankYouNotesData';
  giftBatchId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  workspaceName: Scalars['String']['output'];
};

export type ReportChartsTimeToAccept = {
  __typename?: 'ReportChartsTimeToAccept';
  data: Array<ReportChartsTimeToAcceptData>;
  median: Scalars['Float']['output'];
};

export type ReportChartsTimeToAcceptData = {
  __typename?: 'ReportChartsTimeToAcceptData';
  bucket: Scalars['Int']['output'];
  gifts: Scalars['Int']['output'];
};

export enum ReportChartsTimeToActionGranularity {
  /** days */
  Days = 'days',
  /** hours */
  Hours = 'hours'
}

export type ReportChartsTimeToOpen = {
  __typename?: 'ReportChartsTimeToOpen';
  data: Array<ReportChartsTimeToOpenData>;
  median: Scalars['Float']['output'];
};

export type ReportChartsTimeToOpenData = {
  __typename?: 'ReportChartsTimeToOpenData';
  bucket: Scalars['Int']['output'];
  gifts: Scalars['Int']['output'];
};

export type ReportChartsTopBrands = {
  __typename?: 'ReportChartsTopBrands';
  data: Array<ReportChartsTopBrandsData>;
};

export type ReportChartsTopBrandsData = {
  __typename?: 'ReportChartsTopBrandsData';
  brandName: Scalars['String']['output'];
  brandSlug: Scalars['String']['output'];
  giftCount: Scalars['Int']['output'];
  giftOptionSlug?: Maybe<Scalars['String']['output']>;
  giftPercent: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
};

export type ReportChartsTopProducts = {
  __typename?: 'ReportChartsTopProducts';
  data: Array<ReportChartsTopProductsData>;
};

export type ReportChartsTopProductsData = {
  __typename?: 'ReportChartsTopProductsData';
  brandName: Scalars['String']['output'];
  brandSlug: Scalars['String']['output'];
  giftCount: Scalars['Int']['output'];
  giftPercent: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productSlug: Scalars['String']['output'];
};

export type ReportChartsTotalViews = {
  __typename?: 'ReportChartsTotalViews';
  data: Array<ReportChartsTotalViewsData>;
  totalCount: Scalars['Float']['output'];
};

export type ReportChartsTotalViewsData = {
  __typename?: 'ReportChartsTotalViewsData';
  date: Scalars['ISO8601Date']['output'];
  views: Scalars['Int']['output'];
};

export type ReportChartsViewCountPerGift = {
  __typename?: 'ReportChartsViewCountPerGift';
  data: Array<ReportChartsViewCountPerGiftData>;
  median: Scalars['Float']['output'];
};

export type ReportChartsViewCountPerGiftData = {
  __typename?: 'ReportChartsViewCountPerGiftData';
  bucket: Scalars['String']['output'];
  gifts: Scalars['Int']['output'];
};

export type ReportFilterClass = {
  __typename?: 'ReportFilterClass';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options: Array<ReportFilterOption>;
};

export type ReportFilterOption = {
  __typename?: 'ReportFilterOption';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ReportParamsInput = {
  autogiftType?: InputMaybe<Array<Scalars['String']['input']>>;
  balance?: InputMaybe<Array<Scalars['String']['input']>>;
  dateEnd: Scalars['ISO8601Date']['input'];
  dateStart: Scalars['ISO8601Date']['input'];
  giftBatch?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of ReportsValidateGiftBatchPublicId. */
export type ReportsValidateGiftBatchPublicIdPayload = {
  __typename?: 'ReportsValidateGiftBatchPublicIdPayload';
  firstGiftDate?: Maybe<Scalars['ISO8601Date']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ResendInvite. */
export type ResendInvitePayload = {
  __typename?: 'ResendInvitePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  userPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ResyncIntegration. */
export type ResyncIntegrationPayload = {
  __typename?: 'ResyncIntegrationPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of RetryFailedEmailDelivery. */
export type RetryFailedEmailDeliveryPayload = {
  __typename?: 'RetryFailedEmailDeliveryPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of RevokeInvite. */
export type RevokeInvitePayload = {
  __typename?: 'RevokeInvitePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum SalesforceEvent {
  Accepted = 'ACCEPTED',
  AcceptedWithThankYou = 'ACCEPTED_WITH_THANK_YOU',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  GiftSwapped = 'GIFT_SWAPPED',
  Opened = 'OPENED',
  Ordered = 'ORDERED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  Shipped = 'SHIPPED',
  ThankYouAdded = 'THANK_YOU_ADDED'
}

export type SalesforceEventData = {
  __typename?: 'SalesforceEventData';
  brand: Scalars['String']['output'];
  brandAndProduct: Scalars['String']['output'];
  campaignName?: Maybe<Scalars['String']['output']>;
  eventType: SalesforceEvent;
  giftPriceFinal?: Maybe<Scalars['Float']['output']>;
  giftPriceInitialEstimate?: Maybe<Scalars['Float']['output']>;
  goodyGiftBatchId: Scalars['String']['output'];
  goodyGiftId: Scalars['String']['output'];
  isSwapped: Scalars['Boolean']['output'];
  meetingScheduled: Scalars['Boolean']['output'];
  orgId: Scalars['String']['output'];
  preSwapBrand?: Maybe<Scalars['String']['output']>;
  preSwapProduct?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  productCategory?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productImageUrl?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  salesforceContactId?: Maybe<Scalars['String']['output']>;
  salesforceLeadId?: Maybe<Scalars['String']['output']>;
  salesforceOpportunityId?: Maybe<Scalars['String']['output']>;
  salesforceUserId?: Maybe<Scalars['String']['output']>;
  sendSource?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName: Scalars['String']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  thankYouNote?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['ISO8601DateTime']['output'];
};

/** Additional data for Salesforce sends to attach to the gift batch */
export type SalesforceGiftBatchDataInput = {
  authorization: Scalars['String']['input'];
  salesforceOrgId: Scalars['String']['input'];
  salesforceUserEmail: Scalars['String']['input'];
  salesforceUserId: Scalars['String']['input'];
};

export type SalesforceRecipientDataInput = {
  salesforceContactCompanyName?: InputMaybe<Scalars['String']['input']>;
  salesforceContactId?: InputMaybe<Scalars['String']['input']>;
  salesforceContactTitle?: InputMaybe<Scalars['String']['input']>;
  salesforceLeadId?: InputMaybe<Scalars['String']['input']>;
  salesforceOpportunityId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SalesforceValidateSendPayload. */
export type SalesforceValidateSendPayloadPayload = {
  __typename?: 'SalesforceValidateSendPayloadPayload';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SampleGift = {
  __typename?: 'SampleGift';
  id: Scalars['ID']['output'];
  recipientAccessLink: Scalars['String']['output'];
};

/** Autogenerated return type of SampleGiftCreate. */
export type SampleGiftCreatePayload = {
  __typename?: 'SampleGiftCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  sampleGift?: Maybe<SampleGift>;
  sampleGiftLink?: Maybe<Scalars['String']['output']>;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  color?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  day: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  featured: Scalars['Boolean']['output'];
  giftBatch?: Maybe<GiftBatch>;
  giftIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: EventKind;
  logoUrl?: Maybe<Scalars['String']['output']>;
  month: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<EventOwner>;
  recurrenceType?: Maybe<Recurrence>;
  relevantEvent?: Maybe<Event>;
  relevantRecurrence?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type ScheduledEventGiftBatchArgs = {
  anchorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type ScheduledEventRelevantEventArgs = {
  anchorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type ScheduledEventRelevantRecurrenceArgs = {
  anchorDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type ScheduledEventInput = {
  day: Scalars['Int']['input'];
  kind?: InputMaybe<EventKind>;
  month: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum SendAudience {
  /** Customers */
  Customers = 'customers',
  /** Employees */
  Employees = 'employees',
  /** Other */
  Other = 'other',
  /** Sales Prospects */
  SalesProspects = 'sales_prospects'
}

/** Autogenerated return type of SendReminder. */
export type SendReminderPayload = {
  __typename?: 'SendReminderPayload';
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendRemindersForGifts. */
export type SendRemindersForGiftsPayload = {
  __typename?: 'SendRemindersForGiftsPayload';
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum SendTypeEnum {
  /** BATCH */
  Batch = 'batch',
  /** STANDARD */
  Standard = 'standard'
}

/** Autogenerated return type of SetLastRealm. */
export type SetLastRealmPayload = {
  __typename?: 'SetLastRealmPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SetStoreReview. */
export type SetStoreReviewPayload = {
  __typename?: 'SetStoreReviewPayload';
  ok: Scalars['Boolean']['output'];
};

export type Shipment = {
  __typename?: 'Shipment';
  brand: Brand;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryEta?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  shippedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: ShipmentStatus;
  trackingCarrier?: Maybe<Scalars['String']['output']>;
  trackingEvents?: Maybe<Array<ShipmentTrackingEvent>>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export enum ShipmentStatus {
  /** Delivered */
  Delivered = 'delivered',
  /** Delivered Override */
  DeliveredOverride = 'delivered_override',
  /** Delivered Override Canceled */
  DeliveredOverrideCanceled = 'delivered_override_canceled',
  /** Failed */
  Failed = 'failed',
  /** Failed Unset Tracking */
  FailedUnsetTracking = 'failed_unset_tracking',
  /** Failed With Reship */
  FailedWithReship = 'failed_with_reship',
  /** Pending */
  Pending = 'pending',
  /** Shipped */
  Shipped = 'shipped',
  /** Tracking */
  Tracking = 'tracking'
}

export type ShipmentTrackingEvent = {
  __typename?: 'ShipmentTrackingEvent';
  datetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  locationString?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtagMessage?: Maybe<Scalars['String']['output']>;
};

export type ShippingCountry = {
  __typename?: 'ShippingCountry';
  code: CountryCodeEnum;
  groups: Array<ShippingCountryGroupEnum>;
  name: Scalars['String']['output'];
};

export type ShippingCountryGroup = {
  __typename?: 'ShippingCountryGroup';
  digital?: Maybe<Array<CountryCodeEnum>>;
  domestic?: Maybe<Array<CountryCodeEnum>>;
  giftCard?: Maybe<Array<CountryCodeEnum>>;
  global?: Maybe<Array<CountryCodeEnum>>;
  globalRelay?: Maybe<Array<CountryCodeEnum>>;
  passthrough?: Maybe<Array<CountryCodeEnum>>;
};

export enum ShippingCountryGroupEnum {
  Domestic = 'domestic',
  GiftCard = 'gift_card',
  Global = 'global'
}

export enum Status {
  /** Accepted */
  Accepted = 'accepted',
  /** Cancelled Internal */
  CancelledInternal = 'cancelled_internal',
  /** Cancelled User */
  CancelledUser = 'cancelled_user',
  /** Created */
  Created = 'created',
  /** Declined */
  Declined = 'declined',
  /** Delivered */
  Delivered = 'delivered',
  /** Delivery Failed */
  DeliveryFailed = 'delivery_failed',
  /** Ineligible */
  Ineligible = 'ineligible',
  /** Notification Failed */
  NotificationFailed = 'notification_failed',
  /** Notified */
  Notified = 'notified',
  /** Opened */
  Opened = 'opened',
  /** Ordered */
  Ordered = 'ordered',
  /** Paid */
  Paid = 'paid',
  /** Pending Payment */
  PendingPayment = 'pending_payment',
  /** Pending Payment Approval */
  PendingPaymentApproval = 'pending_payment_approval',
  /** Pending User Approval */
  PendingUserApproval = 'pending_user_approval',
  /** Shipped */
  Shipped = 'shipped'
}

export enum StatusEnum {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** INACTIVE */
  Inactive = 'INACTIVE'
}

/** Autogenerated return type of StoreCheckoutCreate. */
export type StoreCheckoutCreatePayload = {
  __typename?: 'StoreCheckoutCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<RecipientGift>;
  ok: Scalars['Boolean']['output'];
};

/** Price breakdown for a Company Store checkout preview. */
export type StoreCheckoutEstimate = {
  __typename?: 'StoreCheckoutEstimate';
  amountProductCents: Scalars['Int']['output'];
  amountShippingCents: Scalars['Int']['output'];
  amountTaxCents: Scalars['Int']['output'];
  amountTotalCents: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
};

/** Payload for estimating the pricing of a Company Store checkout. Shipping country is derived from `address.country`. */
export type StoreCheckoutEstimateInput = {
  address?: InputMaybe<AddressInput>;
  collectionId: Scalars['ID']['input'];
  items: Array<CheckoutItemInput>;
};

/** Payload for creating an order through Company Store checkout */
export type StoreCheckoutInput = {
  address: AddressInput;
  collectionId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  items: Array<CheckoutItemInput>;
  lastName: Scalars['String']['input'];
  payment: CheckoutPaymentInput;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type StoreFiltersInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  fastTurnaround?: InputMaybe<Scalars['Boolean']['input']>;
  noMinimumQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  priceRange?: InputMaybe<PriceRangeInput>;
  shippingCountries?: InputMaybe<Array<CountryCodeEnum>>;
};

export type StoreOrder = {
  __typename?: 'StoreOrder';
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Derived state for the org admin Store Order dashboard: processing / shipped / delivered / cancelled. */
  dashboardState: StoreOrderDashboardStateEnum;
  id: Scalars['ID']['output'];
  orderItems: Array<StoreOrderItem>;
  orderNumber: Scalars['String']['output'];
  owner: StoreOrderOwner;
  productAmountCents: Scalars['Int']['output'];
  /** Per-brand shipments associated with this order. Empty until the gift transitions to shipped/delivered. */
  shipments: Array<StoreOrderShipment>;
  shippingAmountCents: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  taxAmountCents: Scalars['Int']['output'];
  totalAmountCents: Scalars['Int']['output'];
};

/** The connection type for StoreOrder. */
export type StoreOrderConnection = {
  __typename?: 'StoreOrderConnection';
  /** A list of edges. */
  edges: Array<StoreOrderEdge>;
  /** A list of nodes. */
  nodes: Array<StoreOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum StoreOrderDashboardStateEnum {
  Cancelled = 'cancelled',
  Delivered = 'delivered',
  Processing = 'processing',
  Shipped = 'shipped'
}

/** An edge in a connection. */
export type StoreOrderEdge = {
  __typename?: 'StoreOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StoreOrder>;
};

export type StoreOrderItem = {
  __typename?: 'StoreOrderItem';
  brand: Brand;
  id: Scalars['ID']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  totalAmountCents: Scalars['Int']['output'];
  unitPriceCents: Scalars['Int']['output'];
};

export type StoreOrderOwner = {
  __typename?: 'StoreOrderOwner';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type StoreOrderShipment = {
  __typename?: 'StoreOrderShipment';
  brandName?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  shippedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  trackingCarrier?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type StoreOrdersSummary = {
  __typename?: 'StoreOrdersSummary';
  /** Number of store orders placed in the summary window (last 30 days). */
  orderCount: Scalars['Int']['output'];
  /** Sum of amount_total across store orders in the summary window (last 30 days). */
  salesTotalCents: Scalars['Int']['output'];
};

export enum StorePlatformEnum {
  Mobile = 'mobile',
  Swap = 'swap',
  Web = 'web'
}

/** Location in app for a potential review */
export enum StoreReviewSource {
  /** After checking out */
  AfterCheckout = 'AFTER_CHECKOUT',
  /** After sending a gift */
  AfterGiftSend = 'AFTER_GIFT_SEND',
  /** After receiving a thank you */
  AfterThankYouViewed = 'AFTER_THANK_YOU_VIEWED'
}

export type StoreSearchResponse = {
  __typename?: 'StoreSearchResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<StoreSearchResult>>;
  searchRecordId?: Maybe<Scalars['String']['output']>;
  searchSessionId?: Maybe<Scalars['String']['output']>;
};

export type StoreSearchResult = {
  __typename?: 'StoreSearchResult';
  giftOption?: Maybe<GiftOption>;
  id: Scalars['ID']['output'];
  itemType: Scalars['String']['output'];
  product?: Maybe<Product>;
  searchRecordId: Scalars['String']['output'];
};

export type StoredValueTransaction = {
  __typename?: 'StoredValueTransaction';
  amountAfter: Scalars['Int']['output'];
  amountBefore: Scalars['Int']['output'];
  amountDiff: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<StoredValueTransactionGift>;
  id: Scalars['ID']['output'];
  ttype: StoredValueTransactionTtype;
};

export type StoredValueTransactionGift = {
  __typename?: 'StoredValueTransactionGift';
  amountCreditApplied: Scalars['Int']['output'];
  amountProcessingFee: Scalars['Int']['output'];
  amountProduct: Scalars['Int']['output'];
  amountShipping: Scalars['Int']['output'];
  amountTax?: Maybe<Scalars['Int']['output']>;
  amountTotal?: Maybe<Scalars['Int']['output']>;
  cartSummary: Array<Scalars['String']['output']>;
  giftBatchId?: Maybe<Scalars['ID']['output']>;
  giftBatchName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  recipientLastName?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
};

export type StoredValueTransactionSeries = {
  __typename?: 'StoredValueTransactionSeries';
  items: Array<StoredValueTransaction>;
  totalCount: Scalars['Int']['output'];
};

export enum StoredValueTransactionTtype {
  /** Debit */
  Debit = 'DEBIT',
  /** Manual */
  Manual = 'MANUAL',
  /** Refund */
  Refund = 'REFUND'
}

export type StructuredAddress = {
  __typename?: 'StructuredAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<CountryCodeEnum>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SubscriptionCreate. */
export type SubscriptionCreatePayload = {
  __typename?: 'SubscriptionCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  created: Scalars['ISO8601Date']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export enum SubscriptionManagement {
  Managed = 'MANAGED',
  SelfServe = 'SELF_SERVE'
}

export enum SubscriptionOwnerType {
  /** ORGANIZATION */
  Organization = 'ORGANIZATION',
  /** USER */
  User = 'USER'
}

export enum SubscriptionPlanSku {
  BusinessEmployeeSmallbusiness_2022bMonthly = 'business_employee_smallbusiness_2022b_monthly',
  BusinessEmployeeSmallbusiness_2022bYearly = 'business_employee_smallbusiness_2022b_yearly',
  BusinessEmployeeSmallbusinessMonthly = 'business_employee_smallbusiness_monthly',
  BusinessEmployeeSmallbusinessYearly = 'business_employee_smallbusiness_yearly',
  BusinessEmployeeStandardMonthly = 'business_employee_standard_monthly',
  BusinessEmployeeStandardYearly = 'business_employee_standard_yearly',
  BusinessProMonthly = 'business_pro_monthly',
  BusinessProYearly = 'business_pro_yearly',
  BusinessTeamBaseMonthly_2022a = 'business_team_base_monthly_2022a',
  BusinessTeamBaseMonthly_2025 = 'business_team_base_monthly_2025',
  BusinessTeamBaseYearly_2022a = 'business_team_base_yearly_2022a',
  BusinessTeamBaseYearly_2025 = 'business_team_base_yearly_2025',
  BusinessTeamEnterpriseMonthly_2022a = 'business_team_enterprise_monthly_2022a',
  BusinessTeamEnterpriseMonthly_2025 = 'business_team_enterprise_monthly_2025',
  BusinessTeamEnterpriseYearly_2022a = 'business_team_enterprise_yearly_2022a',
  BusinessTeamEnterpriseYearly_2025 = 'business_team_enterprise_yearly_2025',
  BusinessTeamGrowthMonthly_2022a = 'business_team_growth_monthly_2022a',
  BusinessTeamGrowthMonthly_2025 = 'business_team_growth_monthly_2025',
  BusinessTeamGrowthYearly_2022a = 'business_team_growth_yearly_2022a',
  BusinessTeamGrowthYearly_2025 = 'business_team_growth_yearly_2025'
}

/** Autogenerated return type of SubscriptionPriceEstimate. */
export type SubscriptionPriceEstimatePayload = {
  __typename?: 'SubscriptionPriceEstimatePayload';
  estimatedTax?: Maybe<Scalars['Int']['output']>;
  estimatedTotal: Scalars['Int']['output'];
};

/** Autogenerated return type of SubscriptionRegisterCancellation. */
export type SubscriptionRegisterCancellationPayload = {
  __typename?: 'SubscriptionRegisterCancellationPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum SubscriptionTrialCardStatus {
  Cardless = 'CARDLESS',
  CardEntered = 'CARD_ENTERED'
}

export enum SwagIntegrationsActions {
  Delete = 'delete',
  Update = 'update'
}

/** Autogenerated return type of SwagIntegrationsApplySwagMaximumPrice. */
export type SwagIntegrationsApplySwagMaximumPricePayload = {
  __typename?: 'SwagIntegrationsApplySwagMaximumPricePayload';
  error?: Maybe<Scalars['String']['output']>;
  /** Number of products newly filtered out by the new max price */
  hiddenCount: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  /** Number of products with manual overrides that exceed the new max price. Use this to prompt the user about clearing overrides. */
  overrideConflictCount: Scalars['Int']['output'];
  /** The updated swag collection integration */
  swag?: Maybe<CollectionsSwagType>;
  /** Number of products now visible due to raising the max price */
  unhiddenCount: Scalars['Int']['output'];
};

/** Autogenerated return type of SwagIntegrationsArchiveCustomProduct. */
export type SwagIntegrationsArchiveCustomProductPayload = {
  __typename?: 'SwagIntegrationsArchiveCustomProductPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsClearAllSwagMaxPriceOverrides. */
export type SwagIntegrationsClearAllSwagMaxPriceOverridesPayload = {
  __typename?: 'SwagIntegrationsClearAllSwagMaxPriceOverridesPayload';
  /** Number of overrides cleared */
  clearedCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsCreateCustomProductRequest. */
export type SwagIntegrationsCreateCustomProductRequestPayload = {
  __typename?: 'SwagIntegrationsCreateCustomProductRequestPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  requestId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of SwagIntegrationsCreateQuoteRequest. */
export type SwagIntegrationsCreateQuoteRequestPayload = {
  __typename?: 'SwagIntegrationsCreateQuoteRequestPayload';
  error?: Maybe<Scalars['JSON']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsCreateSwagCollection. */
export type SwagIntegrationsCreateSwagCollectionPayload = {
  __typename?: 'SwagIntegrationsCreateSwagCollectionPayload';
  collection?: Maybe<Collection>;
  ok: Scalars['Boolean']['output'];
};

export type SwagIntegrationsCustomProductIntegration = {
  __typename?: 'SwagIntegrationsCustomProductIntegration';
  /** Cached price including shipping for efficient max price filtering */
  cachedPriceWithShippingCents?: Maybe<Scalars['Int']['output']>;
  /** The collection categories for this product (can be in multiple categories) */
  collectionCategories: Array<SwagIntegrationsProductCollectionCategory>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  customProduct?: Maybe<Product>;
  id: Scalars['ID']['output'];
  interface: SwagIntegrationsEditorInterface;
  /** Whether this product has been manually overridden to show despite exceeding the max price */
  maxPriceOverride: Scalars['Boolean']['output'];
  previewImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  swagProductExternalId?: Maybe<Scalars['String']['output']>;
  swagProductId?: Maybe<Scalars['ID']['output']>;
  swagTemplateExternalId: Scalars['String']['output'];
  swagTemplateId: Scalars['ID']['output'];
};

/** The connection type for SwagIntegrationsCustomProductIntegration. */
export type SwagIntegrationsCustomProductIntegrationConnection = {
  __typename?: 'SwagIntegrationsCustomProductIntegrationConnection';
  /** A list of edges. */
  edges: Array<SwagIntegrationsCustomProductIntegrationEdge>;
  /** A list of nodes. */
  nodes: Array<SwagIntegrationsCustomProductIntegration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SwagIntegrationsCustomProductIntegrationEdge = {
  __typename?: 'SwagIntegrationsCustomProductIntegrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SwagIntegrationsCustomProductIntegration>;
};

/** Autogenerated return type of SwagIntegrationsCustomizeFromStorePreview. */
export type SwagIntegrationsCustomizeFromStorePreviewPayload = {
  __typename?: 'SwagIntegrationsCustomizeFromStorePreviewPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsEditCustomProduct. */
export type SwagIntegrationsEditCustomProductPayload = {
  __typename?: 'SwagIntegrationsEditCustomProductPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum SwagIntegrationsEditorInterface {
  CorporateMerch = 'corporate_merch',
  Goody = 'goody',
  Printify = 'printify'
}

export type SwagIntegrationsEngine_Color = {
  __typename?: 'SwagIntegrationsEngine_Color';
  domIds: Array<Scalars['ID']['output']>;
  hex: Scalars['String']['output'];
};

export type SwagIntegrationsEngine_CorporateMerch = {
  __typename?: 'SwagIntegrationsEngine_CorporateMerch';
  iframeUrl: Scalars['String']['output'];
};

/** Autogenerated return type of SwagIntegrationsEngine_CreateProductImage. */
export type SwagIntegrationsEngine_CreateProductImagePayload = {
  __typename?: 'SwagIntegrationsEngine_CreateProductImagePayload';
  error?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SwagIntegrationsEngine_ProductImage>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsEngine_DeleteProductImage. */
export type SwagIntegrationsEngine_DeleteProductImagePayload = {
  __typename?: 'SwagIntegrationsEngine_DeleteProductImagePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum SwagIntegrationsEngine_EditorInterface {
  CorporateMerch = 'corporate_merch',
  Goody = 'goody',
  Printify = 'printify'
}

/** Autogenerated return type of SwagIntegrationsEngine_GenerateMockups. */
export type SwagIntegrationsEngine_GenerateMockupsPayload = {
  __typename?: 'SwagIntegrationsEngine_GenerateMockupsPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  product?: Maybe<SwagIntegrationsEngine_Product>;
};

/** Autogenerated return type of SwagIntegrationsEngine_MoveAllImagesToPrintArea. */
export type SwagIntegrationsEngine_MoveAllImagesToPrintAreaPayload = {
  __typename?: 'SwagIntegrationsEngine_MoveAllImagesToPrintAreaPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SwagIntegrationsEngine_PrintArea = {
  __typename?: 'SwagIntegrationsEngine_PrintArea';
  canvas: Array<SwagIntegrationsEngine_PrintAreaCanvas>;
  domId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type SwagIntegrationsEngine_PrintAreaCanvas = {
  __typename?: 'SwagIntegrationsEngine_PrintAreaCanvas';
  id: Scalars['ID']['output'];
  svgUrl: Scalars['String']['output'];
  variantGroupOptionIds: Array<Scalars['ID']['output']>;
};

export type SwagIntegrationsEngine_Product = {
  __typename?: 'SwagIntegrationsEngine_Product';
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<SwagIntegrationsEngine_ProductImage>>;
  previewImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  variantGroupOptionId?: Maybe<Scalars['ID']['output']>;
};


export type SwagIntegrationsEngine_ProductImagesArgs = {
  externalProductId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwagIntegrationsEngine_ProductImage = {
  __typename?: 'SwagIntegrationsEngine_ProductImage';
  angle: Scalars['Int']['output'];
  autocolorEnabled: Scalars['Boolean']['output'];
  dpi: Scalars['Int']['output'];
  extension: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  originalExtension: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  printAreaId: Scalars['ID']['output'];
  scale: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SwagIntegrationsEngine_Template = {
  __typename?: 'SwagIntegrationsEngine_Template';
  colorVariantGroup?: Maybe<SwagIntegrationsEngine_VariantGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onlyOneImageAllowedPerProduct: Scalars['Boolean']['output'];
  onlyOnePrintAreaAllowedPerProduct: Scalars['Boolean']['output'];
  printAreas: Array<SwagIntegrationsEngine_PrintArea>;
};

/** Autogenerated return type of SwagIntegrationsEngine_UpdateProductImage. */
export type SwagIntegrationsEngine_UpdateProductImagePayload = {
  __typename?: 'SwagIntegrationsEngine_UpdateProductImagePayload';
  error?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SwagIntegrationsEngine_ProductImage>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SwagIntegrationsEngine_UpdateProduct. */
export type SwagIntegrationsEngine_UpdateProductPayload = {
  __typename?: 'SwagIntegrationsEngine_UpdateProductPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  product?: Maybe<SwagIntegrationsEngine_Product>;
};

export type SwagIntegrationsEngine_VariantGroup = {
  __typename?: 'SwagIntegrationsEngine_VariantGroup';
  options: Array<SwagIntegrationsEngine_VariantGroupOption>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SwagIntegrationsEngine_VariantGroupOption = {
  __typename?: 'SwagIntegrationsEngine_VariantGroupOption';
  availableInStock: Scalars['Boolean']['output'];
  colors: Array<SwagIntegrationsEngine_Color>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** Autogenerated return type of SwagIntegrationsGenerateStorePreview. */
export type SwagIntegrationsGenerateStorePreviewPayload = {
  __typename?: 'SwagIntegrationsGenerateStorePreviewPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  storePreview?: Maybe<SwagIntegrationsCustomProductIntegration>;
};

/** Autogenerated return type of SwagIntegrationsPoolCustomProduct. */
export type SwagIntegrationsPoolCustomProductPayload = {
  __typename?: 'SwagIntegrationsPoolCustomProductPayload';
  customProduct?: Maybe<Product>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SwagIntegrationsProductCollectionCategory = {
  __typename?: 'SwagIntegrationsProductCollectionCategory';
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** Autogenerated return type of SwagIntegrationsSetSwagProductMaxPriceOverride. */
export type SwagIntegrationsSetSwagProductMaxPriceOverridePayload = {
  __typename?: 'SwagIntegrationsSetSwagProductMaxPriceOverridePayload';
  /** The updated custom product integration */
  customProductIntegration?: Maybe<SwagIntegrationsCustomProductIntegration>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SwagIntegrationsSwagMaker = {
  __typename?: 'SwagIntegrationsSwagMaker';
  autocolorEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organizationImage?: Maybe<OrganizationImage>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Returns the org's most recent swag collection if one exists */
  swagCollection?: Maybe<Collection>;
};

export enum SwagIntegrationsType {
  Product = 'product',
  Template = 'template'
}

export type SwagIntegrations_MutationType = {
  __typename?: 'SwagIntegrations_MutationType';
  /** Apply a maximum price filter to swag products in a collection */
  applySwagMaximumPrice: SwagIntegrationsApplySwagMaximumPricePayload;
  archiveCustomProduct: SwagIntegrationsArchiveCustomProductPayload;
  /** Clear all max price overrides for products in a collection that exceed the current max price */
  clearAllSwagMaxPriceOverrides: SwagIntegrationsClearAllSwagMaxPriceOverridesPayload;
  /** Create a swag collection with custom products for the organization */
  createSwagCollection: SwagIntegrationsCreateSwagCollectionPayload;
  /** Main entrypoint for the SwagIntegrations graphql product mutations */
  customProductIntegration: SwagIntegrations_ProductMutation;
  customizeFromStorePreview: SwagIntegrationsCustomizeFromStorePreviewPayload;
  editCustomProduct: SwagIntegrationsEditCustomProductPayload;
  generateStorePreview: SwagIntegrationsGenerateStorePreviewPayload;
  poolCustomProduct: SwagIntegrationsPoolCustomProductPayload;
  requestCustomProduct: SwagIntegrationsCreateCustomProductRequestPayload;
  /** Set or clear a max price override on a swag product */
  setSwagProductMaxPriceOverride: SwagIntegrationsSetSwagProductMaxPriceOverridePayload;
  /** Update swag maker settings */
  updateSwagMaker: UpdateSwagMakerPayload;
};


export type SwagIntegrations_MutationTypeApplySwagMaximumPriceArgs = {
  collectionIntegrationId: Scalars['ID']['input'];
  maximumPrice?: InputMaybe<Scalars['Int']['input']>;
};


export type SwagIntegrations_MutationTypeArchiveCustomProductArgs = {
  productId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeClearAllSwagMaxPriceOverridesArgs = {
  collectionIntegrationId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeCreateSwagCollectionArgs = {
  autocolorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationImageId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeCustomProductIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeCustomizeFromStorePreviewArgs = {
  customProductIntegrationId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeEditCustomProductArgs = {
  productId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeGenerateStorePreviewArgs = {
  autocolorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  generateAsync?: InputMaybe<Scalars['Boolean']['input']>;
  organizationImageId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  variantGroupOptionId?: InputMaybe<Scalars['ID']['input']>;
};


export type SwagIntegrations_MutationTypePoolCustomProductArgs = {
  requestId: Scalars['ID']['input'];
};


export type SwagIntegrations_MutationTypeRequestCustomProductArgs = {
  customProductIntegrationId: Scalars['ID']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
};


export type SwagIntegrations_MutationTypeSetSwagProductMaxPriceOverrideArgs = {
  customProductIntegrationId: Scalars['ID']['input'];
  override: Scalars['Boolean']['input'];
};


export type SwagIntegrations_MutationTypeUpdateSwagMakerArgs = {
  autocolorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwagIntegrations_ProductMutation = {
  __typename?: 'SwagIntegrations_ProductMutation';
  createImage: SwagIntegrationsEngine_CreateProductImagePayload;
  deleteImage: SwagIntegrationsEngine_DeleteProductImagePayload;
  generateMockups: SwagIntegrationsEngine_GenerateMockupsPayload;
  moveAllImagesToPrintArea: SwagIntegrationsEngine_MoveAllImagesToPrintAreaPayload;
  updateImage: SwagIntegrationsEngine_UpdateProductImagePayload;
  updateProduct: SwagIntegrationsEngine_UpdateProductPayload;
};


export type SwagIntegrations_ProductMutationCreateImageArgs = {
  organizationImageId: Scalars['ID']['input'];
  printAreaId: Scalars['ID']['input'];
};


export type SwagIntegrations_ProductMutationDeleteImageArgs = {
  imageId: Scalars['ID']['input'];
};


export type SwagIntegrations_ProductMutationMoveAllImagesToPrintAreaArgs = {
  printAreaId: Scalars['ID']['input'];
};


export type SwagIntegrations_ProductMutationUpdateImageArgs = {
  angle?: InputMaybe<Scalars['Int']['input']>;
  autocolorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoplace?: InputMaybe<Scalars['Boolean']['input']>;
  imageId: Scalars['ID']['input'];
  scale?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};


export type SwagIntegrations_ProductMutationUpdateProductArgs = {
  editorInterface?: InputMaybe<SwagIntegrationsEngine_EditorInterface>;
  externalProductId?: InputMaybe<Scalars['ID']['input']>;
  variantGroupOptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwagIntegrations_Query = {
  __typename?: 'SwagIntegrations_Query';
  corporateMerch: SwagIntegrationsEngine_CorporateMerch;
  product?: Maybe<SwagIntegrationsEngine_Product>;
  template?: Maybe<SwagIntegrationsEngine_Template>;
};


export type SwagIntegrations_QueryCorporateMerchArgs = {
  templateId: Scalars['ID']['input'];
};


export type SwagIntegrations_QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type SwagIntegrations_QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type SwagTemplatesPaginatedSeries = {
  __typename?: 'SwagTemplatesPaginatedSeries';
  items: Array<Product>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated return type of SwapCartUpdate. */
export type SwapCartUpdatePayload = {
  __typename?: 'SwapCartUpdatePayload';
  error?: Maybe<Array<Scalars['String']['output']>>;
  ok: Scalars['Boolean']['output'];
};

export type SwapStoreSettings = {
  __typename?: 'SwapStoreSettings';
  priceType?: Maybe<Flex_Gift_Product_Price_Type>;
  showCategories?: Maybe<Scalars['Boolean']['output']>;
};

export type Theme = {
  __typename?: 'Theme';
  colorInputs?: Maybe<ColorInputs>;
  finalColors?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  themeLogo?: Maybe<ThemeLogo>;
  themeLogoAlternate?: Maybe<ThemeLogo>;
};

export type ThemeInput = {
  colorInputs?: InputMaybe<ColorInputsInput>;
  finalColors?: InputMaybe<Scalars['JSON']['input']>;
  themeLogoAlternateId?: InputMaybe<Scalars['String']['input']>;
  themeLogoId?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeLogo = {
  __typename?: 'ThemeLogo';
  id: Scalars['ID']['output'];
  logo: Image;
};

/** Autogenerated return type of ThemeLogoUpload. */
export type ThemeLogoUploadPayload = {
  __typename?: 'ThemeLogoUploadPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  themeLogo?: Maybe<ThemeLogo>;
};

/** Autogenerated return type of ThreadCreate. */
export type ThreadCreatePayload = {
  __typename?: 'ThreadCreatePayload';
  aiChatThread?: Maybe<AiChatThread>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ThreadDelete. */
export type ThreadDeletePayload = {
  __typename?: 'ThreadDeletePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of ThreadUpdate. */
export type ThreadUpdatePayload = {
  __typename?: 'ThreadUpdatePayload';
  aiChatThread?: Maybe<AiChatThread>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Total price estimate for gift or gift batch send */
export type TotalPriceEstimate = {
  __typename?: 'TotalPriceEstimate';
  creditApplied: Scalars['Int']['output'];
  creditAvailable: Scalars['Int']['output'];
  creditAvailableToApply?: Maybe<Scalars['Int']['output']>;
  estGroupTotalHigh: Scalars['Int']['output'];
  estGroupTotalLow: Scalars['Int']['output'];
  estPreCreditSubtotalHigh: Scalars['Int']['output'];
  estPreCreditSubtotalLow: Scalars['Int']['output'];
  estTaxCalculated?: Maybe<Scalars['Int']['output']>;
  promoCodeError?: Maybe<Scalars['String']['output']>;
  recipients: Scalars['Int']['output'];
  taxText: Scalars['String']['output'];
};

/** Total price estimate for gift or gift batch send */
export type TotalPriceEstimateInput = {
  creditApplied: Scalars['Int']['input'];
  creditAvailable?: InputMaybe<Scalars['Int']['input']>;
  creditAvailableToApply?: InputMaybe<Scalars['Int']['input']>;
  estGroupTotalHigh: Scalars['Int']['input'];
  estGroupTotalLow: Scalars['Int']['input'];
  estPreCreditSubtotalHigh: Scalars['Int']['input'];
  estPreCreditSubtotalLow: Scalars['Int']['input'];
  estTaxCalculated?: InputMaybe<Scalars['Int']['input']>;
  promoCodeError?: InputMaybe<Scalars['String']['input']>;
  recipients: Scalars['Int']['input'];
  taxText?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TrackProductView. */
export type TrackProductViewPayload = {
  __typename?: 'TrackProductViewPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateBalanceAccess. */
export type UpdateBalanceAccessPayload = {
  __typename?: 'UpdateBalanceAccessPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

/** Autogenerated return type of UpdateIdentityProvider. */
export type UpdateIdentityProviderPayload = {
  __typename?: 'UpdateIdentityProviderPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  samlIdentityProvider?: Maybe<IdentityProvider>;
};

/** Autogenerated return type of UpdateIntegration. */
export type UpdateIntegrationPayload = {
  __typename?: 'UpdateIntegrationPayload';
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateMembership. */
export type UpdateMembershipPayload = {
  __typename?: 'UpdateMembershipPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  workspaceMembership?: Maybe<WorkspaceMembership>;
};

/** Autogenerated return type of Update. */
export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateSettings. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateSwagMaker. */
export type UpdateSwagMakerPayload = {
  __typename?: 'UpdateSwagMakerPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  swagMaker: SwagIntegrationsSwagMaker;
};

/** Autogenerated return type of UpdateWorkspace. */
export type UpdateWorkspacePayload = {
  __typename?: 'UpdateWorkspacePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated return type of UserDismissedScreenCreate. */
export type UserDismissedScreenCreatePayload = {
  __typename?: 'UserDismissedScreenCreatePayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of UserEdit. */
export type UserEditPayload = {
  __typename?: 'UserEditPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Data needed to update user */
export type UserFieldsInput = {
  allowGiftsViaUsername?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyTitle?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  logoFile?: InputMaybe<Scalars['Upload']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserLastSendAudienceUpdate. */
export type UserLastSendAudienceUpdatePayload = {
  __typename?: 'UserLastSendAudienceUpdatePayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of UserLastUsedWorkspaceUpdate. */
export type UserLastUsedWorkspaceUpdatePayload = {
  __typename?: 'UserLastUsedWorkspaceUpdatePayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSubscription = CommonSubscription & {
  __typename?: 'UserSubscription';
  /** @deprecated Seats fields have been deprecated */
  additionalSeatMonthlyCostCents?: Maybe<Scalars['Int']['output']>;
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  isCancelRegistered?: Maybe<Scalars['Boolean']['output']>;
  isEe: Scalars['Boolean']['output'];
  isTeamPlan: Scalars['Boolean']['output'];
  isTrialActive?: Maybe<Scalars['Boolean']['output']>;
  managementType?: Maybe<SubscriptionManagement>;
  planName: Scalars['String']['output'];
  planSku: SubscriptionPlanSku;
  trialCardStatus?: Maybe<SubscriptionTrialCardStatus>;
  trialEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of UserUpdatePostSignupData. */
export type UserUpdatePostSignupDataPayload = {
  __typename?: 'UserUpdatePostSignupDataPayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of UserUsernameUpgrade. */
export type UserUsernameUpgradePayload = {
  __typename?: 'UserUsernameUpgradePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UsernameSearch. */
export type UsernameSearchPayload = {
  __typename?: 'UsernameSearchPayload';
  error?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UsernameValidate. */
export type UsernameValidatePayload = {
  __typename?: 'UsernameValidatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UtmParams = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmKeyword?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type VariantGroupOption = {
  __typename?: 'VariantGroupOption';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  imageLarge?: Maybe<Image>;
  imageMedium?: Maybe<Image>;
  imageThumb?: Maybe<Image>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageXlarge?: Maybe<Image>;
  name: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  swagIntegrationsId?: Maybe<Scalars['ID']['output']>;
};

export type VariantGroups = {
  __typename?: 'VariantGroups';
  name: Scalars['String']['output'];
  variantGroupOptions?: Maybe<Array<VariantGroupOption>>;
};

/** Autogenerated return type of VersionCheck. */
export type VersionCheckPayload = {
  __typename?: 'VersionCheckPayload';
  appStoreLink?: Maybe<Scalars['String']['output']>;
  majorUpdateAvailable: Scalars['Boolean']['output'];
  playStoreLink?: Maybe<Scalars['String']['output']>;
  showOtaUpdate?: Maybe<Scalars['Boolean']['output']>;
  updateRequired?: Maybe<Scalars['Boolean']['output']>;
};

/** Information about a user's app version */
export type VersionInfoInput = {
  expoSdkVersion?: InputMaybe<Scalars['String']['input']>;
  expoVersion?: InputMaybe<Scalars['String']['input']>;
  majorVersion: Scalars['Int']['input'];
  nativeAppVersion?: InputMaybe<Scalars['String']['input']>;
  nativeBuildVersion?: InputMaybe<Scalars['String']['input']>;
  releaseChannel?: InputMaybe<Scalars['String']['input']>;
  revisionId?: InputMaybe<Scalars['String']['input']>;
  updateId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WebhookApplicationCreate. */
export type WebhookApplicationCreatePayload = {
  __typename?: 'WebhookApplicationCreatePayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

/** Autogenerated return type of WebhookApplicationFetchDashboardUrl. */
export type WebhookApplicationFetchDashboardUrlPayload = {
  __typename?: 'WebhookApplicationFetchDashboardUrlPayload';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  balance?: Maybe<Scalars['Int']['output']>;
  balanceAccess: WorkspaceBalanceAccess;
  balanceAccessAvailable: Scalars['Boolean']['output'];
  balanceAccount?: Maybe<BalanceAccount>;
  budgetRule?: Maybe<BudgetRule>;
  canLeaveWorkspace: Scalars['Boolean']['output'];
  giftsCount?: Maybe<Scalars['Int']['output']>;
  giftsCountInLast30Days?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isEe: Scalars['Boolean']['output'];
  isTeamPlan: Scalars['Boolean']['output'];
  managerNames: Array<Scalars['String']['output']>;
  members: Array<WorkspaceMembership>;
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  pendingInvites: Array<WorkspaceInvite>;
  permissions: WorkspacePermissions;
  role?: Maybe<WorkspaceMembershipRole>;
  ttype: WorkspaceTtype;
};

export enum WorkspaceBalanceAccess {
  /** all_members */
  AllMembers = 'all_members',
  /** disabled */
  Disabled = 'disabled',
  /** managers */
  Managers = 'managers'
}

export type WorkspaceInvite = {
  __typename?: 'WorkspaceInvite';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  senderEmail: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  workspaceName: Scalars['String']['output'];
};

export type WorkspaceInviteCreateInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceInviteError = {
  __typename?: 'WorkspaceInviteError';
  email?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceInviteLimited = {
  __typename?: 'WorkspaceInviteLimited';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  organizationName: Scalars['String']['output'];
  requireSsoSetting: OrganizationRequireSsoSetting;
  samlEnabled: Scalars['Boolean']['output'];
  senderName: Scalars['String']['output'];
  workspaceName: Scalars['String']['output'];
};

export type WorkspaceMembership = {
  __typename?: 'WorkspaceMembership';
  companyTitle?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  giftCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invitedByUserEmail?: Maybe<Scalars['String']['output']>;
  invitedByUserFullName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Seats fields have been deprecated */
  organizationAccess: OrganizationMembershipAccess;
  organizationMembershipId: Scalars['ID']['output'];
  role: WorkspaceMembershipRole;
  status: Scalars['String']['output'];
  userPublicId: Scalars['ID']['output'];
};

export enum WorkspaceMembershipRole {
  /** Manager */
  Manager = 'MANAGER',
  /** Member */
  Member = 'MEMBER'
}

export type WorkspaceMembershipUpdateInput = {
  role?: InputMaybe<WorkspaceMembershipRole>;
};

export type WorkspacePermissions = {
  __typename?: 'WorkspacePermissions';
  inviteMembersPermission: InviteMembersPermission;
};

export type WorkspacePermissionsInput = {
  inviteMembersPermission?: InputMaybe<InviteMembersPermission>;
};

export enum WorkspaceTtype {
  /** individual */
  Individual = 'INDIVIDUAL',
  /** standard */
  Standard = 'STANDARD'
}

export type WorkspaceUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<WorkspacePermissionsInput>;
};

/** Flex Gift Product Price Type */
export enum Flex_Gift_Product_Price_Type {
  /** Fixed cost. */
  Fixed = 'FIXED',
  /** Tiers cost. */
  Tiers = 'TIERS',
  /** Variable cost. */
  Variable = 'VARIABLE'
}

/** Gift Meeting Setting Type */
export enum Gift_Meeting_Setting {
  /** Associated gifts/gift will allow the recipient to accept while asking them to schedule a meeting */
  GiftFirst = 'GIFT_FIRST',
  /** Associated gifts/gift will require a meeting before its accepted */
  MeetingRequired = 'MEETING_REQUIRED',
  /** Associated gifts/gift will not have a meeting */
  NoMeeting = 'NO_MEETING'
}

export type Wishlists_ProductsQueryVariables = Exact<{
  products: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Wishlists_ProductsQuery = { __typename?: 'Query', products?: Array<{ __typename?: 'ProductFragment', id: string, name: string, brandName: string, subtitle?: string | null, price?: number | null, shippingPrice?: number | null, associatedGiftOptionId?: string | null, primaryImage?: { __typename?: 'ProductImage', imageLarge: { __typename?: 'Image', url: string, width?: number | null, height?: number | null } } | null }> | null };


export const Wishlists_ProductsDocument = gql`
    query Wishlists_Products($products: [ID!]!) {
  products(productIdList: $products) {
    id
    name
    brandName
    subtitle
    price
    shippingPrice
    associatedGiftOptionId
    primaryImage {
      imageLarge {
        url
        width
        height
      }
    }
  }
}
    `;

export function useWishlists_ProductsQuery(options: Omit<Urql.UseQueryArgs<Wishlists_ProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<Wishlists_ProductsQuery, Wishlists_ProductsQueryVariables>({ query: Wishlists_ProductsDocument, ...options });
};